unit dashboard.maintenance;

interface

uses
  System.SysUtils, System.Classes, weblib.JSON, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, VCL.TMSFNCGridCell,
  VCL.TMSFNCGridOptions, XData.Web.Client, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCCustomGrid, VCL.TMSFNCGridDatabaseAdapter, VCL.TMSFNCCustomControl,
  VCL.TMSFNCCustomScrollControl, VCL.TMSFNCGridData, VCL.TMSFNCGrid,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls, Data.DB,
  WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.Buttons,
  System.Variants, WEBLib.DBCtrls, Vcl.Imaging.GIFImg, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer,
  VCL.TMSFNCDataGridDatabaseAdapter, VCL.TMSFNCDataGrid,
  VCL.TMSFNCBitmapContainer, WEBLib.ComCtrls;

type
  TfrmDashBoardMaintenance = class(TForm)
    pTop: TPanel;
    pBottom: TPanel;
    pMain: TPanel;
    wcYears: TXDataWebClient;
    wdsYears: TXDataWebDataSet;
    dsYears: TDataSource;
    wcMonths: TXDataWebClient;
    wdsMonths: TXDataWebDataSet;
    dsMonths: TDataSource;
    wdsMonthsMonth: TIntegerField;
    wdsMonthsMonthName: TStringField;
    wdsYearsSelected: TBooleanField;
    wdsMonthsSelected: TBooleanField;
    wdsYearsYear: TIntegerField;
    wcReg: TXDataWebClient;
    wdsReg: TXDataWebDataSet;
    dsReg: TDataSource;
    wdsRegReg: TStringField;
    wdsRegFleetNo: TStringField;
    wdsRegFleetType: TStringField;
    wdsRegSelected: TBooleanField;
    WebTimer1: TTimer;
    wdsRegPriKey: TIntegerField;
    wdsTempReg: TXDataWebDataSet;
    StringField1: TStringField;
    StringField2: TStringField;
    StringField3: TStringField;
    BooleanField1: TBooleanField;
    IntegerField1: TIntegerField;
    dsSysTypes: TDataSource;
    wcSysTypes: TXDataWebClient;
    wdsSysTypes: TXDataWebDataSet;
    wdsSysTypesSelected: TBooleanField;
    wdsCostGroups: TXDataWebDataSet;
    dsCostGroups: TDataSource;
    wcCostGroups: TXDataWebClient;
    wdsSysTypesSysType: TIntegerField;
    wdsSysTypesDescription: TStringField;
    wdsCostGroupsDescription: TStringField;
    wdsCostGroupsselected: TBooleanField;
    wdsDashData: TXDataWebDataSet;
    wcDashboardSums: TXDataWebClient;
    dsDashBoardSums: TDataSource;
    wcDashData: TXDataWebClient;
    dsDashData: TDataSource;
    wpDashSums: TPanel;
    wpTotalCost: TPanel;
    WebDBLabel1: TDBLabel;
    WebLabel6: TLabel;
    wpMaintenance: TPanel;
    WebLabel7: TLabel;
    WebDBLabel2: TDBLabel;
    wpTyres: TPanel;
    wpCost: TPanel;
    wpInsurance: TPanel;
    wpOperational: TPanel;
    WebDBLabel5: TDBLabel;
    WebDBLabel3: TDBLabel;
    WebDBLabel4: TDBLabel;
    WebDBLabel6: TDBLabel;
    WebLabel8: TLabel;
    WebLabel9: TLabel;
    WebLabel10: TLabel;
    WebLabel11: TLabel;
    wdsDashDataJobcardNo: TIntegerField;
    wdsDashDataStockDescription: TStringField;
    wdsDashDataTotalExcl: TStringField;
    wdsDashDataGlCode: TStringField;
    wdsDashDataReason: TStringField;
    wdsDashDataCategory: TStringField;
    wdsDashDataRepMain: TStringField;
    wdsDashDataCostDescription: TStringField;
    wdsDashDataTRegNo: TStringField;
    wdsDashDataTFleetNo: TStringField;
    wdsDashDataOrderNo: TStringField;
    wdsDashDataJobDate: TStringField;
    wdsDashDataReferenceNo: TStringField;
    wdsDashDataVehType: TStringField;
    wdsDashDataJobType: TStringField;
    wbSearch: TButton;
    wpCapex: TPanel;
    wpUnAll: TPanel;
    WebLabel13: TLabel;
    WebLabel14: TLabel;
    WebDBLabel7: TDBLabel;
    WebDBLabel8: TDBLabel;
    WebDBLabel9: TDBLabel;
    WebDBLabel10: TDBLabel;
    WebDBLabel11: TDBLabel;
    WebDBLabel12: TDBLabel;
    WebDBLabel14: TDBLabel;
    WebDBLabel15: TDBLabel;
    WebDBLabel16: TDBLabel;
    WebPanel1: TPanel;
    WebLabel12: TLabel;
    WebLabel15: TLabel;
    WebLabel16: TLabel;
    wdsCostGroupsCost: TIntegerField;
    wdsDashDataSupplier: TStringField;
    wbExcel: TButton;
    wpNoLink: TPanel;
    WebLabel17: TLabel;
    WebDBLabel17: TDBLabel;
    WebDBLabel18: TDBLabel;
    wdsSuppliers: TXDataWebDataSet;
    wcSuppliers: TXDataWebClient;
    dsSuppliers: TDataSource;
    wdsSuppliersCrName: TStringField;
    wdsSuppliersCrNumber: TStringField;
    wdsSuppliersSelected: TBooleanField;
    wdsVehGroups: TXDataWebDataSet;
    wcVehGroups: TXDataWebClient;
    dsVehGroups: TDataSource;
    wdsVehGroupsDescription: TStringField;
    wdsVehGroupsSelected: TBooleanField;
    WebPageControl1: TPageControl;
    WebPageControl1Sheet1: TTabSheet;
    WebPageControl1Sheet2: TTabSheet;
    WebPageControl1Sheet3: TTabSheet;
    pDashData: TPanel;
    dgDashData: TTMSFNCDataGrid;
    dgdaDashData: TTMSFNCDataGridDatabaseAdapter;
    BitmapContainer1: TTMSFNCBitmapContainer;
    WebPanel2: TPanel;
    WebPanel6: TPanel;
    WebLabel22: TLabel;
    WebDBLabel19: TDBLabel;
    wcUnitType: TXDataWebClient;
    dsUnitType: TDataSource;
    wdsUnitType: TXDataWebDataSet;
    wdsUnitTypeSysType: TIntegerField;
    wdsUnitTypeDescription: TStringField;
    wdsUnitTypeSelected: TBooleanField;
    dsMake: TDataSource;
    wdsMake: TXDataWebDataSet;
    wcMake: TXDataWebClient;
    dsMaintGroup: TDataSource;
    wdsMaintGroup: TXDataWebDataSet;
    wcMaintGroup: TXDataWebClient;
    wdsFinYears: TXDataWebDataSet;
    wcFinYears: TXDataWebClient;
    dsFinYears: TDataSource;
    wdsFinYearsSelected: TBooleanField;
    wdsFinYearsYear: TIntegerField;
    wdsMaintGroupSelected: TBooleanField;
    wdsMaintGroupSysType: TIntegerField;
    wdsMaintGroupDescription: TStringField;
    WebPanel4: TPanel;
    pMainTop: TPanel;
    pMainMonths: TPanel;
    WebLabel2: TLabel;
    pRegNo: TPanel;
    WebLabel3: TLabel;
    pFinYears: TPanel;
    WebLabel19: TLabel;
    pMainYears: TPanel;
    WebLabel1: TLabel;
    dgYears: TTMSFNCDataGrid;
    dgdaYears: TTMSFNCDataGridDatabaseAdapter;
    pMaintGroups: TPanel;
    WebLabel21: TLabel;
    pMaintTypes: TPanel;
    WebLabel4: TLabel;
    WebPanel3: TPanel;
    wpSuppliers: TPanel;
    WebLabel18: TLabel;
    wpVehGroups: TPanel;
    WebLabel20: TLabel;
    pCostGroups: TPanel;
    WebLabel5: TLabel;
    WebPanel5: TPanel;
    WebLabel23: TLabel;
    pEquipMake: TPanel;
    WebLabel24: TLabel;
    wdsVehGroupsSysType: TIntegerField;
    wdsMakeDescription: TStringField;
    wdsMakeSelected: TBooleanField;
    dsServiceTypes: TDataSource;
    wdsServiceTypes: TXDataWebDataSet;
    wcServiceTypes: TXDataWebClient;
    wdsServiceTypesSelected: TBooleanField;
    wdsServiceTypesSystype: TIntegerField;
    wdsServiceTypesDescription: TStringField;
    wdsDashboardSums: TXDataWebDataSet;
    wdsDashboardSumsMaintenanceCost: TFloatField;
    wdsDashboardSumsTyreCost: TFloatField;
    wdsDashboardSumsWashCost: TFloatField;
    wdsDashboardSumsInsuranceCost: TFloatField;
    wdsDashboardSumsOtherCost: TFloatField;
    wdsDashboardSumsTotalCost: TFloatField;
    wdsDashboardSumsCapexCost: TFloatField;
    wdsDashboardSumsUnallCost: TFloatField;
    wdsDashboardSumsNotLinkedCost: TFloatField;
    wdsDashboardSumsMaintenanceCPK: TFloatField;
    wdsDashboardSumsTyreCPK: TFloatField;
    wdsDashboardSumsWashCPK: TFloatField;
    wdsDashboardSumsInsuranceCPK: TFloatField;
    wdsDashboardSumsOtherCPK: TFloatField;
    wdsDashboardSumsTotalCPK: TFloatField;
    wdsDashboardSumsCapexCPK: TFloatField;
    wdsDashboardSumsUnallCPK: TFloatField;
    wdsDashboardSumsNotLinkedCPK: TFloatField;
    wdsDashboardSumsTotalkilo: TFloatField;
    WebDBLabel13: TDBLabel;
    WebPanel7: TPanel;
    WebPanel8: TPanel;
    WebPanel9: TPanel;
    WebPanel10: TPanel;
    WebSpeedButton6: TSpeedButton;
    dgMaintGroups: TTMSFNCDataGrid;
    dgdaMaintGroups: TTMSFNCDataGridDatabaseAdapter;
    WebPanel11: TPanel;
    WebPanel12: TPanel;
    WebPanel13: TPanel;
    dgFinYears: TTMSFNCDataGrid;
    dgdaFinYears: TTMSFNCDataGridDatabaseAdapter;
    WebSpeedButton4: TSpeedButton;
    WebPanel14: TPanel;
    WebPanel15: TPanel;
    WebPanel16: TPanel;
    WebPanel17: TPanel;
    TMSFNCDataGrid1: TTMSFNCDataGrid;
    TMSFNCDataGridDatabaseAdapter1: TTMSFNCDataGridDatabaseAdapter;
    btnYearsClear: TSpeedButton;
    WebPanel18: TPanel;
    WebPanel19: TPanel;
    dgMonths: TTMSFNCDataGrid;
    dgdaMonths: TTMSFNCDataGridDatabaseAdapter;
    btnMonthsClear: TSpeedButton;
    WebPanel20: TPanel;
    dgReg: TTMSFNCDataGrid;
    dgdaReg: TTMSFNCDataGridDatabaseAdapter;
    btnRegClear: TSpeedButton;
    WebPanel21: TPanel;
    WebPanel22: TPanel;
    WebPanel23: TPanel;
    WebPanel24: TPanel;
    WebPanel25: TPanel;
    WebPanel26: TPanel;
    WebPanel27: TPanel;
    dgSysTypes: TTMSFNCDataGrid;
    dgdaSysTypes: TTMSFNCDataGridDatabaseAdapter;
    WebPanel28: TPanel;
    WebPanel29: TPanel;
    WebPanel30: TPanel;
    WebSpeedButton1: TSpeedButton;
    WebPanel31: TPanel;
    dgCostGroups: TTMSFNCDataGrid;
    dgdaCostGroups: TTMSFNCDataGridDatabaseAdapter;
    WebSpeedButton2: TSpeedButton;
    WebPanel32: TPanel;
    WebPanel33: TPanel;
    WebPanel34: TPanel;
    WebPanel35: TPanel;
    WebPanel36: TPanel;
    WebPanel37: TPanel;
    WebPanel38: TPanel;
    dgSuppliers: TTMSFNCDataGrid;
    dgdaSuppliers: TTMSFNCDataGridDatabaseAdapter;
    WebSpeedButton3: TSpeedButton;
    WebPanel39: TPanel;
    WebPanel40: TPanel;
    WebPanel41: TPanel;
    WebPanel42: TPanel;
    WebPanel43: TPanel;
    WebPanel44: TPanel;
    WebPanel45: TPanel;
    WebPanel46: TPanel;
    WebPanel47: TPanel;
    WebPanel48: TPanel;
    WebPanel49: TPanel;
    WebPanel50: TPanel;
    dgVehGroup: TTMSFNCDataGrid;
    dgdaVehGroups: TTMSFNCDataGridDatabaseAdapter;
    WebSpeedButton5: TSpeedButton;
    dgUnitType: TTMSFNCDataGrid;
    dgdaUnitType: TTMSFNCDataGridDatabaseAdapter;
    TMSFNCDataGrid2: TTMSFNCDataGrid;
    TMSFNCDataGridDatabaseAdapter2: TTMSFNCDataGridDatabaseAdapter;
    WebSpeedButton7: TSpeedButton;
    dgMake: TTMSFNCDataGrid;
    dgdaMake: TTMSFNCDataGridDatabaseAdapter;
    WebSpeedButton8: TSpeedButton;
    procedure WebFormShow(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
    procedure btnRegClearClick(Sender: TObject);
    procedure wdsYearsAfterPost(DataSet: TDataSet);
    procedure wdsMonthsAfterPost(DataSet: TDataSet);
    procedure WebTimer1Timer(Sender: TObject);
    procedure wdsSysTypesAfterPost(DataSet: TDataSet);
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure WebSpeedButton2Click(Sender: TObject);
    procedure wdsCostGroupsAfterPost(DataSet: TDataSet);
    procedure wbSearchClick(Sender: TObject);
    procedure wdsDashboardSumsAfterOpen(DataSet: TDataSet);
    procedure wdsDashDataAfterOpen(DataSet: TDataSet);
    procedure gDashDataSortFormat(Sender: TObject; Col: Integer;
      var SortFormat: TTMSFNCGridSortFormat; var APrefix, ASuffix: string);
    procedure btnMonthsClearClick(Sender: TObject);
    procedure btnYearsClearClick(Sender: TObject);
    procedure wbExcelClick(Sender: TObject);
    procedure CallMaintReport(sFilename, sReport : String);
    procedure WebButton2Click(Sender: TObject);
    procedure dgYearsCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure dgMonthsCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure dgMonthsGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgYearsGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgRegCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure dgRegGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgSysTypesGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgCostGroupsCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure dgSysTypesCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure dgCostGroupsGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure wdsSuppliersAfterPost(DataSet: TDataSet);
    procedure WebSpeedButton5Click(Sender: TObject);
    procedure WebSpeedButton3Click(Sender: TObject);
    procedure dgSuppliersCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure dgSuppliersGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgVehGroupGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgVehGroupCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure dgMaintGroupsCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure dgMaintGroupsGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgUnitTypeCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure dgUnitTypeGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgFinYearsCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure dgFinYearsGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgMakeGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgMakeCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure WebSpeedButton4Click(Sender: TObject);
    procedure WebSpeedButton6Click(Sender: TObject);
    procedure WebSpeedButton7Click(Sender: TObject);
    procedure WebSpeedButton8Click(Sender: TObject);
  private
    { Private declarations }
    procedure DoRegInfo;
    procedure TriggerTimer;
    Function DashDatatoJSonstr : String;


  public
    { Public declarations }
    procedure DoLoadYears;
    procedure DoLoadFinYears;
    procedure DoLoadMonths;
    procedure DoLoadSystemTypes;
    procedure DoLoadCostGroups;
    Procedure DoLoadSuppliers;
    Procedure DoLoadVehGroups;
    Procedure DoLoadVehUnitTypes;
    Procedure DoLoadMaintGroups;
    Procedure DoLoadEquipMake;
    Procedure DoLoadServiceTypes;
    procedure DoLoadMainData;
    Procedure DoLoadMainDataDetails;

    //procedure downloadxlsx(Report : String; iParam : Integer; Param1, Param2, Param3, Param4, Param5, Param6, Param7, Param8, Param9, Param10 : JSValue);
    [Async]
    procedure downloadfile(Report, sFileName : String; Param : Array of JSValue); async;
  protected procedure LoadDFMValues; override; end;

  TTMSFNCGridDataBaseAdapterOpen = class(TTMSFNCGridDataBaseAdapter);

var
  frmDashBoardMaintenance: TfrmDashBoardMaintenance;

implementation

{$R *.dfm}

uses
  stfmssystem.connection,
  share.common,
  share.classes;

{ TfrmDashBoardMaintenance }

procedure TfrmDashBoardMaintenance.downloadfile(Report, sFileName : String; Param : Array of JSValue);
  var
    filesize,
    I, ArrayCount : Integer;
    AB : TJSArrayBuffer;
    AV : TJSUInt8Array;

    Client : TXDataWebClient;
    Response : TXDataClientResponse;
    FileData : WideString;

    DirectDownload : TDirectDownload;


    FileName : string;
begin
  filesize := -1;
  Client            := TXDataWebClient.Create(nil);
  Client.Connection := dmdata.dbConnect;

  // Get File
  try
    Response := await(Client.RawInvokeAsync(Report, Param));
  except
    on Error: Exception do
    begin
      Client.Free;
      console.log('ERROR: '+Error.Classname+' ('+Error.Message+')+ ');
      exit;
    end;
  end;

  DirectDownload := TDirectDownload.Create;
  DirectDownload := TDirectDownload(Response.Result);

  // Convert file
  try
    FileName := string(DirectDownload.Filename);
    asm FileData = window.atob(DirectDownload.Data); end;

    filesize := Length(FileData);
  except on E: Exception do
    begin
      console.log('ERROR: (Base64) File could not be decoded');
      raise Exception.Create('ERROR: (Base64) File could not be decoded');
    end;
  end;

  if (filesize <> -1) then
  begin
    console.log('Retrieved (Base64) File: '+IntToStr(length(FileData))+' bytes');
    console.log('Decoded (Base64) File: '+IntToStr(filesize)+' bytes');
  end;

  Client.Free;

  if (filesize <> -1) then
    begin
      AB := TJSArrayBuffer.new(filesize);
      AV := TJSUInt8Array.new(AB);
      for i := 0 to filesize - 1 do
        AV[i] := TJSString(FileData).charCodeAt(i);
      Application.DownloadBinaryFile(AV, sFilename);
    end
  else
    begin
      // what/how do you want to tell the user about a failure here
    end;
  DirectDownload.Free;
end;

procedure TfrmDashBoardMaintenance.btnRegClearClick(Sender: TObject);
begin
  wdsReg.DisableControls;
  wdsReg.First;
  Repeat
    If wdsReg.FieldByName('Selected').asBoolean then
      begin
        wdsReg.Edit;
        wdsReg.FieldByName('Selected').asBoolean := False;
        wdsReg.Post;
      end;
    wdsReg.Next;
  Until wdsReg.Eof;
  wdsReg.First;
  wdsReg.EnableControls;
end;

procedure TfrmDashBoardMaintenance.btnYearsClearClick(Sender: TObject);
begin
  wdsYears.DisableControls;
  wdsYears.First;
  Repeat
    If wdsYears.FieldByName('Selected').asBoolean then
      begin
        wdsYears.Edit;
        wdsYears.FieldByName('Selected').asBoolean := False;
        wdsYears.Post;
      end;
    wdsYears.Next;
  Until wdsYears.Eof;
  wdsYears.First;
  wdsYears.EnableControls;
end;

procedure TfrmDashBoardMaintenance.DoLoadMainData;
  procedure OnError(Error: TXDataClientError);
    begin
      DoLoadMainData;
    end;

  procedure OnResult(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        DoLoadMainData;
      end
    else
      begin

        wdsDashboardSums.Close;
        wdsDashboardSums.SetJsonData(Response.Result);
        wdsDashboardSums.Open;

      end;
    end;

begin
  wcDashboardSums.RawInvoke('IdashboardService.GetJobcardTypeTotals', [DashDatatoJSonstr], @OnResult,@OnError);


end;

procedure TfrmDashBoardMaintenance.DoLoadMainDataDetails;

   procedure OnError(Error: TXDataClientError);
    begin
      DoLoadMainDataDetails;
    end;

    procedure OnResult(Response : TXDataClientResponse);
     begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          DoLoadMainDataDetails;
        end
      else
        begin
          wdsDashData.Close;
          wdsDashData.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsDashData.Open;

        end;
     end;


begin

   wcDashData.RawInvoke('IdashboardService.GetJobcardDetails', [DashDatatoJSonstr], @OnResult, @OnError);

end;

procedure TfrmDashBoardMaintenance.DoLoadMonths;
  procedure OnError(Error: TXDataClientError);
    begin
      DoLoadMonths;
    end;
  procedure OnResultMonths(Response : TXDataClientResponse);
   begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        DoLoadMonths;
      end
    else
      begin
        wdsMonths.Close;
        wdsMonths.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsMonths.Open;
        //DoLoadMaintGroups;
        DoLoadSystemTypes;
      end;
   end;

begin
  wcMonths.RawInvoke('IdashboardService.GetMonths', [4], @OnResultMonths, @OnError);
end;

procedure TfrmDashBoardMaintenance.DoLoadYears;
  procedure OnError(Error: TXDataClientError);
  begin
    DoLoadYears;
  end;

  procedure OnResultYears(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        DoLoadYears;
      end
    else
      begin
        wdsYears.Close;
        wdsYears.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsYears.Open;
        DoLoadMonths;
      end;
  end;
begin
  wcYears.RawInvoke('IdashboardService.GetYears', [4], @OnResultYears, @OnError);

end;

//procedure DoLoadFinYears;
procedure TfrmDashBoardMaintenance.DoLoadFinYears;
  procedure OnError(Error: TXDataClientError);
  begin
    DoLoadFinYears;
  end;

  procedure OnResultFinYears(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        DoLoadFinYears;
      end
    else
      begin
        wdsFinYears.Close;
        wdsFinYears.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsFinYears.Open;
        DoLoadYears
      end;
  end;
begin
  wcYears.RawInvoke('IdashboardService.GetYears', [4], @OnResultFinYears, @OnError);

end;

procedure TfrmDashBoardMaintenance.DoLoadSystemTypes;
   procedure OnError(Error: TXDataClientError);
  begin
    DoLoadSystemTypes;
  end;

  procedure OnResultSysTypes(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        DoLoadSystemTypes;
      end
    else
      begin
        wdsSysTypes.Close;
        wdsSysTypes.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsSysTypes.Open;
        DoLoadCostGroups;
      end;
  end;

begin
  wcSysTypes.RawInvoke('IdashboardService.GetSysTypes', [], @OnResultSysTypes, @OnError);
end;

procedure TfrmDashBoardMaintenance.DoLoadCostGroups;
  procedure OnError(Error: TXDataClientError);
  begin
    DoLoadCostGroups;
  end;

  procedure OnResultSysTypes(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        DoLoadCostGroups;
      end
    else
      begin
        wdsCostGroups.Close;
        wdsCostGroups.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsCostGroups.Open;
        DoLoadSuppliers;
      end;

  end;
begin
  wcSysTypes.RawInvoke('IdashboardService.GetJobCostDesc', [], @OnResultSysTypes, @OnError);

end;

procedure TfrmDashBoardMaintenance.DoLoadSuppliers;
 procedure OnError(Error: TXDataClientError);
  begin
    DoLoadSuppliers;
  end;

  procedure OnResultSuppliers(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        DoLoadSuppliers;
      end
    else
      begin
        wdsSuppliers.Close;
        wdsSuppliers.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsSuppliers.Open;
        DoLoadVehGroups;
      end;

  end;
begin
  wcSuppliers.RawInvoke('IdashboardService.GetSuppliers', [], @OnResultSuppliers, @OnError);

end;

procedure TfrmDashBoardMaintenance.DoLoadVehUnitTypes;
 procedure OnError(Error: TXDataClientError);
  begin
    DoLoadVehUnitTypes;
  end;

  procedure OnResultUnitTypes(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        DoLoadVehUnitTypes;
      end
    else
      begin
        wdsUnitType.Close;
        wdsUnitType.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsUnitType.Open;
        DoLoadMaintGroups;
      end;
  end;
begin
  wcUnitType.RawInvoke('IdashboardService.GetUnitTypes', [], @OnResultUnitTypes, @OnError);

end;

procedure TfrmDashBoardMaintenance.DoLoadMaintGroups;
 procedure OnError(Error: TXDataClientError);
  begin
    DoLoadMaintGroups;
  end;

  procedure OnResultMaintGroups(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        DoLoadMaintGroups;
      end
    else
      begin
        wdsMaintGroup.Close;
        wdsMaintGroup.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsMaintGroup.Open;
        DoLoadEquipMake;
      end;
  end;
begin
  wcUnitType.RawInvoke('IdashboardService.GetMaintGroups', [], @OnResultMaintGroups, @OnError);

end;

//DoLoadEquipMake
procedure TfrmDashBoardMaintenance.DoLoadEquipMake;
 procedure OnError(Error: TXDataClientError);
  begin
    DoLoadEquipMake;
  end;

  procedure OnResultEquipMake(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        DoLoadEquipMake;
      end
    else
      begin
        wdsMake.Close;
        wdsMake.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsMake.Open;
        DoLoadServiceTypes
      end;
  end;
begin
  wcMake.RawInvoke('IdashboardService.GetEquipmentType', [], @OnResultEquipMake, @OnError);

end;

//DoLoadServiceTypes
Procedure TfrmDashBoardMaintenance.DoLoadServiceTypes;
 procedure OnError(Error: TXDataClientError);
  begin
    DoLoadServiceTypes;
  end;

  procedure OnResultServiceTypes(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        DoLoadServiceTypes;
      end
    else
      begin
        wdsServiceTypes.Close;
        wdsServiceTypes.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsServiceTypes.Open;
      end;
  end;
begin
  wcServiceTypes.RawInvoke('IdashboardService.GetEquipmentType', [], @OnResultServiceTypes, @OnError);

end;


procedure TfrmDashBoardMaintenance.DoLoadVehGroups;
 procedure OnError(Error: TXDataClientError);
  begin
    DoLoadVehGroups;
  end;

  procedure OnResultVehGroups(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        DoLoadVehGroups;
      end
    else
      begin
        wdsVehGroups.Close;
        wdsVehGroups.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsVehGroups.Open;
        DoLoadVehUnitTypes;
      end;

  end;
begin
  wcVehGroups.RawInvoke('IdashboardService.GetVehGroups', [], @OnResultVehGroups, @OnError);

end;



procedure TfrmDashBoardMaintenance.DoRegInfo;
  procedure OnResult(Response : TXDataClientResponse);
    var
      iLastKey : Integer;
      iCurrentKey : Integer;
  begin
    If not wdsReg.Active then
      begin
        wdsReg.Close;
        wdsReg.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsReg.Open;
      end
    else
      begin
        wdsTempReg.Close;
        wdsTempReg.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsTempReg.Open;

        iCurrentKey := wdsReg.FieldByName('PriKey').asInteger;
        wdsReg.DisableControls;
        wdsTempReg.First;
        iLastKey := -1;
        Repeat
          If not wdsReg.Locate('PriKey', wdsTempReg.FieldByName('PriKey').asInteger,[]) then
            begin
              If iLastKey > -1 then
                begin
                  wdsReg.Locate('PriKey', iLastKey, []);
                  wdsReg.Insert;
                  wdsReg.FieldByName('Reg').asString       := wdsTempReg.FieldByName('Reg').asString;
                  wdsReg.FieldByName('FleetNo').asString   := wdsTempReg.FieldByName('FleetNo').asString;
                  wdsReg.FieldByName('FleetType').asString := wdsTempReg.FieldByName('FleetType').asString;
                  wdsReg.FieldByName('Selected').asBoolean := wdsTempReg.FieldByName('Selected').asBoolean;
                  wdsReg.FieldByName('PriKey').asInteger   := wdsTempReg.FieldByName('PriKey').asInteger;
                  wdsReg.Post;
                end
              else
                begin
                  wdsReg.First;
                  wdsReg.Insert;
                  wdsReg.FieldByName('Reg').asString       := wdsTempReg.FieldByName('Reg').asString;
                  wdsReg.FieldByName('FleetNo').asString   := wdsTempReg.FieldByName('FleetNo').asString;
                  wdsReg.FieldByName('FleetType').asString := wdsTempReg.FieldByName('FleetType').asString;
                  wdsReg.FieldByName('Selected').asBoolean := wdsTempReg.FieldByName('Selected').asBoolean;
                  wdsReg.FieldByName('PriKey').asInteger   := wdsTempReg.FieldByName('PriKey').asInteger;
                  wdsReg.Post;
                end;
            end;
          iLastKey := wdsTempReg.FieldByName('PriKey').asInteger;
          wdsTempReg.Next;
        Until wdsTempReg.Eof;
        wdsReg.Locate('PriKey', iCurrentKey, []);
        wdsTempReg.Close;
        wdsReg.EnableControls;
      end;
  end;
begin
  wcReg.RawInvoke('IdashboardService.GetReg', [4,GetJsonArrayFromDataSet(wdsYears,true,'Selected'),GetJsonArrayFromDataSet(wdsMonths,true,'Selected')], @OnResult);
end;

procedure TfrmDashBoardMaintenance.gDashDataSortFormat(Sender: TObject;
  Col: Integer; var SortFormat: TTMSFNCGridSortFormat; var APrefix,
  ASuffix: string);
begin
 case Col of

    3 : SortFormat := ssNumeric;
    4 : SortFormat := ssNumeric;
    10 : SortFormat := ssNumeric;


  end;
end;

procedure TfrmDashBoardMaintenance.dgUnitTypeCellClick(Sender: TObject;
  AColumn, ARow: Integer);
var
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= dgUnitType.FixedRowCount - 1 then
    Exit;

  d := TTMSFNCGridDataBaseAdapterOpen(dgdaUnitType);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[2];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsUnitType.Edit;
                        d.FieldAtColumn[2].asBoolean := False;
                        wdsUnitType.Post;
                      end
                    else
                      begin
                        wdsUnitType.Edit;
                        d.FieldAtColumn[2].asBoolean := True;
                        wdsUnitType.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.dgUnitTypeGetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin
if ACell.IsBitmapCell and dgdaUnitType.IsValidDataCell(ACell.Coordinate) then
    begin
      if dgUnitType.Booleans[ACell.Column, ACell.Row] then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[2]
      else
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[3];
    end;
end;

procedure TfrmDashBoardMaintenance.TriggerTimer;
begin
  WebTimer1.Enabled := False;
  WebTimer1.Enabled := True;
end;

procedure TfrmDashBoardMaintenance.wdsCostGroupsAfterPost(DataSet: TDataSet);
begin
  TriggerTimer;
end;

procedure TfrmDashBoardMaintenance.wdsDashboardSumsAfterOpen(DataSet: TDataSet);
begin
  DoLoadMainDataDetails;
end;

procedure TfrmDashBoardMaintenance.wdsDashDataAfterOpen(DataSet: TDataSet);
begin
   //WebWaitMessage1.Hide;
end;

procedure TfrmDashBoardMaintenance.wdsMonthsAfterPost(DataSet: TDataSet);
begin
  TriggerTimer;
end;

procedure TfrmDashBoardMaintenance.wdsSuppliersAfterPost(DataSet: TDataSet);
begin
  TriggerTimer;
end;

procedure TfrmDashBoardMaintenance.wdsSysTypesAfterPost(DataSet: TDataSet);
begin
  TriggerTimer;
end;

procedure TfrmDashBoardMaintenance.wdsYearsAfterPost(DataSet: TDataSet);
begin
  TriggerTimer;
end;

procedure TfrmDashBoardMaintenance.wbExcelClick(Sender: TObject);
begin

  //WebWaitMessage1.Show;
  CallMaintReport('Maintdetail.xlsx', 'XLSX');

end;

procedure TfrmDashBoardMaintenance.wbSearchClick(Sender: TObject);
begin
  //WebWaitMessage1.Show;
  DoLoadMainData;

end;

procedure TfrmDashBoardMaintenance.WebButton2Click(Sender: TObject);
begin

  CallMaintReport('Maintdetail.xlsx', 'XLSX');

end;

procedure TfrmDashBoardMaintenance.WebFormResize(Sender: TObject);
begin
  pMainTop.Height := pMain.Height div 3;
end;

procedure TfrmDashBoardMaintenance.WebFormShow(Sender: TObject);
begin
  DoLoadFinYears;
end;

procedure TfrmDashBoardMaintenance.WebSpeedButton1Click(Sender: TObject);
begin
  wdssysTypes.DisableControls;
  wdssysTypes.First;
  Repeat
    If wdssysTypes.FieldByName('Selected').asBoolean then
      begin
        wdssysTypes.Edit;
        wdssysTypes.FieldByName('Selected').asBoolean := False;
        wdssysTypes.Post;
      end;
    wdssysTypes.Next;
  Until wdssysTypes.Eof;
  wdssysTypes.First;
  wdssysTypes.EnableControls;
end;

procedure TfrmDashBoardMaintenance.WebSpeedButton2Click(Sender: TObject);
begin
  wdsCostGroups.DisableControls;
  wdsCostGroups.First;
  Repeat
    If wdsCostGroups.FieldByName('Selected').asBoolean then
      begin
        wdsCostGroups.Edit;
        wdsCostGroups.FieldByName('Selected').asBoolean := False;
        wdsCostGroups.Post;
      end;
    wdsCostGroups.Next;
  Until wdsCostGroups.Eof;
  wdsCostGroups.First;
  wdsCostGroups.EnableControls;
end;

procedure TfrmDashBoardMaintenance.WebSpeedButton3Click(Sender: TObject);
begin
  wdsSuppliers.DisableControls;
  wdsSuppliers.First;
  Repeat
    If wdsSuppliers.FieldByName('Selected').asBoolean then
      begin
        wdsSuppliers.Edit;
        wdsSuppliers.FieldByName('Selected').asBoolean := False;
        wdsSuppliers.Post;
      end;
    wdsSuppliers.Next;
  Until wdsSuppliers.Eof;
  wdsSuppliers.First;
  wdsSuppliers.EnableControls;
end;

procedure TfrmDashBoardMaintenance.WebSpeedButton4Click(Sender: TObject);
begin
 wdsFinYears.DisableControls;
  wdsFinYears.First;
  Repeat
    If wdsFinYears.FieldByName('Selected').asBoolean then
      begin
        wdsFinYears.Edit;
        wdsFinYears.FieldByName('Selected').asBoolean := False;
        wdsFinYears.Post;
      end;
    wdsFinYears.Next;
  Until wdsFinYears.Eof;
  wdsFinYears.First;
  wdsFinYears.EnableControls;
end;

procedure TfrmDashBoardMaintenance.WebSpeedButton5Click(Sender: TObject);
begin
   wdsVehGroups.DisableControls;
  wdsVehGroups.First;
  Repeat
    If wdsVehGroups.FieldByName('Selected').asBoolean then
      begin
        wdsVehGroups.Edit;
        wdsVehGroups.FieldByName('Selected').asBoolean := False;
        wdsVehGroups.Post;
      end;
    wdsVehGroups.Next;
  Until wdsVehGroups.Eof;
  wdsVehGroups.First;
  wdsVehGroups.EnableControls;
end;

procedure TfrmDashBoardMaintenance.WebSpeedButton6Click(Sender: TObject);
begin
 wdsMaintGroup.DisableControls;
  wdsMaintGroup.First;
  Repeat
    If wdsMaintGroup.FieldByName('Selected').asBoolean then
      begin
        wdsMaintGroup.Edit;
        wdsMaintGroup.FieldByName('Selected').asBoolean := False;
        wdsMaintGroup.Post;
      end;
    wdsMaintGroup.Next;
  Until wdsMaintGroup.Eof;
  wdsMaintGroup.First;
  wdsMaintGroup.EnableControls;
end;

procedure TfrmDashBoardMaintenance.WebSpeedButton7Click(Sender: TObject);
begin
 wdsUnitType.DisableControls;
  wdsUnitType.First;
  Repeat
    If wdsUnitType.FieldByName('Selected').asBoolean then
      begin
        wdsUnitType.Edit;
        wdsUnitType.FieldByName('Selected').asBoolean := False;
        wdsUnitType.Post;
      end;
    wdsUnitType.Next;
  Until wdsUnitType.Eof;
  wdsUnitType.First;
  wdsUnitType.EnableControls;
end;

procedure TfrmDashBoardMaintenance.WebSpeedButton8Click(Sender: TObject);
begin
 wdsMake.DisableControls;
  wdsMake.First;
  Repeat
    If wdsMake.FieldByName('Selected').asBoolean then
      begin
        wdsMake.Edit;
        wdsMake.FieldByName('Selected').asBoolean := False;
        wdsMake.Post;
      end;
    wdsMake.Next;
  Until wdsMake.Eof;
  wdsMake.First;
  wdsMake.EnableControls;
end;

procedure TfrmDashBoardMaintenance.btnMonthsClearClick(Sender: TObject);
begin
  wdsMonths.DisableControls;
  wdsMonths.First;
  Repeat
    If wdsMonths.FieldByName('Selected').asBoolean then
      begin
        wdsMonths.Edit;
        wdsMonths.FieldByName('Selected').asBoolean := False;
        wdsMonths.Post;
      end;
    wdsMonths.Next;
  Until wdsMonths.Eof;
  wdsMonths.First;
  wdsMonths.EnableControls;
end;

procedure TfrmDashBoardMaintenance.WebTimer1Timer(Sender: TObject);
begin
  WebTimer1.Enabled := False;
  DoRegInfo;
end;

procedure TfrmDashBoardMaintenance.CallMaintReport( sFilename, sReport : string);
begin


    downloadfile('IdashboardService.GetRepMainDetails',
                 sFileName,
                 [DashDatatoJSonstr,
                  sReport]);

    //WebWaitMessage1.Hide;



end;

procedure TfrmDashBoardMaintenance.dgCostGroupsCellClick(Sender: TObject;
  AColumn, ARow: Integer);
var
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= dgCostGroups.FixedRowCount - 1 then
    Exit;

  d := TTMSFNCGridDataBaseAdapterOpen(dgdaCostGroups);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[2];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsCostGroups.Edit;
                        d.FieldAtColumn[2].asBoolean := False;
                        wdsCostGroups.Post;
                      end
                    else
                      begin
                        wdsCostGroups.Edit;
                        d.FieldAtColumn[2].asBoolean := True;
                        wdsCostGroups.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.dgCostGroupsGetCellProperties(
  Sender: TObject; ACell: TTMSFNCDataGridCell);
begin
 if ACell.IsBitmapCell and dgdaCostGroups.IsValidDataCell(ACell.Coordinate) then
    begin
      if dgCostGroups.Booleans[ACell.Column, ACell.Row] then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[2]
      else
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[3];
    end;
end;

procedure TfrmDashBoardMaintenance.dgFinYearsCellClick(Sender: TObject; AColumn,
  ARow: Integer);
var
    d: TTMSFNCGridDatabaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= dgFinYears.FixedRowcount - 1 then
    Exit;

  d := TTMSFNCGridDatabaseAdapterOpen(dgdaFinYears);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[1];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsFinYears.Edit;
                        d.FieldAtColumn[1].asBoolean := False;
                        wdsFinYears.Post;
                      end
                    else
                      begin
                        wdsFinYears.Edit;
                        d.FieldAtColumn[1].asBoolean := True;
                        wdsFinYears.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.dgFinYearsGetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin
    if ACell.IsBitmapCell and dgdaFinYears.IsValidDataCell(ACell.Coordinate) then
      begin
        if dgFinYears.Booleans[ACell.Column, ACell.Row] then
          ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[2]
        else
          ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[3];
      end;
end;

procedure TfrmDashBoardMaintenance.dgMaintGroupsCellClick(Sender: TObject;
  AColumn, ARow: Integer);
var
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= dgMaintGroups.FixedRowCount - 1 then
    Exit;

  d := TTMSFNCGridDataBaseAdapterOpen(dgdaMaintGroups);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[2];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsMaintGroup.Edit;
                        d.FieldAtColumn[2].asBoolean := False;
                        wdsMaintGroup.Post;
                      end
                    else
                      begin
                        wdsMaintGroup.Edit;
                        d.FieldAtColumn[2].asBoolean := True;
                        wdsMaintGroup.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.dgMaintGroupsGetCellProperties(
  Sender: TObject; ACell: TTMSFNCDataGridCell);
begin
 if ACell.IsBitmapCell and dgdaMaintGroups.IsValidDataCell(ACell.Coordinate) then
  begin
    if dgMAintGroups.Booleans[ACell.Column, ACell.Row] then
      ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[2]
    else
      ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[3];
  end;
end;

procedure TfrmDashBoardMaintenance.dgMakeCellClick(Sender: TObject; AColumn,
  ARow: Integer);
var
    d: TTMSFNCGridDatabaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= dgMake.FixedRowcount - 1 then
    Exit;

  d := TTMSFNCGridDatabaseAdapterOpen(dgdaMake);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[1];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsMake.Edit;
                        d.FieldAtColumn[1].asBoolean := False;
                        wdsMake.Post;
                      end
                    else
                      begin
                        wdsMake.Edit;
                        d.FieldAtColumn[1].asBoolean := True;
                        wdsMake.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.dgMakeGetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin
begin
    if ACell.IsBitmapCell and dgdaMake.IsValidDataCell(ACell.Coordinate) then
  begin
    if dgMake.Booleans[ACell.Column, ACell.Row] then
      ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[2]
    else
      ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[3];
  end;
end;
end;

procedure TfrmDashBoardMaintenance.dgMonthsCellClick(Sender: TObject; AColumn,
  ARow: Integer);
var
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= dgMonths.FixedRowcount - 1 then
    Exit;

  d := TTMSFNCGridDataBaseAdapterOpen(dgdaMonths);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[2];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsMonths.Edit;
                        d.FieldAtColumn[2].asBoolean := False;
                        wdsMonths.Post;
                      end
                    else
                      begin
                        wdsMonths.Edit;
                        d.FieldAtColumn[2].asBoolean := True;
                        wdsMonths.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.dgMonthsGetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin

  if ACell.IsBitmapCell and dgdaMonths.IsValidDataCell(ACell.Coordinate) then
    begin
      if dgMonths.Booleans[ACell.Column, ACell.Row] then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[2]
      else
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[3];
    end;

end;

procedure TfrmDashBoardMaintenance.dgRegCellClick(Sender: TObject; AColumn,
  ARow: Integer);
var
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= dgReg.FixedRowCount - 1 then
    Exit;

  d := TTMSFNCGridDataBaseAdapterOpen(dgdaReg);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[2];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsReg.Edit;
                        d.FieldAtColumn[2].asBoolean := False;
                        wdsReg.Post;
                      end
                    else
                      begin
                        wdsReg.Edit;
                        d.FieldAtColumn[2].asBoolean := True;
                        wdsReg.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.dgRegGetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin

 if ACell.IsBitmapCell and dgdaReg.IsValidDataCell(ACell.Coordinate) then
  begin
    if dgReg.Booleans[ACell.Column, ACell.Row] then
      ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[2]
    else
      ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[3];
  end;

end;

procedure TfrmDashBoardMaintenance.dgSuppliersCellClick(Sender: TObject;
  AColumn, ARow: Integer);
var
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= dgSuppliers.FixedRowCount - 1 then
    Exit;

  d := TTMSFNCGridDataBaseAdapterOpen(dgdaSuppliers);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[2];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsSuppliers.Edit;
                        d.FieldAtColumn[2].asBoolean := False;
                        wdsSuppliers.Post;
                      end
                    else
                      begin
                        wdsSuppliers.Edit;
                        d.FieldAtColumn[2].asBoolean := True;
                        wdsSuppliers.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.dgSuppliersGetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin
  if ACell.IsBitmapCell and dgdaSuppliers.IsValidDataCell(ACell.Coordinate) then
    begin
      if dgSuppliers.Booleans[ACell.Column, ACell.Row] then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[2]
      else
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[3];
    end;
end;

procedure TfrmDashBoardMaintenance.dgSysTypesCellClick(Sender: TObject; AColumn,
  ARow: Integer);
var
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= dgSysTypes.FixedRowCount - 1 then
    Exit;

  d := TTMSFNCGridDataBaseAdapterOpen(dgdaSysTypes);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[2];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsSysTypes.Edit;
                        d.FieldAtColumn[2].asBoolean := False;
                        wdsSysTypes.Post;
                      end
                    else
                      begin
                        wdsSysTypes.Edit;
                        d.FieldAtColumn[2].asBoolean := True;
                        wdsSysTypes.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.dgSysTypesGetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin
 if ACell.IsBitmapCell and dgdaSysTypes.IsValidDataCell(ACell.Coordinate) then
  begin
    if dgSysTypes.Booleans[ACell.Column, ACell.Row] then
      ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[2]
    else
      ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[3];
  end;
end;

procedure TfrmDashBoardMaintenance.dgVehGroupCellClick(Sender: TObject;
  AColumn, ARow: Integer);
var
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= dgVehGroup.FixedRowCount - 1 then
    Exit;

  d := TTMSFNCGridDataBaseAdapterOpen(dgdaVehGroups);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[2];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsVehGroups.Edit;
                        d.FieldAtColumn[2].asBoolean := False;
                        wdsVehGroups.Post;
                      end
                    else
                      begin
                        wdsVehGroups.Edit;
                        d.FieldAtColumn[2].asBoolean := True;
                        wdsVehGroups.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;
procedure TfrmDashBoardMaintenance.dgVehGroupGetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin
  if ACell.IsBitmapCell and dgdaVehGroups.IsValidDataCell(ACell.Coordinate) then
    begin
      if dgVehGroup.Booleans[ACell.Column, ACell.Row] then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[2]
      else
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[3];
    end;
end;

procedure TfrmDashBoardMaintenance.dgYearsCellClick(Sender: TObject;
  AColumn, ARow: Integer);
var
    d: TTMSFNCGridDatabaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= dgYears.FixedRowcount - 1 then
    Exit;

  d := TTMSFNCGridDatabaseAdapterOpen(dgdayears);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[1];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsYears.Edit;
                        d.FieldAtColumn[1].asBoolean := False;
                        wdsYears.Post;
                      end
                    else
                      begin
                        wdsYears.Edit;
                        d.FieldAtColumn[1].asBoolean := True;
                        wdsYears.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.dgYearsGetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin
    if ACell.IsBitmapCell and dgdaYears.IsValidDataCell(ACell.Coordinate) then
  begin
    if dgYears.Booleans[ACell.Column, ACell.Row] then
      ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[2]
    else
      ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[3];
  end;
end;



Function TfrmDashBoardMaintenance.DashDatatoJSonstr : String;
var
    RootObj, YearObj, MonthObj, RegObj, SysTypesObj, CostGroupsObj, SupplierObj, UnitTypeObj,
    VehGroupsObj, MaintGroupObj, EquipMakeObj, FinYearsObj, ServiceTypesObj : TJSONObject;
    YearsArr, MonthsArr, RegArr, SysTypesArr, CostGroupsArr, SupplierArr, UnitTypeArr,
    VehGroupsArr, MaintGroupArr,EquipMakeArr,FinYearsArr, ServiceTypesArr: TJSONArray;
    JsonStr: string;
begin
  // root {}
  RootObj := TJSONObject.Create;

  // "Years-1": []
  YearsArr := TJSONArray.Create;
  wdsYears.Filtered := False;
  wdsYears.Filter := 'selected = True';
  wdsYears.Filtered := True;
  wdsYears.First;
  Repeat
    If wdsYears.FieldByName('Selected').AsBoolean then
      begin
        YearsArr.AddElement(TJSONObject.Create.AddPair('Year', TJSONNumber.Create(wdsYears.FieldByName('Year').AsInteger)));
      end;
    wdsYears.Next;
  Until wdsYears.Eof;
  RootObj.AddPair('Years', YearsArr);

  // "Months-2": []
  MonthsArr := TJSONArray.Create;
  wdsMonths.Filtered := False;
  wdsMonths.Filter := 'selected = True';
  wdsMonths.Filtered := True;
  wdsMonths.First;
  Repeat
    If wdsMonths.FieldByName('Selected').AsBoolean then
      begin
        MonthsArr.AddElement(TJSONObject.Create.AddPair('Month', TJSONNumber.Create(wdsMonths.FieldByName('Month').AsInteger)));
      end;
    wdsMonths.Next;
  Until wdsMonths.Eof;
  RootObj.AddPair('Months', MonthsArr);


  // "Reg-3": []
  RegArr := TJSONArray.Create;
  wdsReg.Filtered := False;
  wdsReg.Filter := 'selected = True';
  wdsReg.Filtered := True;
  wdsReg.First;
  Repeat
    begin
     If wdsReg.FieldByName('Selected').AsBoolean then
      begin
       RegArr.AddElement(TJSONObject.Create.AddPair('Reg', TJSONNumber.Create(wdsReg.FieldByName('Reg').asString)));
      end;
     wdsReg.Next;
    end;
  until wdsReg.Eof;

  RootObj.AddPair('Reg', RegArr);

  // "SysTypes-4": []
  SysTypesArr := TJSONArray.Create;
  wdsSysTypes.Filtered := False;
  wdsSysTypes.Filter := 'selected = True';
  wdsSysTypes.Filtered := True;
  wdsSysTypes.First;
  Repeat
    If wdsSysTypes.FieldByName('Selected').AsBoolean then
      begin
        SysTypesArr.AddElement(TJSONObject.Create.AddPair('SysTypes', TJSONNumber.Create(wdsSysTypes.FieldByName('SysType').AsInteger)));
      end;
    wdsSysTypes.Next;
  Until wdsSysTypes.Eof;
  RootObj.AddPair('SysTypes', SysTypesArr);

  // "CostGroups-5": []
  CostGroupsArr := TJSONArray.Create;
  wdsCostGroups.Filtered := False;
  wdsCostGroups.Filter := 'selected = True';
  wdsCostGroups.Filtered := True;
  wdsCostGroups.First;
  Repeat
    If wdsCostGroups.FieldByName('Selected').AsBoolean then
      begin
        CostGroupsArr.AddElement(TJSONObject.Create.AddPair('CostGroups', TJSONNumber.Create(wdsCostGroups.FieldByName('Cost').AsInteger)));
      end;
    wdsCostGroups.Next;
  Until wdsCostGroups.Eof;
  RootObj.AddPair('CostGroups', CostGroupsArr);

  // "Suppliers-6": []
  SupplierArr := TJSONArray.Create;
  wdsSuppliers.Filtered := False;
  wdsSuppliers.Filter := 'selected = True';
  wdsSuppliers.Filtered := True;
  wdsSuppliers.First;
  Repeat
    If wdsSuppliers.FieldByName('Selected').AsBoolean then
      begin
        SupplierArr.AddElement(TJSONObject.Create.AddPair('Suppliers', TJSONNumber.Create(wdsSuppliers.FieldByName('CrNumber').AsString)));
      end;
    wdsSuppliers.Next;
  Until wdsSuppliers.Eof;
  RootObj.AddPair('suppliers', SupplierArr);

  // "Veh Groups-7": []
  VehGroupsArr := TJSONArray.Create;
  wdsVehGroups.Filtered := False;
  wdsVehGroups.Filter := 'selected = True';
  wdsVehGroups.Filtered := True;
  wdsVehGroups.First;
  Repeat
    If wdsVehGroups.FieldByName('Selected').AsBoolean then
      begin
        VehGroupsArr.AddElement(TJSONObject.Create.AddPair('VehGroups', TJSONNumber.Create(wdsVehGroups.FieldByName('SysType').AsInteger)));
      end;
    wdsVehGroups.Next;
  Until wdsVehGroups.Eof;
  RootObj.AddPair('VehGroups', VehGroupsArr);

  // "UnitType-8": []
  UnitTypeArr := TJSONArray.Create;
  wdsUnitType.Filtered := False;
  wdsUnitType.Filter := 'selected = True';
  wdsUnitType.Filtered := True;
  wdsUnitType.First;
  Repeat
    If wdsUnitType.FieldByName('Selected').AsBoolean then
      begin
        UnitTypeArr.AddElement(TJSONObject.Create.AddPair('UnitType', TJSONNumber.Create(wdsUnitType.FieldByName('SysType').AsInteger)));
      end;
    wdsUnitType.Next;
  Until wdsUnitType.Eof;
  RootObj.AddPair('UnitType', UnitTypeArr);

  // "MaintGroups-9": []
  MaintGroupArr := TJSONArray.Create;
  wdsMaintGroup.Filtered := False;
  wdsMaintGroup.Filter := 'selected = True';
  wdsMaintGroup.Filtered := True;
  wdsMaintGroup.First;
  Repeat
    If wdsMaintGroup.FieldByName('Selected').AsBoolean then
      begin
        MaintGroupArr.AddElement(TJSONObject.Create.AddPair('MaintGroup', TJSONNumber.Create(wdsMaintGroup.FieldByName('SysType').AsInteger)));
      end;
    wdsMaintGroup.Next;
  Until wdsMaintGroup.Eof;
  RootObj.AddPair('MaintGroup', MaintGroupArr);

  // "EquipmentMAke-10": []
  EquipMakeArr := TJSONArray.Create;
  wdsMake.Filtered := False;
  wdsMake.Filter := 'selected = True';
  wdsMake.Filtered := True;
  wdsMake.First;
  Repeat
    If wdsMake.FieldByName('Selected').AsBoolean then
      begin
        EquipMakeArr.AddElement(TJSONObject.Create.AddPair('EquipMake', TJSONNumber.Create(wdsMake.FieldByName('Description').AsString)));
      end;
    wdsMake.Next;
  Until wdsMake.Eof;
  RootObj.AddPair('EquipMake', EquipMakeArr);

  // "FinYears-11": []
  FinYearsArr := TJSONArray.Create;
  wdsFinYears.Filtered := False;
  wdsFinYears.Filter := 'selected = True';
  wdsFinYears.Filtered := True;
  wdsFinYears.First;
  Repeat
    If wdsFinYears.FieldByName('Selected').AsBoolean then
      begin
        FinYearsArr.AddElement(TJSONObject.Create.AddPair('FinYear', TJSONNumber.Create(wdsFinYears.FieldByName('Year').AsInteger)));
      end;
    wdsFinYears.Next;
  Until wdsFinYears.Eof;
  RootObj.AddPair('FinYears', FinYearsArr);

   // "ServiceTypes-12": []
  ServiceTypesArr := TJSONArray.Create;
  wdsServiceTypes.Filtered := False;
  wdsServiceTypes.Filter := 'selected = True';
  wdsServiceTypes.Filtered := True;
  wdsServiceTypes.First;
  Repeat
    If wdsServiceTypes.FieldByName('Selected').AsBoolean then
      begin
        ServiceTypesArr.AddElement(TJSONObject.Create.AddPair('ServiceType', TJSONNumber.Create(wdsServiceTypes.FieldByName('SysType').AsInteger)));
      end;
    wdsServiceTypes.Next;
  Until wdsServiceTypes.Eof;
  RootObj.AddPair('ServiceType', ServiceTypesArr);
  JsonStr := RootObj.ToJSON;
  Result := JsonStr;

  RootObj.Free;
  wdsYears.Filtered := False;
  wdsMonths.Filtered := False;
  wdsReg.Filtered := False;
  wdsSysTypes.Filtered := False;
  wdsCostGroups.Filtered := False;
  wdsSuppliers.Filtered := False;
  wdsVehGroups.Filtered := False;
  wdsUnitType.Filtered := False;
  wdsMaintGroup.Filtered := False;
  YearsArr.Free;
  MonthsArr.Free;
  RegArr.Free;
  SysTypesArr.Free;
  CostGroupsArr.Free;
  SupplierArr.Free;
  UnitTypeArr.Free;
  VehGroupsArr.Free;
  MaintGroupArr.Free;
  EquipMakeArr.Free;

end;

procedure TfrmDashBoardMaintenance.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pTop := TPanel.Create(Self);
  pBottom := TPanel.Create(Self);
  pMain := TPanel.Create(Self);
  wpDashSums := TPanel.Create(Self);
  wpTotalCost := TPanel.Create(Self);
  WebDBLabel1 := TDBLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebDBLabel10 := TDBLabel.Create(Self);
  wpMaintenance := TPanel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebDBLabel2 := TDBLabel.Create(Self);
  WebDBLabel11 := TDBLabel.Create(Self);
  wpTyres := TPanel.Create(Self);
  WebDBLabel5 := TDBLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebDBLabel12 := TDBLabel.Create(Self);
  wpCost := TPanel.Create(Self);
  WebDBLabel3 := TDBLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebDBLabel9 := TDBLabel.Create(Self);
  wpInsurance := TPanel.Create(Self);
  WebDBLabel4 := TDBLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebDBLabel13 := TDBLabel.Create(Self);
  wpOperational := TPanel.Create(Self);
  WebDBLabel6 := TDBLabel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebDBLabel14 := TDBLabel.Create(Self);
  wbSearch := TButton.Create(Self);
  wpCapex := TPanel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebDBLabel7 := TDBLabel.Create(Self);
  WebDBLabel15 := TDBLabel.Create(Self);
  wpUnAll := TPanel.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebDBLabel8 := TDBLabel.Create(Self);
  WebDBLabel16 := TDBLabel.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  WebLabel15 := TLabel.Create(Self);
  WebLabel16 := TLabel.Create(Self);
  wbExcel := TButton.Create(Self);
  wpNoLink := TPanel.Create(Self);
  WebLabel17 := TLabel.Create(Self);
  WebDBLabel17 := TDBLabel.Create(Self);
  WebDBLabel18 := TDBLabel.Create(Self);
  WebPanel6 := TPanel.Create(Self);
  WebLabel22 := TLabel.Create(Self);
  WebDBLabel19 := TDBLabel.Create(Self);
  WebPageControl1 := TPageControl.Create(Self);
  WebPageControl1Sheet3 := TTabSheet.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  pMainTop := TPanel.Create(Self);
  pMainMonths := TPanel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebPanel19 := TPanel.Create(Self);
  dgMonths := TTMSFNCDataGrid.Create(Self);
  dgdaMonths := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  btnMonthsClear := TSpeedButton.Create(Self);
  WebPanel21 := TPanel.Create(Self);
  WebPanel22 := TPanel.Create(Self);
  WebPanel23 := TPanel.Create(Self);
  pRegNo := TPanel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebPanel20 := TPanel.Create(Self);
  dgReg := TTMSFNCDataGrid.Create(Self);
  dgdaReg := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  btnRegClear := TSpeedButton.Create(Self);
  WebPanel24 := TPanel.Create(Self);
  WebPanel25 := TPanel.Create(Self);
  WebPanel26 := TPanel.Create(Self);
  pFinYears := TPanel.Create(Self);
  WebLabel19 := TLabel.Create(Self);
  WebPanel11 := TPanel.Create(Self);
  WebPanel12 := TPanel.Create(Self);
  WebPanel13 := TPanel.Create(Self);
  dgFinYears := TTMSFNCDataGrid.Create(Self);
  dgdaFinYears := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  WebPanel14 := TPanel.Create(Self);
  pMainYears := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  dgYears := TTMSFNCDataGrid.Create(Self);
  dgdaYears := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  WebPanel15 := TPanel.Create(Self);
  WebPanel16 := TPanel.Create(Self);
  WebPanel17 := TPanel.Create(Self);
  TMSFNCDataGrid1 := TTMSFNCDataGrid.Create(Self);
  TMSFNCDataGridDatabaseAdapter1 := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  btnYearsClear := TSpeedButton.Create(Self);
  WebPanel18 := TPanel.Create(Self);
  pMaintGroups := TPanel.Create(Self);
  WebLabel21 := TLabel.Create(Self);
  WebPanel7 := TPanel.Create(Self);
  WebPanel8 := TPanel.Create(Self);
  WebPanel9 := TPanel.Create(Self);
  WebPanel10 := TPanel.Create(Self);
  WebSpeedButton6 := TSpeedButton.Create(Self);
  dgMaintGroups := TTMSFNCDataGrid.Create(Self);
  dgdaMaintGroups := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  pMaintTypes := TPanel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebPanel27 := TPanel.Create(Self);
  dgSysTypes := TTMSFNCDataGrid.Create(Self);
  dgdaSysTypes := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebPanel28 := TPanel.Create(Self);
  WebPanel29 := TPanel.Create(Self);
  WebPanel30 := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  wpSuppliers := TPanel.Create(Self);
  WebLabel18 := TLabel.Create(Self);
  WebPanel35 := TPanel.Create(Self);
  WebPanel36 := TPanel.Create(Self);
  WebPanel37 := TPanel.Create(Self);
  WebPanel38 := TPanel.Create(Self);
  dgSuppliers := TTMSFNCDataGrid.Create(Self);
  dgdaSuppliers := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  wpVehGroups := TPanel.Create(Self);
  WebLabel20 := TLabel.Create(Self);
  WebPanel45 := TPanel.Create(Self);
  WebPanel46 := TPanel.Create(Self);
  WebPanel47 := TPanel.Create(Self);
  WebPanel50 := TPanel.Create(Self);
  dgVehGroup := TTMSFNCDataGrid.Create(Self);
  dgdaVehGroups := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  pCostGroups := TPanel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebPanel31 := TPanel.Create(Self);
  dgCostGroups := TTMSFNCDataGrid.Create(Self);
  dgdaCostGroups := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebPanel32 := TPanel.Create(Self);
  WebPanel33 := TPanel.Create(Self);
  WebPanel34 := TPanel.Create(Self);
  WebPanel5 := TPanel.Create(Self);
  WebLabel23 := TLabel.Create(Self);
  WebPanel42 := TPanel.Create(Self);
  WebPanel43 := TPanel.Create(Self);
  WebPanel44 := TPanel.Create(Self);
  WebPanel49 := TPanel.Create(Self);
  dgUnitType := TTMSFNCDataGrid.Create(Self);
  dgdaUnitType := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  TMSFNCDataGrid2 := TTMSFNCDataGrid.Create(Self);
  TMSFNCDataGridDatabaseAdapter2 := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  WebSpeedButton7 := TSpeedButton.Create(Self);
  pEquipMake := TPanel.Create(Self);
  WebLabel24 := TLabel.Create(Self);
  WebPanel39 := TPanel.Create(Self);
  WebPanel40 := TPanel.Create(Self);
  WebPanel41 := TPanel.Create(Self);
  WebPanel48 := TPanel.Create(Self);
  dgMake := TTMSFNCDataGrid.Create(Self);
  dgdaMake := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  WebSpeedButton8 := TSpeedButton.Create(Self);
  WebPageControl1Sheet2 := TTabSheet.Create(Self);
  pDashData := TPanel.Create(Self);
  dgDashData := TTMSFNCDataGrid.Create(Self);
  dgdaDashData := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  BitmapContainer1 := TTMSFNCBitmapContainer.Create(Self);
  WebPageControl1Sheet1 := TTabSheet.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  wcYears := TXDataWebClient.Create(Self);
  wdsYears := TXDataWebDataSet.Create(Self);
  wdsYearsSelected := TBooleanField.Create(Self);
  wdsYearsYear := TIntegerField.Create(Self);
  dsYears := TDataSource.Create(Self);
  wcMonths := TXDataWebClient.Create(Self);
  wdsMonths := TXDataWebDataSet.Create(Self);
  wdsMonthsMonth := TIntegerField.Create(Self);
  wdsMonthsMonthName := TStringField.Create(Self);
  wdsMonthsSelected := TBooleanField.Create(Self);
  dsMonths := TDataSource.Create(Self);
  wcReg := TXDataWebClient.Create(Self);
  wdsReg := TXDataWebDataSet.Create(Self);
  wdsRegReg := TStringField.Create(Self);
  wdsRegFleetNo := TStringField.Create(Self);
  wdsRegFleetType := TStringField.Create(Self);
  wdsRegSelected := TBooleanField.Create(Self);
  wdsRegPriKey := TIntegerField.Create(Self);
  dsReg := TDataSource.Create(Self);
  WebTimer1 := TTimer.Create(Self);
  wdsTempReg := TXDataWebDataSet.Create(Self);
  StringField1 := TStringField.Create(Self);
  StringField2 := TStringField.Create(Self);
  StringField3 := TStringField.Create(Self);
  BooleanField1 := TBooleanField.Create(Self);
  IntegerField1 := TIntegerField.Create(Self);
  dsSysTypes := TDataSource.Create(Self);
  wcSysTypes := TXDataWebClient.Create(Self);
  wdsSysTypes := TXDataWebDataSet.Create(Self);
  wdsSysTypesSelected := TBooleanField.Create(Self);
  wdsSysTypesSysType := TIntegerField.Create(Self);
  wdsSysTypesDescription := TStringField.Create(Self);
  wdsCostGroups := TXDataWebDataSet.Create(Self);
  wdsCostGroupsselected := TBooleanField.Create(Self);
  wdsCostGroupsCost := TIntegerField.Create(Self);
  wdsCostGroupsDescription := TStringField.Create(Self);
  dsCostGroups := TDataSource.Create(Self);
  wcCostGroups := TXDataWebClient.Create(Self);
  wdsDashData := TXDataWebDataSet.Create(Self);
  wdsDashDataJobcardNo := TIntegerField.Create(Self);
  wdsDashDataStockDescription := TStringField.Create(Self);
  wdsDashDataTotalExcl := TStringField.Create(Self);
  wdsDashDataGlCode := TStringField.Create(Self);
  wdsDashDataReason := TStringField.Create(Self);
  wdsDashDataCategory := TStringField.Create(Self);
  wdsDashDataRepMain := TStringField.Create(Self);
  wdsDashDataCostDescription := TStringField.Create(Self);
  wdsDashDataTRegNo := TStringField.Create(Self);
  wdsDashDataTFleetNo := TStringField.Create(Self);
  wdsDashDataOrderNo := TStringField.Create(Self);
  wdsDashDataJobDate := TStringField.Create(Self);
  wdsDashDataReferenceNo := TStringField.Create(Self);
  wdsDashDataVehType := TStringField.Create(Self);
  wdsDashDataJobType := TStringField.Create(Self);
  wdsDashDataSupplier := TStringField.Create(Self);
  wcDashboardSums := TXDataWebClient.Create(Self);
  dsDashBoardSums := TDataSource.Create(Self);
  wcDashData := TXDataWebClient.Create(Self);
  dsDashData := TDataSource.Create(Self);
  wdsSuppliers := TXDataWebDataSet.Create(Self);
  wdsSuppliersCrName := TStringField.Create(Self);
  wdsSuppliersCrNumber := TStringField.Create(Self);
  wdsSuppliersSelected := TBooleanField.Create(Self);
  wcSuppliers := TXDataWebClient.Create(Self);
  dsSuppliers := TDataSource.Create(Self);
  wdsVehGroups := TXDataWebDataSet.Create(Self);
  wdsVehGroupsDescription := TStringField.Create(Self);
  wdsVehGroupsSelected := TBooleanField.Create(Self);
  wdsVehGroupsSysType := TIntegerField.Create(Self);
  wcVehGroups := TXDataWebClient.Create(Self);
  dsVehGroups := TDataSource.Create(Self);
  wcUnitType := TXDataWebClient.Create(Self);
  dsUnitType := TDataSource.Create(Self);
  wdsUnitType := TXDataWebDataSet.Create(Self);
  wdsUnitTypeSysType := TIntegerField.Create(Self);
  wdsUnitTypeDescription := TStringField.Create(Self);
  wdsUnitTypeSelected := TBooleanField.Create(Self);
  dsMake := TDataSource.Create(Self);
  wdsMake := TXDataWebDataSet.Create(Self);
  wdsMakeDescription := TStringField.Create(Self);
  wdsMakeSelected := TBooleanField.Create(Self);
  wcMake := TXDataWebClient.Create(Self);
  dsMaintGroup := TDataSource.Create(Self);
  wdsMaintGroup := TXDataWebDataSet.Create(Self);
  wdsMaintGroupSelected := TBooleanField.Create(Self);
  wdsMaintGroupSysType := TIntegerField.Create(Self);
  wdsMaintGroupDescription := TStringField.Create(Self);
  wcMaintGroup := TXDataWebClient.Create(Self);
  wdsFinYears := TXDataWebDataSet.Create(Self);
  wdsFinYearsSelected := TBooleanField.Create(Self);
  wdsFinYearsYear := TIntegerField.Create(Self);
  wcFinYears := TXDataWebClient.Create(Self);
  dsFinYears := TDataSource.Create(Self);
  dsServiceTypes := TDataSource.Create(Self);
  wdsServiceTypes := TXDataWebDataSet.Create(Self);
  wdsServiceTypesSelected := TBooleanField.Create(Self);
  wdsServiceTypesSystype := TIntegerField.Create(Self);
  wdsServiceTypesDescription := TStringField.Create(Self);
  wcServiceTypes := TXDataWebClient.Create(Self);
  wdsDashboardSums := TXDataWebDataSet.Create(Self);
  wdsDashboardSumsMaintenanceCost := TFloatField.Create(Self);
  wdsDashboardSumsTyreCost := TFloatField.Create(Self);
  wdsDashboardSumsWashCost := TFloatField.Create(Self);
  wdsDashboardSumsInsuranceCost := TFloatField.Create(Self);
  wdsDashboardSumsOtherCost := TFloatField.Create(Self);
  wdsDashboardSumsTotalCost := TFloatField.Create(Self);
  wdsDashboardSumsCapexCost := TFloatField.Create(Self);
  wdsDashboardSumsUnallCost := TFloatField.Create(Self);
  wdsDashboardSumsNotLinkedCost := TFloatField.Create(Self);
  wdsDashboardSumsMaintenanceCPK := TFloatField.Create(Self);
  wdsDashboardSumsTyreCPK := TFloatField.Create(Self);
  wdsDashboardSumsWashCPK := TFloatField.Create(Self);
  wdsDashboardSumsInsuranceCPK := TFloatField.Create(Self);
  wdsDashboardSumsOtherCPK := TFloatField.Create(Self);
  wdsDashboardSumsTotalCPK := TFloatField.Create(Self);
  wdsDashboardSumsCapexCPK := TFloatField.Create(Self);
  wdsDashboardSumsUnallCPK := TFloatField.Create(Self);
  wdsDashboardSumsNotLinkedCPK := TFloatField.Create(Self);
  wdsDashboardSumsTotalkilo := TFloatField.Create(Self);

  pTop.BeforeLoadDFMValues;
  pBottom.BeforeLoadDFMValues;
  pMain.BeforeLoadDFMValues;
  wpDashSums.BeforeLoadDFMValues;
  wpTotalCost.BeforeLoadDFMValues;
  WebDBLabel1.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebDBLabel10.BeforeLoadDFMValues;
  wpMaintenance.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebDBLabel2.BeforeLoadDFMValues;
  WebDBLabel11.BeforeLoadDFMValues;
  wpTyres.BeforeLoadDFMValues;
  WebDBLabel5.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebDBLabel12.BeforeLoadDFMValues;
  wpCost.BeforeLoadDFMValues;
  WebDBLabel3.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebDBLabel9.BeforeLoadDFMValues;
  wpInsurance.BeforeLoadDFMValues;
  WebDBLabel4.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebDBLabel13.BeforeLoadDFMValues;
  wpOperational.BeforeLoadDFMValues;
  WebDBLabel6.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebDBLabel14.BeforeLoadDFMValues;
  wbSearch.BeforeLoadDFMValues;
  wpCapex.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebDBLabel7.BeforeLoadDFMValues;
  WebDBLabel15.BeforeLoadDFMValues;
  wpUnAll.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebDBLabel8.BeforeLoadDFMValues;
  WebDBLabel16.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  wbExcel.BeforeLoadDFMValues;
  wpNoLink.BeforeLoadDFMValues;
  WebLabel17.BeforeLoadDFMValues;
  WebDBLabel17.BeforeLoadDFMValues;
  WebDBLabel18.BeforeLoadDFMValues;
  WebPanel6.BeforeLoadDFMValues;
  WebLabel22.BeforeLoadDFMValues;
  WebDBLabel19.BeforeLoadDFMValues;
  WebPageControl1.BeforeLoadDFMValues;
  WebPageControl1Sheet3.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  pMainTop.BeforeLoadDFMValues;
  pMainMonths.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebPanel19.BeforeLoadDFMValues;
  dgMonths.BeforeLoadDFMValues;
  dgdaMonths.BeforeLoadDFMValues;
  btnMonthsClear.BeforeLoadDFMValues;
  WebPanel21.BeforeLoadDFMValues;
  WebPanel22.BeforeLoadDFMValues;
  WebPanel23.BeforeLoadDFMValues;
  pRegNo.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebPanel20.BeforeLoadDFMValues;
  dgReg.BeforeLoadDFMValues;
  dgdaReg.BeforeLoadDFMValues;
  btnRegClear.BeforeLoadDFMValues;
  WebPanel24.BeforeLoadDFMValues;
  WebPanel25.BeforeLoadDFMValues;
  WebPanel26.BeforeLoadDFMValues;
  pFinYears.BeforeLoadDFMValues;
  WebLabel19.BeforeLoadDFMValues;
  WebPanel11.BeforeLoadDFMValues;
  WebPanel12.BeforeLoadDFMValues;
  WebPanel13.BeforeLoadDFMValues;
  dgFinYears.BeforeLoadDFMValues;
  dgdaFinYears.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  WebPanel14.BeforeLoadDFMValues;
  pMainYears.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  dgYears.BeforeLoadDFMValues;
  dgdaYears.BeforeLoadDFMValues;
  WebPanel15.BeforeLoadDFMValues;
  WebPanel16.BeforeLoadDFMValues;
  WebPanel17.BeforeLoadDFMValues;
  TMSFNCDataGrid1.BeforeLoadDFMValues;
  TMSFNCDataGridDatabaseAdapter1.BeforeLoadDFMValues;
  btnYearsClear.BeforeLoadDFMValues;
  WebPanel18.BeforeLoadDFMValues;
  pMaintGroups.BeforeLoadDFMValues;
  WebLabel21.BeforeLoadDFMValues;
  WebPanel7.BeforeLoadDFMValues;
  WebPanel8.BeforeLoadDFMValues;
  WebPanel9.BeforeLoadDFMValues;
  WebPanel10.BeforeLoadDFMValues;
  WebSpeedButton6.BeforeLoadDFMValues;
  dgMaintGroups.BeforeLoadDFMValues;
  dgdaMaintGroups.BeforeLoadDFMValues;
  pMaintTypes.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebPanel27.BeforeLoadDFMValues;
  dgSysTypes.BeforeLoadDFMValues;
  dgdaSysTypes.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebPanel28.BeforeLoadDFMValues;
  WebPanel29.BeforeLoadDFMValues;
  WebPanel30.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  wpSuppliers.BeforeLoadDFMValues;
  WebLabel18.BeforeLoadDFMValues;
  WebPanel35.BeforeLoadDFMValues;
  WebPanel36.BeforeLoadDFMValues;
  WebPanel37.BeforeLoadDFMValues;
  WebPanel38.BeforeLoadDFMValues;
  dgSuppliers.BeforeLoadDFMValues;
  dgdaSuppliers.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  wpVehGroups.BeforeLoadDFMValues;
  WebLabel20.BeforeLoadDFMValues;
  WebPanel45.BeforeLoadDFMValues;
  WebPanel46.BeforeLoadDFMValues;
  WebPanel47.BeforeLoadDFMValues;
  WebPanel50.BeforeLoadDFMValues;
  dgVehGroup.BeforeLoadDFMValues;
  dgdaVehGroups.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  pCostGroups.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebPanel31.BeforeLoadDFMValues;
  dgCostGroups.BeforeLoadDFMValues;
  dgdaCostGroups.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebPanel32.BeforeLoadDFMValues;
  WebPanel33.BeforeLoadDFMValues;
  WebPanel34.BeforeLoadDFMValues;
  WebPanel5.BeforeLoadDFMValues;
  WebLabel23.BeforeLoadDFMValues;
  WebPanel42.BeforeLoadDFMValues;
  WebPanel43.BeforeLoadDFMValues;
  WebPanel44.BeforeLoadDFMValues;
  WebPanel49.BeforeLoadDFMValues;
  dgUnitType.BeforeLoadDFMValues;
  dgdaUnitType.BeforeLoadDFMValues;
  TMSFNCDataGrid2.BeforeLoadDFMValues;
  TMSFNCDataGridDatabaseAdapter2.BeforeLoadDFMValues;
  WebSpeedButton7.BeforeLoadDFMValues;
  pEquipMake.BeforeLoadDFMValues;
  WebLabel24.BeforeLoadDFMValues;
  WebPanel39.BeforeLoadDFMValues;
  WebPanel40.BeforeLoadDFMValues;
  WebPanel41.BeforeLoadDFMValues;
  WebPanel48.BeforeLoadDFMValues;
  dgMake.BeforeLoadDFMValues;
  dgdaMake.BeforeLoadDFMValues;
  WebSpeedButton8.BeforeLoadDFMValues;
  WebPageControl1Sheet2.BeforeLoadDFMValues;
  pDashData.BeforeLoadDFMValues;
  dgDashData.BeforeLoadDFMValues;
  dgdaDashData.BeforeLoadDFMValues;
  BitmapContainer1.BeforeLoadDFMValues;
  WebPageControl1Sheet1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  wcYears.BeforeLoadDFMValues;
  wdsYears.BeforeLoadDFMValues;
  wdsYearsSelected.BeforeLoadDFMValues;
  wdsYearsYear.BeforeLoadDFMValues;
  dsYears.BeforeLoadDFMValues;
  wcMonths.BeforeLoadDFMValues;
  wdsMonths.BeforeLoadDFMValues;
  wdsMonthsMonth.BeforeLoadDFMValues;
  wdsMonthsMonthName.BeforeLoadDFMValues;
  wdsMonthsSelected.BeforeLoadDFMValues;
  dsMonths.BeforeLoadDFMValues;
  wcReg.BeforeLoadDFMValues;
  wdsReg.BeforeLoadDFMValues;
  wdsRegReg.BeforeLoadDFMValues;
  wdsRegFleetNo.BeforeLoadDFMValues;
  wdsRegFleetType.BeforeLoadDFMValues;
  wdsRegSelected.BeforeLoadDFMValues;
  wdsRegPriKey.BeforeLoadDFMValues;
  dsReg.BeforeLoadDFMValues;
  WebTimer1.BeforeLoadDFMValues;
  wdsTempReg.BeforeLoadDFMValues;
  StringField1.BeforeLoadDFMValues;
  StringField2.BeforeLoadDFMValues;
  StringField3.BeforeLoadDFMValues;
  BooleanField1.BeforeLoadDFMValues;
  IntegerField1.BeforeLoadDFMValues;
  dsSysTypes.BeforeLoadDFMValues;
  wcSysTypes.BeforeLoadDFMValues;
  wdsSysTypes.BeforeLoadDFMValues;
  wdsSysTypesSelected.BeforeLoadDFMValues;
  wdsSysTypesSysType.BeforeLoadDFMValues;
  wdsSysTypesDescription.BeforeLoadDFMValues;
  wdsCostGroups.BeforeLoadDFMValues;
  wdsCostGroupsselected.BeforeLoadDFMValues;
  wdsCostGroupsCost.BeforeLoadDFMValues;
  wdsCostGroupsDescription.BeforeLoadDFMValues;
  dsCostGroups.BeforeLoadDFMValues;
  wcCostGroups.BeforeLoadDFMValues;
  wdsDashData.BeforeLoadDFMValues;
  wdsDashDataJobcardNo.BeforeLoadDFMValues;
  wdsDashDataStockDescription.BeforeLoadDFMValues;
  wdsDashDataTotalExcl.BeforeLoadDFMValues;
  wdsDashDataGlCode.BeforeLoadDFMValues;
  wdsDashDataReason.BeforeLoadDFMValues;
  wdsDashDataCategory.BeforeLoadDFMValues;
  wdsDashDataRepMain.BeforeLoadDFMValues;
  wdsDashDataCostDescription.BeforeLoadDFMValues;
  wdsDashDataTRegNo.BeforeLoadDFMValues;
  wdsDashDataTFleetNo.BeforeLoadDFMValues;
  wdsDashDataOrderNo.BeforeLoadDFMValues;
  wdsDashDataJobDate.BeforeLoadDFMValues;
  wdsDashDataReferenceNo.BeforeLoadDFMValues;
  wdsDashDataVehType.BeforeLoadDFMValues;
  wdsDashDataJobType.BeforeLoadDFMValues;
  wdsDashDataSupplier.BeforeLoadDFMValues;
  wcDashboardSums.BeforeLoadDFMValues;
  dsDashBoardSums.BeforeLoadDFMValues;
  wcDashData.BeforeLoadDFMValues;
  dsDashData.BeforeLoadDFMValues;
  wdsSuppliers.BeforeLoadDFMValues;
  wdsSuppliersCrName.BeforeLoadDFMValues;
  wdsSuppliersCrNumber.BeforeLoadDFMValues;
  wdsSuppliersSelected.BeforeLoadDFMValues;
  wcSuppliers.BeforeLoadDFMValues;
  dsSuppliers.BeforeLoadDFMValues;
  wdsVehGroups.BeforeLoadDFMValues;
  wdsVehGroupsDescription.BeforeLoadDFMValues;
  wdsVehGroupsSelected.BeforeLoadDFMValues;
  wdsVehGroupsSysType.BeforeLoadDFMValues;
  wcVehGroups.BeforeLoadDFMValues;
  dsVehGroups.BeforeLoadDFMValues;
  wcUnitType.BeforeLoadDFMValues;
  dsUnitType.BeforeLoadDFMValues;
  wdsUnitType.BeforeLoadDFMValues;
  wdsUnitTypeSysType.BeforeLoadDFMValues;
  wdsUnitTypeDescription.BeforeLoadDFMValues;
  wdsUnitTypeSelected.BeforeLoadDFMValues;
  dsMake.BeforeLoadDFMValues;
  wdsMake.BeforeLoadDFMValues;
  wdsMakeDescription.BeforeLoadDFMValues;
  wdsMakeSelected.BeforeLoadDFMValues;
  wcMake.BeforeLoadDFMValues;
  dsMaintGroup.BeforeLoadDFMValues;
  wdsMaintGroup.BeforeLoadDFMValues;
  wdsMaintGroupSelected.BeforeLoadDFMValues;
  wdsMaintGroupSysType.BeforeLoadDFMValues;
  wdsMaintGroupDescription.BeforeLoadDFMValues;
  wcMaintGroup.BeforeLoadDFMValues;
  wdsFinYears.BeforeLoadDFMValues;
  wdsFinYearsSelected.BeforeLoadDFMValues;
  wdsFinYearsYear.BeforeLoadDFMValues;
  wcFinYears.BeforeLoadDFMValues;
  dsFinYears.BeforeLoadDFMValues;
  dsServiceTypes.BeforeLoadDFMValues;
  wdsServiceTypes.BeforeLoadDFMValues;
  wdsServiceTypesSelected.BeforeLoadDFMValues;
  wdsServiceTypesSystype.BeforeLoadDFMValues;
  wdsServiceTypesDescription.BeforeLoadDFMValues;
  wcServiceTypes.BeforeLoadDFMValues;
  wdsDashboardSums.BeforeLoadDFMValues;
  wdsDashboardSumsMaintenanceCost.BeforeLoadDFMValues;
  wdsDashboardSumsTyreCost.BeforeLoadDFMValues;
  wdsDashboardSumsWashCost.BeforeLoadDFMValues;
  wdsDashboardSumsInsuranceCost.BeforeLoadDFMValues;
  wdsDashboardSumsOtherCost.BeforeLoadDFMValues;
  wdsDashboardSumsTotalCost.BeforeLoadDFMValues;
  wdsDashboardSumsCapexCost.BeforeLoadDFMValues;
  wdsDashboardSumsUnallCost.BeforeLoadDFMValues;
  wdsDashboardSumsNotLinkedCost.BeforeLoadDFMValues;
  wdsDashboardSumsMaintenanceCPK.BeforeLoadDFMValues;
  wdsDashboardSumsTyreCPK.BeforeLoadDFMValues;
  wdsDashboardSumsWashCPK.BeforeLoadDFMValues;
  wdsDashboardSumsInsuranceCPK.BeforeLoadDFMValues;
  wdsDashboardSumsOtherCPK.BeforeLoadDFMValues;
  wdsDashboardSumsTotalCPK.BeforeLoadDFMValues;
  wdsDashboardSumsCapexCPK.BeforeLoadDFMValues;
  wdsDashboardSumsUnallCPK.BeforeLoadDFMValues;
  wdsDashboardSumsNotLinkedCPK.BeforeLoadDFMValues;
  wdsDashboardSumsTotalkilo.BeforeLoadDFMValues;
  try
    Name := 'frmDashBoardMaintenance';
    Left := 776;
    Width := 1782;
    Height := 578;
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    pTop.SetParentComponent(Self);
    pTop.Name := 'pTop';
    pTop.Left := 0;
    pTop.Top := 0;
    pTop.Width := 1782;
    pTop.Height := 41;
    pTop.Align := alTop;
    pTop.Caption := 'Maintenance Dashboard';
    pTop.Color := clSkyBlue;
    pTop.Font.Charset := DEFAULT_CHARSET;
    pTop.Font.Color := clWindowText;
    pTop.Font.Height := -12;
    pTop.Font.Name := 'Segoe UI';
    pTop.Font.Style := [fsBold];
    pTop.ParentFont := False;
    pTop.TabOrder := 0;
    pBottom.SetParentComponent(Self);
    pBottom.Name := 'pBottom';
    pBottom.Left := 0;
    pBottom.Top := 538;
    pBottom.Width := 1782;
    pBottom.Height := 40;
    pBottom.Align := alBottom;
    pBottom.ChildOrder := 1;
    pBottom.TabOrder := 1;
    pMain.SetParentComponent(Self);
    pMain.Name := 'pMain';
    pMain.Left := 0;
    pMain.Top := 41;
    pMain.Width := 1782;
    pMain.Height := 497;
    pMain.Align := alClient;
    pMain.ChildOrder := 2;
    pMain.TabOrder := 2;
    wpDashSums.SetParentComponent(pMain);
    wpDashSums.Name := 'wpDashSums';
    wpDashSums.Left := 0;
    wpDashSums.Top := 425;
    wpDashSums.Width := 1782;
    wpDashSums.Height := 72;
    wpDashSums.Align := alBottom;
    wpDashSums.ChildOrder := 2;
    wpDashSums.TabOrder := 0;
    wpTotalCost.SetParentComponent(wpDashSums);
    wpTotalCost.Name := 'wpTotalCost';
    wpTotalCost.Left := 57;
    wpTotalCost.Top := 0;
    wpTotalCost.Width := 150;
    wpTotalCost.Height := 72;
    wpTotalCost.Align := alLeft;
    wpTotalCost.BorderColor := clBlack;
    wpTotalCost.ChildOrder := 6;
    wpTotalCost.Color := clYellow;
    wpTotalCost.TabOrder := 0;
    WebDBLabel1.SetParentComponent(wpTotalCost);
    WebDBLabel1.Name := 'WebDBLabel1';
    WebDBLabel1.Left := 0;
    WebDBLabel1.Top := 23;
    WebDBLabel1.Width := 150;
    WebDBLabel1.Height := 23;
    WebDBLabel1.Align := alTop;
    WebDBLabel1.Alignment := taCenter;
    WebDBLabel1.Color := clYellow;
    WebDBLabel1.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel1.Font.Color := clWindowText;
    WebDBLabel1.Font.Height := -17;
    WebDBLabel1.Font.Name := 'Segoe UI';
    WebDBLabel1.Font.Style := [fsBold];
    WebDBLabel1.HeightPercent := 100.000000000000000000;
    WebDBLabel1.ParentFont := False;
    WebDBLabel1.Transparent := False;
    WebDBLabel1.WidthPercent := 100.000000000000000000;
    WebDBLabel1.DataField := 'TotalCost';
    WebDBLabel1.DataSource := dsDashBoardSums;
    WebLabel6.SetParentComponent(wpTotalCost);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 0;
    WebLabel6.Top := 0;
    WebLabel6.Width := 150;
    WebLabel6.Height := 23;
    WebLabel6.Align := alTop;
    WebLabel6.Alignment := taCenter;
    WebLabel6.Caption := 'Total';
    WebLabel6.Font.Charset := DEFAULT_CHARSET;
    WebLabel6.Font.Color := clWindowText;
    WebLabel6.Font.Height := -17;
    WebLabel6.Font.Name := 'Segoe UI';
    WebLabel6.Font.Style := [fsBold];
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.ParentFont := False;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebDBLabel10.SetParentComponent(wpTotalCost);
    WebDBLabel10.Name := 'WebDBLabel10';
    WebDBLabel10.Left := 0;
    WebDBLabel10.Top := 46;
    WebDBLabel10.Width := 150;
    WebDBLabel10.Height := 26;
    WebDBLabel10.Align := alClient;
    WebDBLabel10.Alignment := taCenter;
    WebDBLabel10.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel10.Font.Color := clWindowText;
    WebDBLabel10.Font.Height := -16;
    WebDBLabel10.Font.Name := 'Segoe UI';
    WebDBLabel10.Font.Style := [fsBold];
    WebDBLabel10.HeightPercent := 100.000000000000000000;
    WebDBLabel10.ParentFont := False;
    WebDBLabel10.WidthPercent := 100.000000000000000000;
    WebDBLabel10.DataField := 'TotalCPK';
    WebDBLabel10.DataSource := dsDashBoardSums;
    wpMaintenance.SetParentComponent(wpDashSums);
    wpMaintenance.Name := 'wpMaintenance';
    wpMaintenance.Left := 207;
    wpMaintenance.Top := 0;
    wpMaintenance.Width := 150;
    wpMaintenance.Height := 72;
    wpMaintenance.Align := alLeft;
    wpMaintenance.ChildOrder := 6;
    wpMaintenance.Color := clTomato;
    wpMaintenance.TabOrder := 1;
    WebLabel7.SetParentComponent(wpMaintenance);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 0;
    WebLabel7.Top := 0;
    WebLabel7.Width := 150;
    WebLabel7.Height := 23;
    WebLabel7.Align := alTop;
    WebLabel7.Alignment := taCenter;
    WebLabel7.Caption := 'Maintenance';
    WebLabel7.Font.Charset := DEFAULT_CHARSET;
    WebLabel7.Font.Color := clWindowText;
    WebLabel7.Font.Height := -17;
    WebLabel7.Font.Name := 'Segoe UI';
    WebLabel7.Font.Style := [fsBold];
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.ParentFont := False;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebDBLabel2.SetParentComponent(wpMaintenance);
    WebDBLabel2.Name := 'WebDBLabel2';
    WebDBLabel2.Left := 0;
    WebDBLabel2.Top := 23;
    WebDBLabel2.Width := 150;
    WebDBLabel2.Height := 23;
    WebDBLabel2.Align := alTop;
    WebDBLabel2.Alignment := taCenter;
    WebDBLabel2.Color := clTomato;
    WebDBLabel2.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel2.Font.Color := clWindowText;
    WebDBLabel2.Font.Height := -17;
    WebDBLabel2.Font.Name := 'Segoe UI';
    WebDBLabel2.Font.Style := [fsBold];
    WebDBLabel2.HeightPercent := 100.000000000000000000;
    WebDBLabel2.ParentFont := False;
    WebDBLabel2.Transparent := False;
    WebDBLabel2.WidthPercent := 100.000000000000000000;
    WebDBLabel2.DataField := 'MaintenanceCost';
    WebDBLabel2.DataSource := dsDashBoardSums;
    WebDBLabel11.SetParentComponent(wpMaintenance);
    WebDBLabel11.Name := 'WebDBLabel11';
    WebDBLabel11.Left := 0;
    WebDBLabel11.Top := 46;
    WebDBLabel11.Width := 150;
    WebDBLabel11.Height := 26;
    WebDBLabel11.Align := alClient;
    WebDBLabel11.Alignment := taCenter;
    WebDBLabel11.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel11.Font.Color := clWindowText;
    WebDBLabel11.Font.Height := -16;
    WebDBLabel11.Font.Name := 'Segoe UI';
    WebDBLabel11.Font.Style := [fsBold];
    WebDBLabel11.HeightPercent := 100.000000000000000000;
    WebDBLabel11.ParentFont := False;
    WebDBLabel11.WidthPercent := 100.000000000000000000;
    WebDBLabel11.DataField := 'MaintenanceCPK';
    WebDBLabel11.DataSource := dsDashBoardSums;
    wpTyres.SetParentComponent(wpDashSums);
    wpTyres.Name := 'wpTyres';
    wpTyres.Left := 357;
    wpTyres.Top := 0;
    wpTyres.Width := 150;
    wpTyres.Height := 72;
    wpTyres.Align := alLeft;
    wpTyres.BorderColor := clAqua;
    wpTyres.ChildOrder := 6;
    wpTyres.Color := clAqua;
    wpTyres.TabOrder := 2;
    WebDBLabel5.SetParentComponent(wpTyres);
    WebDBLabel5.Name := 'WebDBLabel5';
    WebDBLabel5.Left := 0;
    WebDBLabel5.Top := 23;
    WebDBLabel5.Width := 150;
    WebDBLabel5.Height := 23;
    WebDBLabel5.Align := alTop;
    WebDBLabel5.Alignment := taCenter;
    WebDBLabel5.Color := clAqua;
    WebDBLabel5.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel5.Font.Color := clWindowText;
    WebDBLabel5.Font.Height := -17;
    WebDBLabel5.Font.Name := 'Segoe UI';
    WebDBLabel5.Font.Style := [fsBold];
    WebDBLabel5.HeightPercent := 100.000000000000000000;
    WebDBLabel5.ParentFont := False;
    WebDBLabel5.Transparent := False;
    WebDBLabel5.WidthPercent := 100.000000000000000000;
    WebDBLabel5.DataField := 'TyreCost';
    WebDBLabel5.DataSource := dsDashBoardSums;
    WebLabel8.SetParentComponent(wpTyres);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 0;
    WebLabel8.Top := 0;
    WebLabel8.Width := 150;
    WebLabel8.Height := 23;
    WebLabel8.Align := alTop;
    WebLabel8.Alignment := taCenter;
    WebLabel8.Caption := 'Tyre';
    WebLabel8.Color := clAqua;
    WebLabel8.Font.Charset := DEFAULT_CHARSET;
    WebLabel8.Font.Color := clWindowText;
    WebLabel8.Font.Height := -17;
    WebLabel8.Font.Name := 'Segoe UI';
    WebLabel8.Font.Style := [fsBold];
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.ParentFont := False;
    WebLabel8.Transparent := False;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebDBLabel12.SetParentComponent(wpTyres);
    WebDBLabel12.Name := 'WebDBLabel12';
    WebDBLabel12.Left := 0;
    WebDBLabel12.Top := 46;
    WebDBLabel12.Width := 150;
    WebDBLabel12.Height := 26;
    WebDBLabel12.Align := alClient;
    WebDBLabel12.Alignment := taCenter;
    WebDBLabel12.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel12.Font.Color := clWindowText;
    WebDBLabel12.Font.Height := -16;
    WebDBLabel12.Font.Name := 'Segoe UI';
    WebDBLabel12.Font.Style := [fsBold];
    WebDBLabel12.HeightPercent := 100.000000000000000000;
    WebDBLabel12.ParentFont := False;
    WebDBLabel12.WidthPercent := 100.000000000000000000;
    WebDBLabel12.DataField := 'TyreCPK';
    WebDBLabel12.DataSource := dsDashBoardSums;
    wpCost.SetParentComponent(wpDashSums);
    wpCost.Name := 'wpCost';
    wpCost.Left := 507;
    wpCost.Top := 0;
    wpCost.Width := 150;
    wpCost.Height := 72;
    wpCost.Align := alLeft;
    wpCost.ChildOrder := 7;
    wpCost.Color := clFuchsia;
    wpCost.TabOrder := 3;
    WebDBLabel3.SetParentComponent(wpCost);
    WebDBLabel3.Name := 'WebDBLabel3';
    WebDBLabel3.Left := 0;
    WebDBLabel3.Top := 23;
    WebDBLabel3.Width := 150;
    WebDBLabel3.Height := 23;
    WebDBLabel3.Align := alTop;
    WebDBLabel3.Alignment := taCenter;
    WebDBLabel3.Color := clFuchsia;
    WebDBLabel3.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel3.Font.Color := clWindowText;
    WebDBLabel3.Font.Height := -17;
    WebDBLabel3.Font.Name := 'Segoe UI';
    WebDBLabel3.Font.Style := [fsBold];
    WebDBLabel3.HeightPercent := 100.000000000000000000;
    WebDBLabel3.ParentFont := False;
    WebDBLabel3.WidthPercent := 100.000000000000000000;
    WebDBLabel3.DataField := 'WashCost';
    WebDBLabel3.DataSource := dsDashBoardSums;
    WebLabel9.SetParentComponent(wpCost);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 0;
    WebLabel9.Top := 0;
    WebLabel9.Width := 150;
    WebLabel9.Height := 23;
    WebLabel9.Align := alTop;
    WebLabel9.Alignment := taCenter;
    WebLabel9.Caption := 'Wash';
    WebLabel9.Font.Charset := DEFAULT_CHARSET;
    WebLabel9.Font.Color := clWindowText;
    WebLabel9.Font.Height := -17;
    WebLabel9.Font.Name := 'Segoe UI';
    WebLabel9.Font.Style := [fsBold];
    WebLabel9.HeightPercent := 100.000000000000000000;
    WebLabel9.ParentFont := False;
    WebLabel9.WidthPercent := 100.000000000000000000;
    WebDBLabel9.SetParentComponent(wpCost);
    WebDBLabel9.Name := 'WebDBLabel9';
    WebDBLabel9.Left := 0;
    WebDBLabel9.Top := 46;
    WebDBLabel9.Width := 150;
    WebDBLabel9.Height := 26;
    WebDBLabel9.Align := alClient;
    WebDBLabel9.Alignment := taCenter;
    WebDBLabel9.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel9.Font.Color := clWindowText;
    WebDBLabel9.Font.Height := -16;
    WebDBLabel9.Font.Name := 'Segoe UI';
    WebDBLabel9.Font.Style := [fsBold];
    WebDBLabel9.HeightPercent := 100.000000000000000000;
    WebDBLabel9.ParentFont := False;
    WebDBLabel9.WidthPercent := 100.000000000000000000;
    WebDBLabel9.DataField := 'WashCPK';
    WebDBLabel9.DataSource := dsDashBoardSums;
    wpInsurance.SetParentComponent(wpDashSums);
    wpInsurance.Name := 'wpInsurance';
    wpInsurance.Left := 657;
    wpInsurance.Top := 0;
    wpInsurance.Width := 150;
    wpInsurance.Height := 72;
    wpInsurance.Align := alLeft;
    wpInsurance.ChildOrder := 8;
    wpInsurance.Color := clLime;
    wpInsurance.TabOrder := 4;
    WebDBLabel4.SetParentComponent(wpInsurance);
    WebDBLabel4.Name := 'WebDBLabel4';
    WebDBLabel4.Left := 0;
    WebDBLabel4.Top := 23;
    WebDBLabel4.Width := 150;
    WebDBLabel4.Height := 24;
    WebDBLabel4.Align := alTop;
    WebDBLabel4.Alignment := taCenter;
    WebDBLabel4.AutoSize := False;
    WebDBLabel4.Color := clLime;
    WebDBLabel4.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel4.Font.Color := clWindowText;
    WebDBLabel4.Font.Height := -17;
    WebDBLabel4.Font.Name := 'Segoe UI';
    WebDBLabel4.Font.Style := [fsBold];
    WebDBLabel4.HeightPercent := 100.000000000000000000;
    WebDBLabel4.ParentFont := False;
    WebDBLabel4.WidthPercent := 100.000000000000000000;
    WebDBLabel4.DataField := 'InsuranceCost';
    WebDBLabel4.DataSource := dsDashBoardSums;
    WebLabel10.SetParentComponent(wpInsurance);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 0;
    WebLabel10.Top := 0;
    WebLabel10.Width := 150;
    WebLabel10.Height := 23;
    WebLabel10.Align := alTop;
    WebLabel10.Alignment := taCenter;
    WebLabel10.Caption := 'Insurance';
    WebLabel10.Font.Charset := DEFAULT_CHARSET;
    WebLabel10.Font.Color := clWindowText;
    WebLabel10.Font.Height := -17;
    WebLabel10.Font.Name := 'Segoe UI';
    WebLabel10.Font.Style := [fsBold];
    WebLabel10.HeightPercent := 100.000000000000000000;
    WebLabel10.ParentFont := False;
    WebLabel10.WidthPercent := 100.000000000000000000;
    WebDBLabel13.SetParentComponent(wpInsurance);
    WebDBLabel13.Name := 'WebDBLabel13';
    WebDBLabel13.Left := 0;
    WebDBLabel13.Top := 47;
    WebDBLabel13.Width := 150;
    WebDBLabel13.Height := 25;
    WebDBLabel13.Align := alClient;
    WebDBLabel13.Alignment := taCenter;
    WebDBLabel13.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel13.Font.Color := clWindowText;
    WebDBLabel13.Font.Height := -16;
    WebDBLabel13.Font.Name := 'Segoe UI';
    WebDBLabel13.Font.Style := [fsBold];
    WebDBLabel13.HeightPercent := 100.000000000000000000;
    WebDBLabel13.ParentFont := False;
    WebDBLabel13.WidthPercent := 100.000000000000000000;
    WebDBLabel13.DataField := 'InsuranceCPK';
    WebDBLabel13.DataSource := dsDashBoardSums;
    wpOperational.SetParentComponent(wpDashSums);
    wpOperational.Name := 'wpOperational';
    wpOperational.Left := 807;
    wpOperational.Top := 0;
    wpOperational.Width := 150;
    wpOperational.Height := 72;
    wpOperational.Align := alLeft;
    wpOperational.ChildOrder := 9;
    wpOperational.Color := clTeal;
    wpOperational.TabOrder := 5;
    WebDBLabel6.SetParentComponent(wpOperational);
    WebDBLabel6.Name := 'WebDBLabel6';
    WebDBLabel6.Left := 0;
    WebDBLabel6.Top := 23;
    WebDBLabel6.Width := 150;
    WebDBLabel6.Height := 24;
    WebDBLabel6.Align := alTop;
    WebDBLabel6.Alignment := taCenter;
    WebDBLabel6.AutoSize := False;
    WebDBLabel6.Color := clTeal;
    WebDBLabel6.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel6.Font.Color := clWindowText;
    WebDBLabel6.Font.Height := -17;
    WebDBLabel6.Font.Name := 'Segoe UI';
    WebDBLabel6.Font.Style := [fsBold];
    WebDBLabel6.HeightPercent := 100.000000000000000000;
    WebDBLabel6.ParentFont := False;
    WebDBLabel6.WidthPercent := 100.000000000000000000;
    WebDBLabel6.DataField := 'OtherCost';
    WebDBLabel6.DataSource := dsDashBoardSums;
    WebLabel11.SetParentComponent(wpOperational);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 0;
    WebLabel11.Top := 0;
    WebLabel11.Width := 150;
    WebLabel11.Height := 23;
    WebLabel11.Align := alTop;
    WebLabel11.Alignment := taCenter;
    WebLabel11.Caption := 'Operational';
    WebLabel11.Font.Charset := DEFAULT_CHARSET;
    WebLabel11.Font.Color := clWindowText;
    WebLabel11.Font.Height := -17;
    WebLabel11.Font.Name := 'Segoe UI';
    WebLabel11.Font.Style := [fsBold];
    WebLabel11.HeightPercent := 100.000000000000000000;
    WebLabel11.ParentFont := False;
    WebLabel11.WidthPercent := 100.000000000000000000;
    WebDBLabel14.SetParentComponent(wpOperational);
    WebDBLabel14.Name := 'WebDBLabel14';
    WebDBLabel14.Left := 0;
    WebDBLabel14.Top := 47;
    WebDBLabel14.Width := 150;
    WebDBLabel14.Height := 25;
    WebDBLabel14.Align := alClient;
    WebDBLabel14.Alignment := taCenter;
    WebDBLabel14.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel14.Font.Color := clWindowText;
    WebDBLabel14.Font.Height := -16;
    WebDBLabel14.Font.Name := 'Segoe UI';
    WebDBLabel14.Font.Style := [fsBold];
    WebDBLabel14.HeightPercent := 100.000000000000000000;
    WebDBLabel14.ParentFont := False;
    WebDBLabel14.WidthPercent := 100.000000000000000000;
    WebDBLabel14.DataField := 'OtherCPK';
    WebDBLabel14.DataSource := dsDashBoardSums;
    wbSearch.SetParentComponent(wpDashSums);
    wbSearch.Name := 'wbSearch';
    wbSearch.Left := 1557;
    wbSearch.Top := 0;
    wbSearch.Width := 96;
    wbSearch.Height := 72;
    wbSearch.Align := alLeft;
    wbSearch.Caption := 'Search';
    wbSearch.ChildOrder := 5;
    wbSearch.HeightPercent := 100.000000000000000000;
    wbSearch.WidthPercent := 100.000000000000000000;
    SetEvent(wbSearch, Self, 'OnClick', 'wbSearchClick');
    wpCapex.SetParentComponent(wpDashSums);
    wpCapex.Name := 'wpCapex';
    wpCapex.Left := 957;
    wpCapex.Top := 0;
    wpCapex.Width := 150;
    wpCapex.Height := 72;
    wpCapex.Align := alLeft;
    wpCapex.ChildOrder := 7;
    wpCapex.Color := clGoldenrod;
    wpCapex.TabOrder := 7;
    WebLabel13.SetParentComponent(wpCapex);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 0;
    WebLabel13.Top := 0;
    WebLabel13.Width := 150;
    WebLabel13.Height := 23;
    WebLabel13.Align := alTop;
    WebLabel13.Alignment := taCenter;
    WebLabel13.Caption := 'Capex';
    WebLabel13.Font.Charset := DEFAULT_CHARSET;
    WebLabel13.Font.Color := clWindowText;
    WebLabel13.Font.Height := -17;
    WebLabel13.Font.Name := 'Segoe UI';
    WebLabel13.Font.Style := [fsBold];
    WebLabel13.HeightPercent := 100.000000000000000000;
    WebLabel13.ParentFont := False;
    WebLabel13.WidthPercent := 100.000000000000000000;
    WebDBLabel7.SetParentComponent(wpCapex);
    WebDBLabel7.Name := 'WebDBLabel7';
    WebDBLabel7.Left := 0;
    WebDBLabel7.Top := 23;
    WebDBLabel7.Width := 150;
    WebDBLabel7.Height := 24;
    WebDBLabel7.Align := alTop;
    WebDBLabel7.Alignment := taCenter;
    WebDBLabel7.AutoSize := False;
    WebDBLabel7.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel7.Font.Color := clWindowText;
    WebDBLabel7.Font.Height := -17;
    WebDBLabel7.Font.Name := 'Segoe UI';
    WebDBLabel7.Font.Style := [fsBold];
    WebDBLabel7.HeightPercent := 100.000000000000000000;
    WebDBLabel7.ParentFont := False;
    WebDBLabel7.WidthPercent := 100.000000000000000000;
    WebDBLabel7.DataField := 'CapexCost';
    WebDBLabel7.DataSource := dsDashBoardSums;
    WebDBLabel15.SetParentComponent(wpCapex);
    WebDBLabel15.Name := 'WebDBLabel15';
    WebDBLabel15.Left := 0;
    WebDBLabel15.Top := 47;
    WebDBLabel15.Width := 150;
    WebDBLabel15.Height := 25;
    WebDBLabel15.Align := alClient;
    WebDBLabel15.Alignment := taCenter;
    WebDBLabel15.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel15.Font.Color := clWindowText;
    WebDBLabel15.Font.Height := -16;
    WebDBLabel15.Font.Name := 'Segoe UI';
    WebDBLabel15.Font.Style := [fsBold];
    WebDBLabel15.HeightPercent := 100.000000000000000000;
    WebDBLabel15.ParentFont := False;
    WebDBLabel15.WidthPercent := 100.000000000000000000;
    WebDBLabel15.DataField := 'CapexCPK';
    WebDBLabel15.DataSource := dsDashBoardSums;
    wpUnAll.SetParentComponent(wpDashSums);
    wpUnAll.Name := 'wpUnAll';
    wpUnAll.Left := 1107;
    wpUnAll.Top := 0;
    wpUnAll.Width := 150;
    wpUnAll.Height := 72;
    wpUnAll.Align := alLeft;
    wpUnAll.ChildOrder := 8;
    wpUnAll.Color := clChocolate;
    wpUnAll.TabOrder := 8;
    WebLabel14.SetParentComponent(wpUnAll);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 0;
    WebLabel14.Top := 0;
    WebLabel14.Width := 150;
    WebLabel14.Height := 23;
    WebLabel14.Align := alTop;
    WebLabel14.Alignment := taCenter;
    WebLabel14.Caption := 'Unallocated';
    WebLabel14.Font.Charset := DEFAULT_CHARSET;
    WebLabel14.Font.Color := clWindowText;
    WebLabel14.Font.Height := -17;
    WebLabel14.Font.Name := 'Segoe UI';
    WebLabel14.Font.Style := [fsBold];
    WebLabel14.HeightPercent := 100.000000000000000000;
    WebLabel14.ParentFont := False;
    WebLabel14.WidthPercent := 100.000000000000000000;
    WebDBLabel8.SetParentComponent(wpUnAll);
    WebDBLabel8.Name := 'WebDBLabel8';
    WebDBLabel8.Left := 0;
    WebDBLabel8.Top := 23;
    WebDBLabel8.Width := 150;
    WebDBLabel8.Height := 24;
    WebDBLabel8.Align := alTop;
    WebDBLabel8.Alignment := taCenter;
    WebDBLabel8.AutoSize := False;
    WebDBLabel8.Color := clChartreuse;
    WebDBLabel8.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel8.Font.Color := clWindowText;
    WebDBLabel8.Font.Height := -17;
    WebDBLabel8.Font.Name := 'Segoe UI';
    WebDBLabel8.Font.Style := [fsBold];
    WebDBLabel8.HeightPercent := 100.000000000000000000;
    WebDBLabel8.ParentFont := False;
    WebDBLabel8.WidthPercent := 100.000000000000000000;
    WebDBLabel8.DataField := 'UnallCost';
    WebDBLabel8.DataSource := dsDashBoardSums;
    WebDBLabel16.SetParentComponent(wpUnAll);
    WebDBLabel16.Name := 'WebDBLabel16';
    WebDBLabel16.Left := 0;
    WebDBLabel16.Top := 47;
    WebDBLabel16.Width := 150;
    WebDBLabel16.Height := 21;
    WebDBLabel16.Align := alTop;
    WebDBLabel16.Alignment := taCenter;
    WebDBLabel16.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel16.Font.Color := clWindowText;
    WebDBLabel16.Font.Height := -16;
    WebDBLabel16.Font.Name := 'Segoe UI';
    WebDBLabel16.Font.Style := [fsBold];
    WebDBLabel16.HeightPercent := 100.000000000000000000;
    WebDBLabel16.ParentFont := False;
    WebDBLabel16.WidthPercent := 100.000000000000000000;
    WebDBLabel16.DataField := 'UnallCPK';
    WebDBLabel16.DataSource := dsDashBoardSums;
    WebPanel1.SetParentComponent(wpDashSums);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 57;
    WebPanel1.Height := 72;
    WebPanel1.Align := alLeft;
    WebPanel1.ChildOrder := 9;
    WebPanel1.TabOrder := 9;
    WebLabel12.SetParentComponent(WebPanel1);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 0;
    WebLabel12.Top := 0;
    WebLabel12.Width := 57;
    WebLabel12.Height := 15;
    WebLabel12.Align := alTop;
    WebLabel12.HeightPercent := 100.000000000000000000;
    WebLabel12.WidthPercent := 100.000000000000000000;
    WebLabel15.SetParentComponent(WebPanel1);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 0;
    WebLabel15.Top := 15;
    WebLabel15.Width := 57;
    WebLabel15.Height := 21;
    WebLabel15.Align := alTop;
    WebLabel15.Alignment := taRightJustify;
    WebLabel15.Caption := 'Cost : ';
    WebLabel15.Font.Charset := DEFAULT_CHARSET;
    WebLabel15.Font.Color := clWindowText;
    WebLabel15.Font.Height := -16;
    WebLabel15.Font.Name := 'Segoe UI';
    WebLabel15.Font.Style := [fsBold];
    WebLabel15.HeightPercent := 100.000000000000000000;
    WebLabel15.ParentFont := False;
    WebLabel15.WidthPercent := 100.000000000000000000;
    WebLabel16.SetParentComponent(WebPanel1);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 0;
    WebLabel16.Top := 36;
    WebLabel16.Width := 57;
    WebLabel16.Height := 21;
    WebLabel16.Align := alTop;
    WebLabel16.Alignment := taRightJustify;
    WebLabel16.Caption := 'CPK : ';
    WebLabel16.Font.Charset := DEFAULT_CHARSET;
    WebLabel16.Font.Color := clWindowText;
    WebLabel16.Font.Height := -16;
    WebLabel16.Font.Name := 'Segoe UI';
    WebLabel16.Font.Style := [fsBold];
    WebLabel16.HeightPercent := 100.000000000000000000;
    WebLabel16.ParentFont := False;
    WebLabel16.WidthPercent := 100.000000000000000000;
    wbExcel.SetParentComponent(wpDashSums);
    wbExcel.Name := 'wbExcel';
    wbExcel.Left := 1653;
    wbExcel.Top := 0;
    wbExcel.Width := 96;
    wbExcel.Height := 72;
    wbExcel.Align := alLeft;
    wbExcel.Caption := 'Excel Export';
    wbExcel.ChildOrder := 10;
    wbExcel.HeightPercent := 100.000000000000000000;
    wbExcel.WidthPercent := 100.000000000000000000;
    SetEvent(wbExcel, Self, 'OnClick', 'wbExcelClick');
    wpNoLink.SetParentComponent(wpDashSums);
    wpNoLink.Name := 'wpNoLink';
    wpNoLink.Left := 1257;
    wpNoLink.Top := 0;
    wpNoLink.Width := 150;
    wpNoLink.Height := 72;
    wpNoLink.Align := alLeft;
    wpNoLink.ChildOrder := 11;
    wpNoLink.TabOrder := 11;
    WebLabel17.SetParentComponent(wpNoLink);
    WebLabel17.Name := 'WebLabel17';
    WebLabel17.Left := 0;
    WebLabel17.Top := 0;
    WebLabel17.Width := 150;
    WebLabel17.Height := 23;
    WebLabel17.Align := alTop;
    WebLabel17.Alignment := taCenter;
    WebLabel17.Caption := 'Not linked';
    WebLabel17.Color := clCornflowerblue;
    WebLabel17.Font.Charset := DEFAULT_CHARSET;
    WebLabel17.Font.Color := clWindowText;
    WebLabel17.Font.Height := -17;
    WebLabel17.Font.Name := 'Segoe UI';
    WebLabel17.Font.Style := [fsBold];
    WebLabel17.HeightPercent := 100.000000000000000000;
    WebLabel17.ParentFont := False;
    WebLabel17.Transparent := False;
    WebLabel17.WidthPercent := 100.000000000000000000;
    WebDBLabel17.SetParentComponent(wpNoLink);
    WebDBLabel17.Name := 'WebDBLabel17';
    WebDBLabel17.Left := 0;
    WebDBLabel17.Top := 23;
    WebDBLabel17.Width := 150;
    WebDBLabel17.Height := 23;
    WebDBLabel17.Align := alTop;
    WebDBLabel17.Alignment := taCenter;
    WebDBLabel17.Color := clCornflowerblue;
    WebDBLabel17.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel17.Font.Color := clWindowText;
    WebDBLabel17.Font.Height := -17;
    WebDBLabel17.Font.Name := 'Segoe UI';
    WebDBLabel17.Font.Style := [fsBold];
    WebDBLabel17.HeightPercent := 100.000000000000000000;
    WebDBLabel17.ParentFont := False;
    WebDBLabel17.Transparent := False;
    WebDBLabel17.WidthPercent := 100.000000000000000000;
    WebDBLabel17.DataField := 'NotLinkedCost';
    WebDBLabel17.DataSource := dsDashBoardSums;
    WebDBLabel18.SetParentComponent(wpNoLink);
    WebDBLabel18.Name := 'WebDBLabel18';
    WebDBLabel18.Left := 0;
    WebDBLabel18.Top := 46;
    WebDBLabel18.Width := 150;
    WebDBLabel18.Height := 26;
    WebDBLabel18.Align := alClient;
    WebDBLabel18.Alignment := taCenter;
    WebDBLabel18.Color := clCornflowerblue;
    WebDBLabel18.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel18.Font.Color := clWindowText;
    WebDBLabel18.Font.Height := -16;
    WebDBLabel18.Font.Name := 'Segoe UI';
    WebDBLabel18.Font.Style := [fsBold];
    WebDBLabel18.HeightPercent := 100.000000000000000000;
    WebDBLabel18.ParentFont := False;
    WebDBLabel18.Transparent := False;
    WebDBLabel18.WidthPercent := 100.000000000000000000;
    WebDBLabel18.DataField := 'NotLinkedCPK';
    WebDBLabel18.DataSource := dsDashBoardSums;
    WebPanel6.SetParentComponent(wpDashSums);
    WebPanel6.Name := 'WebPanel6';
    WebPanel6.Left := 1407;
    WebPanel6.Top := 0;
    WebPanel6.Width := 150;
    WebPanel6.Height := 72;
    WebPanel6.Align := alLeft;
    WebPanel6.ChildOrder := 12;
    WebPanel6.TabOrder := 12;
    WebLabel22.SetParentComponent(WebPanel6);
    WebLabel22.Name := 'WebLabel22';
    WebLabel22.Left := 0;
    WebLabel22.Top := 0;
    WebLabel22.Width := 150;
    WebLabel22.Height := 23;
    WebLabel22.Align := alTop;
    WebLabel22.Alignment := taCenter;
    WebLabel22.Caption := 'Total km'#39's';
    WebLabel22.Color := clCrimson;
    WebLabel22.Font.Charset := DEFAULT_CHARSET;
    WebLabel22.Font.Color := clWindowText;
    WebLabel22.Font.Height := -17;
    WebLabel22.Font.Name := 'Segoe UI';
    WebLabel22.Font.Style := [fsBold];
    WebLabel22.HeightPercent := 100.000000000000000000;
    WebLabel22.ParentFont := False;
    WebLabel22.Transparent := False;
    WebLabel22.WidthPercent := 100.000000000000000000;
    WebDBLabel19.SetParentComponent(WebPanel6);
    WebDBLabel19.Name := 'WebDBLabel19';
    WebDBLabel19.Left := 0;
    WebDBLabel19.Top := 23;
    WebDBLabel19.Width := 150;
    WebDBLabel19.Height := 49;
    WebDBLabel19.Align := alClient;
    WebDBLabel19.Alignment := taCenter;
    WebDBLabel19.Color := clCrimson;
    WebDBLabel19.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel19.Font.Color := clWindowText;
    WebDBLabel19.Font.Height := -27;
    WebDBLabel19.Font.Name := 'Segoe UI';
    WebDBLabel19.Font.Style := [fsBold];
    WebDBLabel19.HeightPercent := 100.000000000000000000;
    WebDBLabel19.ParentFont := False;
    WebDBLabel19.Transparent := False;
    WebDBLabel19.WidthPercent := 100.000000000000000000;
    WebDBLabel19.DataField := 'Totalkilo';
    WebDBLabel19.DataSource := dsDashBoardSums;
    WebPageControl1.SetParentComponent(pMain);
    WebPageControl1.Name := 'WebPageControl1';
    WebPageControl1.Left := 0;
    WebPageControl1.Top := 0;
    WebPageControl1.Width := 1782;
    WebPageControl1.Height := 425;
    WebPageControl1.Align := alClient;
    WebPageControl1.ChildOrder := 3;
    WebPageControl1.TabIndex := 1;
    WebPageControl1.TabOrder := 1;
    WebPageControl1Sheet3.SetParentComponent(WebPageControl1);
    WebPageControl1Sheet3.Name := 'WebPageControl1Sheet3';
    WebPageControl1Sheet3.Left := 0;
    WebPageControl1Sheet3.Top := 20;
    WebPageControl1Sheet3.Width := 1782;
    WebPageControl1Sheet3.Height := 405;
    WebPageControl1Sheet3.Caption := 'Search';
    WebPageControl1Sheet3.ChildOrder := 2;
    WebPanel4.SetParentComponent(WebPageControl1Sheet3);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 0;
    WebPanel4.Top := 0;
    WebPanel4.Width := 1782;
    WebPanel4.Height := 405;
    WebPanel4.Align := alClient;
    WebPanel4.Caption := 'WebPanel4';
    WebPanel4.ChildOrder := 2;
    WebPanel4.TabOrder := 0;
    pMainTop.SetParentComponent(WebPanel4);
    pMainTop.Name := 'pMainTop';
    pMainTop.Left := 0;
    pMainTop.Top := 0;
    pMainTop.Width := 1782;
    pMainTop.Height := 209;
    pMainTop.HeightStyle := ssPercent;
    pMainTop.HeightPercent := 55.000000000000000000;
    pMainTop.Align := alTop;
    pMainTop.BorderColor := clBtnFace;
    pMainTop.BorderStyle := bsNone;
    pMainTop.ChildOrder := 1;
    pMainTop.TabOrder := 0;
    pMainMonths.SetParentComponent(pMainTop);
    pMainMonths.Name := 'pMainMonths';
    pMainMonths.Left := 560;
    pMainMonths.Top := 0;
    pMainMonths.Width := 280;
    pMainMonths.Height := 209;
    pMainMonths.Align := alLeft;
    pMainMonths.BorderColor := clGray;
    pMainMonths.BorderStyle := bsNone;
    pMainMonths.ChildOrder := 2;
    pMainMonths.Color := clGray;
    pMainMonths.TabOrder := 0;
    WebLabel2.SetParentComponent(pMainMonths);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 0;
    WebLabel2.Top := 0;
    WebLabel2.Width := 280;
    WebLabel2.Height := 15;
    WebLabel2.Align := alTop;
    WebLabel2.Alignment := taCenter;
    WebLabel2.Caption := 'Select Months';
    WebLabel2.Color := clGray;
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clWindowText;
    WebLabel2.Font.Height := -12;
    WebLabel2.Font.Name := 'Segoe UI';
    WebLabel2.Font.Style := [fsBold];
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.Transparent := False;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebPanel19.SetParentComponent(pMainMonths);
    WebPanel19.Name := 'WebPanel19';
    WebPanel19.Left := 15;
    WebPanel19.Top := 15;
    WebPanel19.Width := 250;
    WebPanel19.Height := 179;
    WebPanel19.Align := alClient;
    WebPanel19.BorderColor := clGray;
    WebPanel19.BorderStyle := bsNone;
    WebPanel19.Caption := 'WebPanel19';
    WebPanel19.ChildOrder := 3;
    WebPanel19.Color := clGray;
    WebPanel19.TabOrder := 0;
    dgMonths.SetParentComponent(WebPanel19);
    dgMonths.Name := 'dgMonths';
    dgMonths.Left := 0;
    dgMonths.Top := 0;
    dgMonths.Width := 250;
    dgMonths.Height := 155;
    dgMonths.Align := alClient;
    dgMonths.ParentDoubleBuffered := False;
    dgMonths.DoubleBuffered := True;
    dgMonths.TabOrder := 0;
    dgMonths.ShowAcceleratorChar := False;
    dgMonths.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgMonths.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgMonths.Header.VisualGrouping.Layout.Font.Height := -12;
    dgMonths.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgMonths.Header.VisualGrouping.Layout.Font.Style := [];
    dgMonths.Adapter := dgdaMonths;
    dgMonths.BitmapContainer := BitmapContainer1;
    dgMonths.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgMonths.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgMonths.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgMonths.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgMonths.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgMonths.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgMonths.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgMonths.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgMonths.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgMonths.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgMonths.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgMonths.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgMonths.CellAppearance.BandLayout.Font.Height := -12;
    dgMonths.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgMonths.CellAppearance.BandLayout.Font.Style := [];
    dgMonths.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgMonths.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgMonths.CellAppearance.FixedLayout.Font.Height := -12;
    dgMonths.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgMonths.CellAppearance.FixedLayout.Font.Style := [];
    dgMonths.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgMonths.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgMonths.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgMonths.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgMonths.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgMonths.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgMonths.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgMonths.CellAppearance.FocusedLayout.Font.Height := -12;
    dgMonths.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgMonths.CellAppearance.FocusedLayout.Font.Style := [];
    dgMonths.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgMonths.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgMonths.CellAppearance.GroupLayout.Font.Height := -12;
    dgMonths.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgMonths.CellAppearance.GroupLayout.Font.Style := [];
    dgMonths.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgMonths.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgMonths.CellAppearance.NormalLayout.Font.Height := -12;
    dgMonths.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgMonths.CellAppearance.NormalLayout.Font.Style := [];
    dgMonths.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgMonths.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgMonths.CellAppearance.SelectedLayout.Font.Height := -12;
    dgMonths.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgMonths.CellAppearance.SelectedLayout.Font.Style := [];
    dgMonths.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgMonths.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgMonths.CellAppearance.SummaryLayout.Font.Height := -12;
    dgMonths.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgMonths.CellAppearance.SummaryLayout.Font.Style := [];
    dgMonths.Columns.Clear;
    with dgMonths.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Month';
      Width := 50.000000000000000000;
    end;
    with dgMonths.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'MonthNo';
      Width := 0.000000000000000000;
    end;
    with dgMonths.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Status';
      Settings := [gcsType];
      Width := 70.000000000000000000;
    end;
    with dgMonths.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    dgMonths.Designer := False;
    dgMonths.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgMonths.FilterAppearance.Font.Color := clWindowText;
    dgMonths.FilterAppearance.Font.Height := -12;
    dgMonths.FilterAppearance.Font.Name := 'Segoe UI';
    dgMonths.FilterAppearance.Font.Style := [];
    dgMonths.HorizontalScrollBarVisible := False;
    dgMonths.Icons.ExpandIcon.LoadFromFile('dashboard.maintenance.WebPanel19.dgMonths.Icons.ExpandIcon.svg');
    dgMonths.Icons.CollapseIcon.LoadFromFile('dashboard.maintenance.WebPanel19.dgMonths.Icons.CollapseIcon.svg');
    dgMonths.Icons.FilterIcon.LoadFromFile('dashboard.maintenance.WebPanel19.dgMonths.Icons.FilterIcon.svg');
    dgMonths.Icons.FilterActiveIcon.LoadFromFile('dashboard.maintenance.WebPanel19.dgMonths.Icons.FilterActiveIcon.svg');
    dgMonths.Icons.FilterClearIcon.LoadFromFile('dashboard.maintenance.WebPanel19.dgMonths.Icons.FilterClearIcon.svg');
    dgMonths.Icons.FilterTypeIcon.LoadFromFile('dashboard.maintenance.WebPanel19.dgMonths.Icons.FilterTypeIcon.svg');
    dgMonths.Icons.SortAscendingIcon.LoadFromFile('dashboard.maintenance.WebPanel19.dgMonths.Icons.SortAscendingIcon.svg');
    dgMonths.Icons.SortDescendingIcon.LoadFromFile('dashboard.maintenance.WebPanel19.dgMonths.Icons.SortDescendingIcon.svg');
    dgMonths.Icons.CloseIcon.LoadFromFile('dashboard.maintenance.WebPanel19.dgMonths.Icons.CloseIcon.svg');
    SetEvent(dgMonths, Self, 'OnCellClick', 'dgMonthsCellClick');
    SetEvent(dgMonths, Self, 'OnGetCellProperties', 'dgMonthsGetCellProperties');
    dgMonths.RowCount := 1;
    dgdaMonths.SetParentComponent(dgMonths);
    dgdaMonths.Name := 'dgdaMonths';
    dgdaMonths.Left := 104;
    dgdaMonths.Top := 72;
    dgdaMonths.Width := 26;
    dgdaMonths.Height := 26;
    dgdaMonths.Visible := True;
    dgdaMonths.AutoCreateColumns := False;
    dgdaMonths.AutoRemoveColumns := False;
    dgdaMonths.Columns.Clear;
    with dgdaMonths.Columns.Add do
    begin
      FieldName := 'MonthName';
      Header := 'Month';
      AutoCreated := False;
    end;
    with dgdaMonths.Columns.Add do
    begin
      FieldName := 'Month';
      Header := 'MonthNo';
      AutoCreated := False;
    end;
    with dgdaMonths.Columns.Add do
    begin
      FieldName := 'Selected';
      AutoCreated := False;
    end;
    with dgdaMonths.Columns.Add do
    begin
      AutoCreated := False;
    end;
    dgdaMonths.DataSource := dsMonths;
    btnMonthsClear.SetParentComponent(WebPanel19);
    btnMonthsClear.Name := 'btnMonthsClear';
    btnMonthsClear.Left := 0;
    btnMonthsClear.Top := 155;
    btnMonthsClear.Width := 250;
    btnMonthsClear.Height := 24;
    btnMonthsClear.Align := alBottom;
    btnMonthsClear.Caption := 'Clear';
    btnMonthsClear.Color := clNone;
    btnMonthsClear.HeightPercent := 100.000000000000000000;
    btnMonthsClear.TabOrder := 1;
    btnMonthsClear.WidthPercent := 100.000000000000000000;
    SetEvent(btnMonthsClear, Self, 'OnClick', 'btnMonthsClearClick');
    WebPanel21.SetParentComponent(pMainMonths);
    WebPanel21.Name := 'WebPanel21';
    WebPanel21.Left := 0;
    WebPanel21.Top := 194;
    WebPanel21.Width := 280;
    WebPanel21.Height := 15;
    WebPanel21.Align := alBottom;
    WebPanel21.BorderColor := clGray;
    WebPanel21.BorderStyle := bsNone;
    WebPanel21.ChildOrder := 4;
    WebPanel21.Color := clGray;
    WebPanel21.TabOrder := 1;
    WebPanel22.SetParentComponent(pMainMonths);
    WebPanel22.Name := 'WebPanel22';
    WebPanel22.Left := 0;
    WebPanel22.Top := 15;
    WebPanel22.Width := 15;
    WebPanel22.Height := 179;
    WebPanel22.Align := alLeft;
    WebPanel22.BorderColor := clGray;
    WebPanel22.BorderStyle := bsNone;
    WebPanel22.ChildOrder := 3;
    WebPanel22.Color := clGray;
    WebPanel22.TabOrder := 2;
    WebPanel23.SetParentComponent(pMainMonths);
    WebPanel23.Name := 'WebPanel23';
    WebPanel23.Left := 265;
    WebPanel23.Top := 15;
    WebPanel23.Width := 15;
    WebPanel23.Height := 179;
    WebPanel23.Align := alRight;
    WebPanel23.BorderColor := clGray;
    WebPanel23.BorderStyle := bsNone;
    WebPanel23.ChildOrder := 4;
    WebPanel23.Color := clGray;
    WebPanel23.TabOrder := 3;
    pRegNo.SetParentComponent(pMainTop);
    pRegNo.Name := 'pRegNo';
    pRegNo.Left := 840;
    pRegNo.Top := 0;
    pRegNo.Width := 280;
    pRegNo.Height := 209;
    pRegNo.Align := alLeft;
    pRegNo.BorderColor := clGray;
    pRegNo.BorderStyle := bsNone;
    pRegNo.ChildOrder := 2;
    pRegNo.Color := clGray;
    pRegNo.TabOrder := 1;
    WebLabel3.SetParentComponent(pRegNo);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 0;
    WebLabel3.Top := 0;
    WebLabel3.Width := 280;
    WebLabel3.Height := 15;
    WebLabel3.Align := alTop;
    WebLabel3.Alignment := taCenter;
    WebLabel3.Caption := 'Select Registration';
    WebLabel3.Color := clGray;
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := -12;
    WebLabel3.Font.Name := 'Segoe UI';
    WebLabel3.Font.Style := [fsBold];
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.Transparent := False;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebPanel20.SetParentComponent(pRegNo);
    WebPanel20.Name := 'WebPanel20';
    WebPanel20.Left := 15;
    WebPanel20.Top := 15;
    WebPanel20.Width := 250;
    WebPanel20.Height := 179;
    WebPanel20.Align := alClient;
    WebPanel20.BorderColor := clGray;
    WebPanel20.BorderStyle := bsNone;
    WebPanel20.Caption := 'WebPanel20';
    WebPanel20.ChildOrder := 3;
    WebPanel20.Color := clGray;
    WebPanel20.TabOrder := 0;
    dgReg.SetParentComponent(WebPanel20);
    dgReg.Name := 'dgReg';
    dgReg.Left := 0;
    dgReg.Top := 0;
    dgReg.Width := 250;
    dgReg.Height := 155;
    dgReg.Align := alClient;
    dgReg.ParentDoubleBuffered := False;
    dgReg.DoubleBuffered := True;
    dgReg.TabOrder := 0;
    dgReg.ShowAcceleratorChar := False;
    dgReg.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgReg.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgReg.Header.VisualGrouping.Layout.Font.Height := -12;
    dgReg.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgReg.Header.VisualGrouping.Layout.Font.Style := [];
    dgReg.Adapter := dgdaReg;
    dgReg.BitmapContainer := BitmapContainer1;
    dgReg.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgReg.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgReg.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgReg.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgReg.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgReg.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgReg.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgReg.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgReg.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgReg.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgReg.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgReg.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgReg.CellAppearance.BandLayout.Font.Height := -12;
    dgReg.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgReg.CellAppearance.BandLayout.Font.Style := [];
    dgReg.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgReg.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgReg.CellAppearance.FixedLayout.Font.Height := -12;
    dgReg.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgReg.CellAppearance.FixedLayout.Font.Style := [];
    dgReg.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgReg.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgReg.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgReg.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgReg.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgReg.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgReg.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgReg.CellAppearance.FocusedLayout.Font.Height := -12;
    dgReg.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgReg.CellAppearance.FocusedLayout.Font.Style := [];
    dgReg.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgReg.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgReg.CellAppearance.GroupLayout.Font.Height := -12;
    dgReg.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgReg.CellAppearance.GroupLayout.Font.Style := [];
    dgReg.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgReg.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgReg.CellAppearance.NormalLayout.Font.Height := -12;
    dgReg.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgReg.CellAppearance.NormalLayout.Font.Style := [];
    dgReg.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgReg.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgReg.CellAppearance.SelectedLayout.Font.Height := -12;
    dgReg.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgReg.CellAppearance.SelectedLayout.Font.Style := [];
    dgReg.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgReg.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgReg.CellAppearance.SummaryLayout.Font.Height := -12;
    dgReg.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgReg.CellAppearance.SummaryLayout.Font.Style := [];
    dgReg.Columns.Clear;
    with dgReg.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Fleet No';
      Width := 80.000000000000000000;
    end;
    with dgReg.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Reg No';
      Width := 100.000000000000000000;
    end;
    with dgReg.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Status';
      Settings := [gcsType];
      Width := 50.000000000000000000;
    end;
    with dgReg.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Visible := False;
      Width := 0.000000000000000000;
    end;
    dgReg.Designer := False;
    dgReg.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgReg.FilterAppearance.Font.Color := clWindowText;
    dgReg.FilterAppearance.Font.Height := -12;
    dgReg.FilterAppearance.Font.Name := 'Segoe UI';
    dgReg.FilterAppearance.Font.Style := [];
    dgReg.Icons.ExpandIcon.LoadFromFile('dashboard.maintenance.WebPanel20.dgReg.Icons.ExpandIcon.svg');
    dgReg.Icons.CollapseIcon.LoadFromFile('dashboard.maintenance.WebPanel20.dgReg.Icons.CollapseIcon.svg');
    dgReg.Icons.FilterIcon.LoadFromFile('dashboard.maintenance.WebPanel20.dgReg.Icons.FilterIcon.svg');
    dgReg.Icons.FilterActiveIcon.LoadFromFile('dashboard.maintenance.WebPanel20.dgReg.Icons.FilterActiveIcon.svg');
    dgReg.Icons.FilterClearIcon.LoadFromFile('dashboard.maintenance.WebPanel20.dgReg.Icons.FilterClearIcon.svg');
    dgReg.Icons.FilterTypeIcon.LoadFromFile('dashboard.maintenance.WebPanel20.dgReg.Icons.FilterTypeIcon.svg');
    dgReg.Icons.SortAscendingIcon.LoadFromFile('dashboard.maintenance.WebPanel20.dgReg.Icons.SortAscendingIcon.svg');
    dgReg.Icons.SortDescendingIcon.LoadFromFile('dashboard.maintenance.WebPanel20.dgReg.Icons.SortDescendingIcon.svg');
    dgReg.Icons.CloseIcon.LoadFromFile('dashboard.maintenance.WebPanel20.dgReg.Icons.CloseIcon.svg');
    SetEvent(dgReg, Self, 'OnCellClick', 'dgRegCellClick');
    SetEvent(dgReg, Self, 'OnGetCellProperties', 'dgRegGetCellProperties');
    dgReg.RowCount := 1;
    dgdaReg.SetParentComponent(dgReg);
    dgdaReg.Name := 'dgdaReg';
    dgdaReg.Left := 88;
    dgdaReg.Top := 96;
    dgdaReg.Width := 26;
    dgdaReg.Height := 26;
    dgdaReg.Visible := True;
    dgdaReg.AutoCreateColumns := False;
    dgdaReg.AutoRemoveColumns := False;
    dgdaReg.Columns.Clear;
    with dgdaReg.Columns.Add do
    begin
      FieldName := 'FleetNo';
      Header := 'Fleet No';
      AutoCreated := False;
    end;
    with dgdaReg.Columns.Add do
    begin
      FieldName := 'Reg';
      Header := 'Reg No';
      AutoCreated := False;
    end;
    with dgdaReg.Columns.Add do
    begin
      FieldName := 'Selected';
      Header := 'Status';
      AutoCreated := False;
    end;
    with dgdaReg.Columns.Add do
    begin
      AutoCreated := False;
    end;
    dgdaReg.DataSource := dsReg;
    btnRegClear.SetParentComponent(WebPanel20);
    btnRegClear.Name := 'btnRegClear';
    btnRegClear.Left := 0;
    btnRegClear.Top := 155;
    btnRegClear.Width := 250;
    btnRegClear.Height := 24;
    btnRegClear.Align := alBottom;
    btnRegClear.Caption := 'Clear';
    btnRegClear.Color := clNone;
    btnRegClear.HeightPercent := 100.000000000000000000;
    btnRegClear.TabOrder := 1;
    btnRegClear.WidthPercent := 100.000000000000000000;
    SetEvent(btnRegClear, Self, 'OnClick', 'btnRegClearClick');
    WebPanel24.SetParentComponent(pRegNo);
    WebPanel24.Name := 'WebPanel24';
    WebPanel24.Left := 0;
    WebPanel24.Top := 194;
    WebPanel24.Width := 280;
    WebPanel24.Height := 15;
    WebPanel24.Align := alBottom;
    WebPanel24.BorderColor := clGray;
    WebPanel24.BorderStyle := bsNone;
    WebPanel24.ChildOrder := 4;
    WebPanel24.Color := clGray;
    WebPanel24.TabOrder := 1;
    WebPanel25.SetParentComponent(pRegNo);
    WebPanel25.Name := 'WebPanel25';
    WebPanel25.Left := 0;
    WebPanel25.Top := 15;
    WebPanel25.Width := 15;
    WebPanel25.Height := 179;
    WebPanel25.Align := alLeft;
    WebPanel25.BorderColor := clGray;
    WebPanel25.BorderStyle := bsNone;
    WebPanel25.ChildOrder := 3;
    WebPanel25.Color := clGray;
    WebPanel25.TabOrder := 2;
    WebPanel26.SetParentComponent(pRegNo);
    WebPanel26.Name := 'WebPanel26';
    WebPanel26.Left := 265;
    WebPanel26.Top := 15;
    WebPanel26.Width := 15;
    WebPanel26.Height := 179;
    WebPanel26.Align := alRight;
    WebPanel26.BorderColor := clGray;
    WebPanel26.BorderStyle := bsNone;
    WebPanel26.ChildOrder := 4;
    WebPanel26.Color := clGray;
    WebPanel26.TabOrder := 3;
    pFinYears.SetParentComponent(pMainTop);
    pFinYears.Name := 'pFinYears';
    pFinYears.Left := 0;
    pFinYears.Top := 0;
    pFinYears.Width := 280;
    pFinYears.Height := 209;
    pFinYears.Align := alLeft;
    pFinYears.BorderColor := clGray;
    pFinYears.BorderStyle := bsNone;
    pFinYears.Caption := 'pFinYears';
    pFinYears.ChildOrder := 4;
    pFinYears.Color := clGray;
    pFinYears.TabOrder := 2;
    WebLabel19.SetParentComponent(pFinYears);
    WebLabel19.Name := 'WebLabel19';
    WebLabel19.Left := 0;
    WebLabel19.Top := 0;
    WebLabel19.Width := 280;
    WebLabel19.Height := 15;
    WebLabel19.Align := alTop;
    WebLabel19.Alignment := taCenter;
    WebLabel19.Caption := 'Select Financial Years';
    WebLabel19.Color := clGray;
    WebLabel19.Font.Charset := DEFAULT_CHARSET;
    WebLabel19.Font.Color := clWindowText;
    WebLabel19.Font.Height := -12;
    WebLabel19.Font.Name := 'Segoe UI';
    WebLabel19.Font.Style := [fsBold];
    WebLabel19.HeightPercent := 100.000000000000000000;
    WebLabel19.ParentFont := False;
    WebLabel19.Transparent := False;
    WebLabel19.WidthPercent := 100.000000000000000000;
    WebPanel11.SetParentComponent(pFinYears);
    WebPanel11.Name := 'WebPanel11';
    WebPanel11.Left := 0;
    WebPanel11.Top := 15;
    WebPanel11.Width := 15;
    WebPanel11.Height := 179;
    WebPanel11.Align := alLeft;
    WebPanel11.BorderColor := clGray;
    WebPanel11.BorderStyle := bsNone;
    WebPanel11.ChildOrder := 3;
    WebPanel11.Color := clGray;
    WebPanel11.TabOrder := 0;
    WebPanel12.SetParentComponent(pFinYears);
    WebPanel12.Name := 'WebPanel12';
    WebPanel12.Left := 265;
    WebPanel12.Top := 15;
    WebPanel12.Width := 15;
    WebPanel12.Height := 179;
    WebPanel12.Align := alRight;
    WebPanel12.BorderColor := clGray;
    WebPanel12.BorderStyle := bsNone;
    WebPanel12.ChildOrder := 4;
    WebPanel12.Color := clGray;
    WebPanel12.TabOrder := 1;
    WebPanel13.SetParentComponent(pFinYears);
    WebPanel13.Name := 'WebPanel13';
    WebPanel13.Left := 15;
    WebPanel13.Top := 15;
    WebPanel13.Width := 250;
    WebPanel13.Height := 179;
    WebPanel13.Align := alClient;
    WebPanel13.BorderColor := clGray;
    WebPanel13.BorderStyle := bsNone;
    WebPanel13.ChildOrder := 3;
    WebPanel13.Color := clGray;
    WebPanel13.TabOrder := 2;
    dgFinYears.SetParentComponent(WebPanel13);
    dgFinYears.Name := 'dgFinYears';
    dgFinYears.Left := 0;
    dgFinYears.Top := 0;
    dgFinYears.Width := 250;
    dgFinYears.Height := 155;
    dgFinYears.Align := alClient;
    dgFinYears.ParentDoubleBuffered := False;
    dgFinYears.DoubleBuffered := True;
    dgFinYears.TabOrder := 0;
    dgFinYears.ShowAcceleratorChar := False;
    dgFinYears.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgFinYears.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgFinYears.Header.VisualGrouping.Layout.Font.Height := -12;
    dgFinYears.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgFinYears.Header.VisualGrouping.Layout.Font.Style := [];
    dgFinYears.Adapter := dgdaFinYears;
    dgFinYears.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgFinYears.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgFinYears.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgFinYears.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgFinYears.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgFinYears.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgFinYears.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgFinYears.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgFinYears.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgFinYears.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgFinYears.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgFinYears.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgFinYears.CellAppearance.BandLayout.Font.Height := -12;
    dgFinYears.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgFinYears.CellAppearance.BandLayout.Font.Style := [];
    dgFinYears.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgFinYears.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgFinYears.CellAppearance.FixedLayout.Font.Height := -12;
    dgFinYears.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgFinYears.CellAppearance.FixedLayout.Font.Style := [];
    dgFinYears.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgFinYears.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgFinYears.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgFinYears.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgFinYears.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgFinYears.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgFinYears.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgFinYears.CellAppearance.FocusedLayout.Font.Height := -12;
    dgFinYears.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgFinYears.CellAppearance.FocusedLayout.Font.Style := [];
    dgFinYears.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgFinYears.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgFinYears.CellAppearance.GroupLayout.Font.Height := -12;
    dgFinYears.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgFinYears.CellAppearance.GroupLayout.Font.Style := [];
    dgFinYears.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgFinYears.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgFinYears.CellAppearance.NormalLayout.Font.Height := -12;
    dgFinYears.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgFinYears.CellAppearance.NormalLayout.Font.Style := [];
    dgFinYears.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgFinYears.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgFinYears.CellAppearance.SelectedLayout.Font.Height := -12;
    dgFinYears.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgFinYears.CellAppearance.SelectedLayout.Font.Style := [];
    dgFinYears.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgFinYears.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgFinYears.CellAppearance.SummaryLayout.Font.Height := -12;
    dgFinYears.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgFinYears.CellAppearance.SummaryLayout.Font.Style := [];
    dgFinYears.ColumnCount := 3;
    dgFinYears.Columns.Clear;
    with dgFinYears.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Fin Year';
    end;
    with dgFinYears.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Selected';
      Settings := [gcsType];
    end;
    with dgFinYears.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    dgFinYears.Designer := False;
    dgFinYears.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgFinYears.FilterAppearance.Font.Color := clWindowText;
    dgFinYears.FilterAppearance.Font.Height := -12;
    dgFinYears.FilterAppearance.Font.Name := 'Segoe UI';
    dgFinYears.FilterAppearance.Font.Style := [];
    dgFinYears.Icons.ExpandIcon.LoadFromFile('dashboard.maintenance.WebPanel13.dgFinYears.Icons.ExpandIcon.svg');
    dgFinYears.Icons.CollapseIcon.LoadFromFile('dashboard.maintenance.WebPanel13.dgFinYears.Icons.CollapseIcon.svg');
    dgFinYears.Icons.FilterIcon.LoadFromFile('dashboard.maintenance.WebPanel13.dgFinYears.Icons.FilterIcon.svg');
    dgFinYears.Icons.FilterActiveIcon.LoadFromFile('dashboard.maintenance.WebPanel13.dgFinYears.Icons.FilterActiveIcon.svg');
    dgFinYears.Icons.FilterClearIcon.LoadFromFile('dashboard.maintenance.WebPanel13.dgFinYears.Icons.FilterClearIcon.svg');
    dgFinYears.Icons.FilterTypeIcon.LoadFromFile('dashboard.maintenance.WebPanel13.dgFinYears.Icons.FilterTypeIcon.svg');
    dgFinYears.Icons.SortAscendingIcon.LoadFromFile('dashboard.maintenance.WebPanel13.dgFinYears.Icons.SortAscendingIcon.svg');
    dgFinYears.Icons.SortDescendingIcon.LoadFromFile('dashboard.maintenance.WebPanel13.dgFinYears.Icons.SortDescendingIcon.svg');
    dgFinYears.Icons.CloseIcon.LoadFromFile('dashboard.maintenance.WebPanel13.dgFinYears.Icons.CloseIcon.svg');
    SetEvent(dgFinYears, Self, 'OnCellClick', 'dgFinYearsCellClick');
    SetEvent(dgFinYears, Self, 'OnGetCellProperties', 'dgFinYearsGetCellProperties');
    dgFinYears.RowCount := 1;
    dgdaFinYears.SetParentComponent(dgFinYears);
    dgdaFinYears.Name := 'dgdaFinYears';
    dgdaFinYears.Left := 80;
    dgdaFinYears.Top := 96;
    dgdaFinYears.Width := 26;
    dgdaFinYears.Height := 26;
    dgdaFinYears.Visible := True;
    dgdaFinYears.Columns.Clear;
    with dgdaFinYears.Columns.Add do
    begin
      FieldName := 'Year';
      Header := 'Fin Year';
      AutoCreated := False;
    end;
    with dgdaFinYears.Columns.Add do
    begin
      FieldName := 'Selected';
      Header := 'Selected';
      AutoCreated := False;
    end;
    with dgdaFinYears.Columns.Add do
    begin
      AutoCreated := False;
    end;
    dgdaFinYears.DataSource := dsFinYears;
    WebSpeedButton4.SetParentComponent(WebPanel13);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 0;
    WebSpeedButton4.Top := 155;
    WebSpeedButton4.Width := 250;
    WebSpeedButton4.Height := 24;
    WebSpeedButton4.Align := alBottom;
    WebSpeedButton4.Caption := 'Clear';
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.TabOrder := 1;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton4, Self, 'OnClick', 'WebSpeedButton4Click');
    WebPanel14.SetParentComponent(pFinYears);
    WebPanel14.Name := 'WebPanel14';
    WebPanel14.Left := 0;
    WebPanel14.Top := 194;
    WebPanel14.Width := 280;
    WebPanel14.Height := 15;
    WebPanel14.Align := alBottom;
    WebPanel14.BorderColor := clGray;
    WebPanel14.BorderStyle := bsNone;
    WebPanel14.ChildOrder := 4;
    WebPanel14.Color := clGray;
    WebPanel14.TabOrder := 3;
    pMainYears.SetParentComponent(pMainTop);
    pMainYears.Name := 'pMainYears';
    pMainYears.Left := 280;
    pMainYears.Top := 0;
    pMainYears.Width := 280;
    pMainYears.Height := 209;
    pMainYears.Align := alLeft;
    pMainYears.BorderColor := clGray;
    pMainYears.BorderStyle := bsNone;
    pMainYears.ChildOrder := 1;
    pMainYears.Color := clGray;
    pMainYears.TabOrder := 3;
    WebLabel1.SetParentComponent(pMainYears);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 0;
    WebLabel1.Top := 0;
    WebLabel1.Width := 280;
    WebLabel1.Height := 15;
    WebLabel1.Align := alTop;
    WebLabel1.Alignment := taCenter;
    WebLabel1.Caption := 'Select Years';
    WebLabel1.Color := clGray;
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -12;
    WebLabel1.Font.Name := 'Segoe UI';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.Transparent := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    dgYears.SetParentComponent(pMainYears);
    dgYears.Name := 'dgYears';
    dgYears.Left := 72;
    dgYears.Top := 56;
    dgYears.Width := 137;
    dgYears.Height := 98;
    dgYears.ParentDoubleBuffered := False;
    dgYears.DoubleBuffered := True;
    dgYears.TabOrder := 0;
    dgYears.ShowAcceleratorChar := False;
    dgYears.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgYears.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgYears.Header.VisualGrouping.Layout.Font.Height := -12;
    dgYears.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgYears.Header.VisualGrouping.Layout.Font.Style := [];
    dgYears.Adapter := dgdaYears;
    dgYears.BitmapContainer := BitmapContainer1;
    dgYears.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgYears.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgYears.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgYears.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgYears.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgYears.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgYears.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgYears.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgYears.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgYears.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgYears.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgYears.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgYears.CellAppearance.BandLayout.Font.Height := -12;
    dgYears.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgYears.CellAppearance.BandLayout.Font.Style := [];
    dgYears.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgYears.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgYears.CellAppearance.FixedLayout.Font.Height := -12;
    dgYears.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgYears.CellAppearance.FixedLayout.Font.Style := [];
    dgYears.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgYears.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgYears.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgYears.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgYears.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgYears.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgYears.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgYears.CellAppearance.FocusedLayout.Font.Height := -12;
    dgYears.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgYears.CellAppearance.FocusedLayout.Font.Style := [];
    dgYears.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgYears.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgYears.CellAppearance.GroupLayout.Font.Height := -12;
    dgYears.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgYears.CellAppearance.GroupLayout.Font.Style := [];
    dgYears.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgYears.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgYears.CellAppearance.NormalLayout.Font.Height := -12;
    dgYears.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgYears.CellAppearance.NormalLayout.Font.Style := [];
    dgYears.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgYears.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgYears.CellAppearance.SelectedLayout.Font.Height := -12;
    dgYears.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgYears.CellAppearance.SelectedLayout.Font.Style := [];
    dgYears.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgYears.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgYears.CellAppearance.SummaryLayout.Font.Height := -12;
    dgYears.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgYears.CellAppearance.SummaryLayout.Font.Style := [];
    dgYears.ColumnCount := 3;
    dgYears.Columns.Clear;
    with dgYears.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Years';
      Width := 50.000000000000000000;
    end;
    with dgYears.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Status';
      Settings := [gcsType];
      Width := 70.000000000000000000;
    end;
    with dgYears.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsType];
      Width := 0.000000000000000000;
    end;
    dgYears.Designer := False;
    dgYears.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgYears.FilterAppearance.Font.Color := clWindowText;
    dgYears.FilterAppearance.Font.Height := -12;
    dgYears.FilterAppearance.Font.Name := 'Segoe UI';
    dgYears.FilterAppearance.Font.Style := [];
    dgYears.HorizontalScrollBarVisible := False;
    dgYears.Icons.ExpandIcon.LoadFromFile('dashboard.maintenance.pMainYears.dgYears.Icons.ExpandIcon.svg');
    dgYears.Icons.CollapseIcon.LoadFromFile('dashboard.maintenance.pMainYears.dgYears.Icons.CollapseIcon.svg');
    dgYears.Icons.FilterIcon.LoadFromFile('dashboard.maintenance.pMainYears.dgYears.Icons.FilterIcon.svg');
    dgYears.Icons.FilterActiveIcon.LoadFromFile('dashboard.maintenance.pMainYears.dgYears.Icons.FilterActiveIcon.svg');
    dgYears.Icons.FilterClearIcon.LoadFromFile('dashboard.maintenance.pMainYears.dgYears.Icons.FilterClearIcon.svg');
    dgYears.Icons.FilterTypeIcon.LoadFromFile('dashboard.maintenance.pMainYears.dgYears.Icons.FilterTypeIcon.svg');
    dgYears.Icons.SortAscendingIcon.LoadFromFile('dashboard.maintenance.pMainYears.dgYears.Icons.SortAscendingIcon.svg');
    dgYears.Icons.SortDescendingIcon.LoadFromFile('dashboard.maintenance.pMainYears.dgYears.Icons.SortDescendingIcon.svg');
    dgYears.Icons.CloseIcon.LoadFromFile('dashboard.maintenance.pMainYears.dgYears.Icons.CloseIcon.svg');
    SetEvent(dgYears, Self, 'OnCellClick', 'dgYearsCellClick');
    SetEvent(dgYears, Self, 'OnGetCellProperties', 'dgYearsGetCellProperties');
    dgYears.RowCount := 1;
    dgdaYears.SetParentComponent(dgYears);
    dgdaYears.Name := 'dgdaYears';
    dgdaYears.Left := 80;
    dgdaYears.Top := 96;
    dgdaYears.Width := 26;
    dgdaYears.Height := 26;
    dgdaYears.Visible := True;
    dgdaYears.AutoCreateColumns := False;
    dgdaYears.AutoRemoveColumns := False;
    dgdaYears.Columns.Clear;
    with dgdaYears.Columns.Add do
    begin
      FieldName := 'Year';
      Header := 'Years';
      AutoCreated := False;
    end;
    with dgdaYears.Columns.Add do
    begin
      FieldName := 'Selected';
      Header := 'Selected';
      AutoCreated := False;
    end;
    with dgdaYears.Columns.Add do
    begin
      AutoCreated := False;
    end;
    dgdaYears.DataSource := dsYears;
    WebPanel15.SetParentComponent(pMainYears);
    WebPanel15.Name := 'WebPanel15';
    WebPanel15.Left := 265;
    WebPanel15.Top := 15;
    WebPanel15.Width := 15;
    WebPanel15.Height := 179;
    WebPanel15.Align := alRight;
    WebPanel15.BorderColor := clGray;
    WebPanel15.BorderStyle := bsNone;
    WebPanel15.ChildOrder := 4;
    WebPanel15.Color := clGray;
    WebPanel15.TabOrder := 1;
    WebPanel16.SetParentComponent(pMainYears);
    WebPanel16.Name := 'WebPanel16';
    WebPanel16.Left := 0;
    WebPanel16.Top := 15;
    WebPanel16.Width := 15;
    WebPanel16.Height := 179;
    WebPanel16.Align := alLeft;
    WebPanel16.BorderColor := clGray;
    WebPanel16.BorderStyle := bsNone;
    WebPanel16.ChildOrder := 3;
    WebPanel16.Color := clGray;
    WebPanel16.TabOrder := 2;
    WebPanel17.SetParentComponent(pMainYears);
    WebPanel17.Name := 'WebPanel17';
    WebPanel17.Left := 15;
    WebPanel17.Top := 15;
    WebPanel17.Width := 250;
    WebPanel17.Height := 179;
    WebPanel17.Align := alClient;
    WebPanel17.BorderStyle := bsNone;
    WebPanel17.Caption := 'WebPanel17';
    WebPanel17.ChildOrder := 5;
    WebPanel17.TabOrder := 3;
    TMSFNCDataGrid1.SetParentComponent(WebPanel17);
    TMSFNCDataGrid1.Name := 'TMSFNCDataGrid1';
    TMSFNCDataGrid1.Left := 0;
    TMSFNCDataGrid1.Top := 0;
    TMSFNCDataGrid1.Width := 250;
    TMSFNCDataGrid1.Height := 155;
    TMSFNCDataGrid1.Align := alClient;
    TMSFNCDataGrid1.ParentDoubleBuffered := False;
    TMSFNCDataGrid1.DoubleBuffered := True;
    TMSFNCDataGrid1.TabOrder := 0;
    TMSFNCDataGrid1.ShowAcceleratorChar := False;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Height := -12;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Style := [];
    TMSFNCDataGrid1.Adapter := TMSFNCDataGridDatabaseAdapter1;
    TMSFNCDataGrid1.BitmapContainer := BitmapContainer1;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Style := [];
    TMSFNCDataGrid1.ColumnCount := 3;
    TMSFNCDataGrid1.Columns.Clear;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Years';
      Width := 50.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Status';
      Settings := [gcsType];
      Width := 70.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsType];
      Visible := False;
      Width := 0.000000000000000000;
    end;
    TMSFNCDataGrid1.Designer := False;
    TMSFNCDataGrid1.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.FilterAppearance.Font.Color := clWindowText;
    TMSFNCDataGrid1.FilterAppearance.Font.Height := -12;
    TMSFNCDataGrid1.FilterAppearance.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.FilterAppearance.Font.Style := [];
    TMSFNCDataGrid1.HorizontalScrollBarVisible := False;
    TMSFNCDataGrid1.Icons.ExpandIcon.LoadFromFile('dashboard.maintenance.WebPanel17.TMSFNCDataGrid1.Icons.ExpandIcon.svg');
    TMSFNCDataGrid1.Icons.CollapseIcon.LoadFromFile('dashboard.maintenance.WebPanel17.TMSFNCDataGrid1.Icons.CollapseIcon.svg');
    TMSFNCDataGrid1.Icons.FilterIcon.LoadFromFile('dashboard.maintenance.WebPanel17.TMSFNCDataGrid1.Icons.FilterIcon.svg');
    TMSFNCDataGrid1.Icons.FilterActiveIcon.LoadFromFile('dashboard.maintenance.WebPanel17.TMSFNCDataGrid1.Icons.FilterActiveIcon.svg');
    TMSFNCDataGrid1.Icons.FilterClearIcon.LoadFromFile('dashboard.maintenance.WebPanel17.TMSFNCDataGrid1.Icons.FilterClearIcon.svg');
    TMSFNCDataGrid1.Icons.FilterTypeIcon.LoadFromFile('dashboard.maintenance.WebPanel17.TMSFNCDataGrid1.Icons.FilterTypeIcon.svg');
    TMSFNCDataGrid1.Icons.SortAscendingIcon.LoadFromFile('dashboard.maintenance.WebPanel17.TMSFNCDataGrid1.Icons.SortAscendingIcon.svg');
    TMSFNCDataGrid1.Icons.SortDescendingIcon.LoadFromFile('dashboard.maintenance.WebPanel17.TMSFNCDataGrid1.Icons.SortDescendingIcon.svg');
    TMSFNCDataGrid1.Icons.CloseIcon.LoadFromFile('dashboard.maintenance.WebPanel17.TMSFNCDataGrid1.Icons.CloseIcon.svg');
    SetEvent(TMSFNCDataGrid1, Self, 'OnCellClick', 'dgYearsCellClick');
    SetEvent(TMSFNCDataGrid1, Self, 'OnGetCellProperties', 'dgYearsGetCellProperties');
    TMSFNCDataGrid1.RowCount := 1;
    TMSFNCDataGridDatabaseAdapter1.SetParentComponent(TMSFNCDataGrid1);
    TMSFNCDataGridDatabaseAdapter1.Name := 'TMSFNCDataGridDatabaseAdapter1';
    TMSFNCDataGridDatabaseAdapter1.Left := 80;
    TMSFNCDataGridDatabaseAdapter1.Top := 96;
    TMSFNCDataGridDatabaseAdapter1.Width := 26;
    TMSFNCDataGridDatabaseAdapter1.Height := 26;
    TMSFNCDataGridDatabaseAdapter1.Visible := True;
    TMSFNCDataGridDatabaseAdapter1.AutoCreateColumns := False;
    TMSFNCDataGridDatabaseAdapter1.AutoRemoveColumns := False;
    TMSFNCDataGridDatabaseAdapter1.Columns.Clear;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'Year';
      Header := 'Years';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'Selected';
      Header := 'Selected';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      AutoCreated := False;
    end;
    TMSFNCDataGridDatabaseAdapter1.DataSource := dsYears;
    btnYearsClear.SetParentComponent(WebPanel17);
    btnYearsClear.Name := 'btnYearsClear';
    btnYearsClear.Left := 0;
    btnYearsClear.Top := 155;
    btnYearsClear.Width := 250;
    btnYearsClear.Height := 24;
    btnYearsClear.Align := alBottom;
    btnYearsClear.Caption := 'Clear';
    btnYearsClear.Color := clNone;
    btnYearsClear.HeightPercent := 100.000000000000000000;
    btnYearsClear.TabOrder := 1;
    btnYearsClear.WidthPercent := 100.000000000000000000;
    SetEvent(btnYearsClear, Self, 'OnClick', 'btnYearsClearClick');
    WebPanel18.SetParentComponent(pMainYears);
    WebPanel18.Name := 'WebPanel18';
    WebPanel18.Left := 0;
    WebPanel18.Top := 194;
    WebPanel18.Width := 280;
    WebPanel18.Height := 15;
    WebPanel18.Align := alBottom;
    WebPanel18.BorderColor := clGray;
    WebPanel18.BorderStyle := bsNone;
    WebPanel18.ChildOrder := 4;
    WebPanel18.Color := clGray;
    WebPanel18.TabOrder := 4;
    pMaintGroups.SetParentComponent(pMainTop);
    pMaintGroups.Name := 'pMaintGroups';
    pMaintGroups.Left := 1120;
    pMaintGroups.Top := 0;
    pMaintGroups.Width := 280;
    pMaintGroups.Height := 209;
    pMaintGroups.Align := alLeft;
    pMaintGroups.BorderColor := clGray;
    pMaintGroups.BorderStyle := bsNone;
    pMaintGroups.Caption := 'pMaintGroups';
    pMaintGroups.ChildOrder := 4;
    pMaintGroups.Color := clGray;
    pMaintGroups.TabOrder := 4;
    WebLabel21.SetParentComponent(pMaintGroups);
    WebLabel21.Name := 'WebLabel21';
    WebLabel21.Left := 0;
    WebLabel21.Top := 0;
    WebLabel21.Width := 280;
    WebLabel21.Height := 15;
    WebLabel21.Align := alTop;
    WebLabel21.Alignment := taCenter;
    WebLabel21.Caption := 'Select Maint Groups';
    WebLabel21.Color := clGray;
    WebLabel21.Font.Charset := DEFAULT_CHARSET;
    WebLabel21.Font.Color := clWindowText;
    WebLabel21.Font.Height := -12;
    WebLabel21.Font.Name := 'Segoe UI';
    WebLabel21.Font.Style := [fsBold];
    WebLabel21.HeightPercent := 100.000000000000000000;
    WebLabel21.ParentFont := False;
    WebLabel21.Transparent := False;
    WebLabel21.WidthPercent := 100.000000000000000000;
    WebPanel7.SetParentComponent(pMaintGroups);
    WebPanel7.Name := 'WebPanel7';
    WebPanel7.Left := 0;
    WebPanel7.Top := 15;
    WebPanel7.Width := 15;
    WebPanel7.Height := 179;
    WebPanel7.Align := alLeft;
    WebPanel7.BorderColor := clGray;
    WebPanel7.BorderStyle := bsNone;
    WebPanel7.ChildOrder := 3;
    WebPanel7.Color := clGray;
    WebPanel7.TabOrder := 0;
    WebPanel8.SetParentComponent(pMaintGroups);
    WebPanel8.Name := 'WebPanel8';
    WebPanel8.Left := 0;
    WebPanel8.Top := 194;
    WebPanel8.Width := 280;
    WebPanel8.Height := 15;
    WebPanel8.Align := alBottom;
    WebPanel8.BorderColor := clGray;
    WebPanel8.BorderStyle := bsNone;
    WebPanel8.ChildOrder := 4;
    WebPanel8.Color := clGray;
    WebPanel8.TabOrder := 1;
    WebPanel9.SetParentComponent(pMaintGroups);
    WebPanel9.Name := 'WebPanel9';
    WebPanel9.Left := 265;
    WebPanel9.Top := 15;
    WebPanel9.Width := 15;
    WebPanel9.Height := 179;
    WebPanel9.Align := alRight;
    WebPanel9.BorderColor := clGray;
    WebPanel9.BorderStyle := bsNone;
    WebPanel9.ChildOrder := 5;
    WebPanel9.Color := clGray;
    WebPanel9.TabOrder := 2;
    WebPanel10.SetParentComponent(pMaintGroups);
    WebPanel10.Name := 'WebPanel10';
    WebPanel10.Left := 15;
    WebPanel10.Top := 15;
    WebPanel10.Width := 250;
    WebPanel10.Height := 179;
    WebPanel10.Align := alClient;
    WebPanel10.BorderColor := clGray;
    WebPanel10.BorderStyle := bsNone;
    WebPanel10.Caption := 'WebPanel10';
    WebPanel10.ChildOrder := 6;
    WebPanel10.Color := clGray;
    WebPanel10.TabOrder := 3;
    WebSpeedButton6.SetParentComponent(WebPanel10);
    WebSpeedButton6.Name := 'WebSpeedButton6';
    WebSpeedButton6.Left := 0;
    WebSpeedButton6.Top := 155;
    WebSpeedButton6.Width := 250;
    WebSpeedButton6.Height := 24;
    WebSpeedButton6.Align := alBottom;
    WebSpeedButton6.Caption := 'Clear';
    WebSpeedButton6.Color := clNone;
    WebSpeedButton6.HeightPercent := 100.000000000000000000;
    WebSpeedButton6.TabOrder := 0;
    WebSpeedButton6.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton6, Self, 'OnClick', 'WebSpeedButton6Click');
    dgMaintGroups.SetParentComponent(WebPanel10);
    dgMaintGroups.Name := 'dgMaintGroups';
    dgMaintGroups.Left := 0;
    dgMaintGroups.Top := 0;
    dgMaintGroups.Width := 250;
    dgMaintGroups.Height := 155;
    dgMaintGroups.Align := alClient;
    dgMaintGroups.ParentDoubleBuffered := False;
    dgMaintGroups.DoubleBuffered := True;
    dgMaintGroups.TabOrder := 1;
    dgMaintGroups.ShowAcceleratorChar := False;
    dgMaintGroups.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgMaintGroups.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgMaintGroups.Header.VisualGrouping.Layout.Font.Height := -12;
    dgMaintGroups.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgMaintGroups.Header.VisualGrouping.Layout.Font.Style := [];
    dgMaintGroups.Adapter := dgdaMaintGroups;
    dgMaintGroups.BitmapContainer := BitmapContainer1;
    dgMaintGroups.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgMaintGroups.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgMaintGroups.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgMaintGroups.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgMaintGroups.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgMaintGroups.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgMaintGroups.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgMaintGroups.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgMaintGroups.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgMaintGroups.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgMaintGroups.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgMaintGroups.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgMaintGroups.CellAppearance.BandLayout.Font.Height := -12;
    dgMaintGroups.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgMaintGroups.CellAppearance.BandLayout.Font.Style := [];
    dgMaintGroups.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgMaintGroups.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgMaintGroups.CellAppearance.FixedLayout.Font.Height := -12;
    dgMaintGroups.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgMaintGroups.CellAppearance.FixedLayout.Font.Style := [];
    dgMaintGroups.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgMaintGroups.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgMaintGroups.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgMaintGroups.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgMaintGroups.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgMaintGroups.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgMaintGroups.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgMaintGroups.CellAppearance.FocusedLayout.Font.Height := -12;
    dgMaintGroups.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgMaintGroups.CellAppearance.FocusedLayout.Font.Style := [];
    dgMaintGroups.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgMaintGroups.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgMaintGroups.CellAppearance.GroupLayout.Font.Height := -12;
    dgMaintGroups.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgMaintGroups.CellAppearance.GroupLayout.Font.Style := [];
    dgMaintGroups.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgMaintGroups.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgMaintGroups.CellAppearance.NormalLayout.Font.Height := -12;
    dgMaintGroups.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgMaintGroups.CellAppearance.NormalLayout.Font.Style := [];
    dgMaintGroups.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgMaintGroups.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgMaintGroups.CellAppearance.SelectedLayout.Font.Height := -12;
    dgMaintGroups.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgMaintGroups.CellAppearance.SelectedLayout.Font.Style := [];
    dgMaintGroups.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgMaintGroups.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgMaintGroups.CellAppearance.SummaryLayout.Font.Height := -12;
    dgMaintGroups.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgMaintGroups.CellAppearance.SummaryLayout.Font.Style := [];
    dgMaintGroups.Columns.Clear;
    with dgMaintGroups.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'ID';
      Width := 0.000000000000000000;
    end;
    with dgMaintGroups.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Name';
    end;
    with dgMaintGroups.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Status';
      Settings := [gcsType];
    end;
    with dgMaintGroups.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    dgMaintGroups.Designer := False;
    dgMaintGroups.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgMaintGroups.FilterAppearance.Font.Color := clWindowText;
    dgMaintGroups.FilterAppearance.Font.Height := -12;
    dgMaintGroups.FilterAppearance.Font.Name := 'Segoe UI';
    dgMaintGroups.FilterAppearance.Font.Style := [];
    dgMaintGroups.Icons.ExpandIcon.LoadFromFile('dashboard.maintenance.WebPanel10.dgMaintGroups.Icons.ExpandIcon.svg');
    dgMaintGroups.Icons.CollapseIcon.LoadFromFile('dashboard.maintenance.WebPanel10.dgMaintGroups.Icons.CollapseIcon.svg');
    dgMaintGroups.Icons.FilterIcon.LoadFromFile('dashboard.maintenance.WebPanel10.dgMaintGroups.Icons.FilterIcon.svg');
    dgMaintGroups.Icons.FilterActiveIcon.LoadFromFile('dashboard.maintenance.WebPanel10.dgMaintGroups.Icons.FilterActiveIcon.svg');
    dgMaintGroups.Icons.FilterClearIcon.LoadFromFile('dashboard.maintenance.WebPanel10.dgMaintGroups.Icons.FilterClearIcon.svg');
    dgMaintGroups.Icons.FilterTypeIcon.LoadFromFile('dashboard.maintenance.WebPanel10.dgMaintGroups.Icons.FilterTypeIcon.svg');
    dgMaintGroups.Icons.SortAscendingIcon.LoadFromFile('dashboard.maintenance.WebPanel10.dgMaintGroups.Icons.SortAscendingIcon.svg');
    dgMaintGroups.Icons.SortDescendingIcon.LoadFromFile('dashboard.maintenance.WebPanel10.dgMaintGroups.Icons.SortDescendingIcon.svg');
    dgMaintGroups.Icons.CloseIcon.LoadFromFile('dashboard.maintenance.WebPanel10.dgMaintGroups.Icons.CloseIcon.svg');
    SetEvent(dgMaintGroups, Self, 'OnCellClick', 'dgMaintGroupsCellClick');
    SetEvent(dgMaintGroups, Self, 'OnGetCellProperties', 'dgMaintGroupsGetCellProperties');
    dgMaintGroups.RowCount := 1;
    dgdaMaintGroups.SetParentComponent(dgMaintGroups);
    dgdaMaintGroups.Name := 'dgdaMaintGroups';
    dgdaMaintGroups.Left := 72;
    dgdaMaintGroups.Top := 56;
    dgdaMaintGroups.Width := 26;
    dgdaMaintGroups.Height := 26;
    dgdaMaintGroups.Visible := True;
    dgdaMaintGroups.AutoRemoveColumns := False;
    dgdaMaintGroups.Columns.Clear;
    with dgdaMaintGroups.Columns.Add do
    begin
      FieldName := 'SysType';
      Header := 'ID';
      AutoCreated := False;
    end;
    with dgdaMaintGroups.Columns.Add do
    begin
      FieldName := 'Description';
      Header := 'Name';
      AutoCreated := False;
    end;
    with dgdaMaintGroups.Columns.Add do
    begin
      FieldName := 'Selected';
      Header := 'Status';
      AutoCreated := False;
    end;
    with dgdaMaintGroups.Columns.Add do
    begin
      AutoCreated := False;
    end;
    dgdaMaintGroups.DataSource := dsMaintGroup;
    pMaintTypes.SetParentComponent(pMainTop);
    pMaintTypes.Name := 'pMaintTypes';
    pMaintTypes.Left := 1400;
    pMaintTypes.Top := 0;
    pMaintTypes.Width := 280;
    pMaintTypes.Height := 209;
    pMaintTypes.Align := alLeft;
    pMaintTypes.BorderColor := clGray;
    pMaintTypes.BorderStyle := bsNone;
    pMaintTypes.ChildOrder := 3;
    pMaintTypes.Color := clGray;
    pMaintTypes.TabOrder := 5;
    WebLabel4.SetParentComponent(pMaintTypes);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 0;
    WebLabel4.Top := 0;
    WebLabel4.Width := 280;
    WebLabel4.Height := 15;
    WebLabel4.Align := alTop;
    WebLabel4.Alignment := taCenter;
    WebLabel4.Caption := 'Select Group Types';
    WebLabel4.Color := clGray;
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clWindowText;
    WebLabel4.Font.Height := -12;
    WebLabel4.Font.Name := 'Segoe UI';
    WebLabel4.Font.Style := [fsBold];
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.ParentFont := False;
    WebLabel4.Transparent := False;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebPanel27.SetParentComponent(pMaintTypes);
    WebPanel27.Name := 'WebPanel27';
    WebPanel27.Left := 15;
    WebPanel27.Top := 15;
    WebPanel27.Width := 250;
    WebPanel27.Height := 179;
    WebPanel27.Align := alClient;
    WebPanel27.BorderColor := clGray;
    WebPanel27.BorderStyle := bsNone;
    WebPanel27.Caption := 'WebPanel27';
    WebPanel27.ChildOrder := 3;
    WebPanel27.Color := clGray;
    WebPanel27.TabOrder := 0;
    dgSysTypes.SetParentComponent(WebPanel27);
    dgSysTypes.Name := 'dgSysTypes';
    dgSysTypes.Left := 0;
    dgSysTypes.Top := 0;
    dgSysTypes.Width := 250;
    dgSysTypes.Height := 155;
    dgSysTypes.Align := alClient;
    dgSysTypes.ParentDoubleBuffered := False;
    dgSysTypes.DoubleBuffered := True;
    dgSysTypes.TabOrder := 0;
    dgSysTypes.ShowAcceleratorChar := False;
    dgSysTypes.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgSysTypes.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgSysTypes.Header.VisualGrouping.Layout.Font.Height := -12;
    dgSysTypes.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgSysTypes.Header.VisualGrouping.Layout.Font.Style := [];
    dgSysTypes.Adapter := dgdaSysTypes;
    dgSysTypes.BitmapContainer := BitmapContainer1;
    dgSysTypes.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgSysTypes.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgSysTypes.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgSysTypes.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgSysTypes.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgSysTypes.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgSysTypes.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgSysTypes.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgSysTypes.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgSysTypes.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgSysTypes.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgSysTypes.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgSysTypes.CellAppearance.BandLayout.Font.Height := -12;
    dgSysTypes.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgSysTypes.CellAppearance.BandLayout.Font.Style := [];
    dgSysTypes.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSysTypes.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgSysTypes.CellAppearance.FixedLayout.Font.Height := -12;
    dgSysTypes.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgSysTypes.CellAppearance.FixedLayout.Font.Style := [];
    dgSysTypes.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSysTypes.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgSysTypes.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgSysTypes.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgSysTypes.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgSysTypes.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSysTypes.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgSysTypes.CellAppearance.FocusedLayout.Font.Height := -12;
    dgSysTypes.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgSysTypes.CellAppearance.FocusedLayout.Font.Style := [];
    dgSysTypes.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgSysTypes.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgSysTypes.CellAppearance.GroupLayout.Font.Height := -12;
    dgSysTypes.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgSysTypes.CellAppearance.GroupLayout.Font.Style := [];
    dgSysTypes.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgSysTypes.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgSysTypes.CellAppearance.NormalLayout.Font.Height := -12;
    dgSysTypes.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgSysTypes.CellAppearance.NormalLayout.Font.Style := [];
    dgSysTypes.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSysTypes.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgSysTypes.CellAppearance.SelectedLayout.Font.Height := -12;
    dgSysTypes.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgSysTypes.CellAppearance.SelectedLayout.Font.Style := [];
    dgSysTypes.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgSysTypes.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgSysTypes.CellAppearance.SummaryLayout.Font.Height := -12;
    dgSysTypes.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgSysTypes.CellAppearance.SummaryLayout.Font.Style := [];
    dgSysTypes.Columns.Clear;
    with dgSysTypes.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'ID';
      Width := 0.000000000000000000;
    end;
    with dgSysTypes.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Name';
      Width := 140.000000000000000000;
    end;
    with dgSysTypes.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Status';
      Settings := [gcsType];
      Width := 50.000000000000000000;
    end;
    with dgSysTypes.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Visible := False;
      Width := 0.000000000000000000;
    end;
    dgSysTypes.Designer := False;
    dgSysTypes.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgSysTypes.FilterAppearance.Font.Color := clWindowText;
    dgSysTypes.FilterAppearance.Font.Height := -12;
    dgSysTypes.FilterAppearance.Font.Name := 'Segoe UI';
    dgSysTypes.FilterAppearance.Font.Style := [];
    dgSysTypes.Icons.ExpandIcon.LoadFromFile('dashboard.maintenance.WebPanel27.dgSysTypes.Icons.ExpandIcon.svg');
    dgSysTypes.Icons.CollapseIcon.LoadFromFile('dashboard.maintenance.WebPanel27.dgSysTypes.Icons.CollapseIcon.svg');
    dgSysTypes.Icons.FilterIcon.LoadFromFile('dashboard.maintenance.WebPanel27.dgSysTypes.Icons.FilterIcon.svg');
    dgSysTypes.Icons.FilterActiveIcon.LoadFromFile('dashboard.maintenance.WebPanel27.dgSysTypes.Icons.FilterActiveIcon.svg');
    dgSysTypes.Icons.FilterClearIcon.LoadFromFile('dashboard.maintenance.WebPanel27.dgSysTypes.Icons.FilterClearIcon.svg');
    dgSysTypes.Icons.FilterTypeIcon.LoadFromFile('dashboard.maintenance.WebPanel27.dgSysTypes.Icons.FilterTypeIcon.svg');
    dgSysTypes.Icons.SortAscendingIcon.LoadFromFile('dashboard.maintenance.WebPanel27.dgSysTypes.Icons.SortAscendingIcon.svg');
    dgSysTypes.Icons.SortDescendingIcon.LoadFromFile('dashboard.maintenance.WebPanel27.dgSysTypes.Icons.SortDescendingIcon.svg');
    dgSysTypes.Icons.CloseIcon.LoadFromFile('dashboard.maintenance.WebPanel27.dgSysTypes.Icons.CloseIcon.svg');
    SetEvent(dgSysTypes, Self, 'OnCellClick', 'dgSysTypesCellClick');
    SetEvent(dgSysTypes, Self, 'OnGetCellProperties', 'dgSysTypesGetCellProperties');
    dgSysTypes.RowCount := 1;
    dgdaSysTypes.SetParentComponent(dgSysTypes);
    dgdaSysTypes.Name := 'dgdaSysTypes';
    dgdaSysTypes.Left := 120;
    dgdaSysTypes.Top := 56;
    dgdaSysTypes.Width := 26;
    dgdaSysTypes.Height := 26;
    dgdaSysTypes.Visible := True;
    dgdaSysTypes.AutoCreateColumns := False;
    dgdaSysTypes.AutoRemoveColumns := False;
    dgdaSysTypes.Columns.Clear;
    with dgdaSysTypes.Columns.Add do
    begin
      FieldName := 'SysType';
      Header := 'ID';
      AutoCreated := False;
    end;
    with dgdaSysTypes.Columns.Add do
    begin
      FieldName := 'Description';
      Header := 'Name';
      AutoCreated := False;
    end;
    with dgdaSysTypes.Columns.Add do
    begin
      FieldName := 'Selected';
      Header := 'Status';
      AutoCreated := False;
    end;
    with dgdaSysTypes.Columns.Add do
    begin
      AutoCreated := False;
    end;
    dgdaSysTypes.DataSource := dsSysTypes;
    WebSpeedButton1.SetParentComponent(WebPanel27);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 0;
    WebSpeedButton1.Top := 155;
    WebSpeedButton1.Width := 250;
    WebSpeedButton1.Height := 24;
    WebSpeedButton1.Align := alBottom;
    WebSpeedButton1.Caption := 'Clear';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 1;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    WebPanel28.SetParentComponent(pMaintTypes);
    WebPanel28.Name := 'WebPanel28';
    WebPanel28.Left := 0;
    WebPanel28.Top := 194;
    WebPanel28.Width := 280;
    WebPanel28.Height := 15;
    WebPanel28.Align := alBottom;
    WebPanel28.BorderColor := clGray;
    WebPanel28.BorderStyle := bsNone;
    WebPanel28.ChildOrder := 4;
    WebPanel28.Color := clGray;
    WebPanel28.TabOrder := 1;
    WebPanel29.SetParentComponent(pMaintTypes);
    WebPanel29.Name := 'WebPanel29';
    WebPanel29.Left := 265;
    WebPanel29.Top := 15;
    WebPanel29.Width := 15;
    WebPanel29.Height := 179;
    WebPanel29.Align := alRight;
    WebPanel29.BorderColor := clGray;
    WebPanel29.BorderStyle := bsNone;
    WebPanel29.ChildOrder := 5;
    WebPanel29.Color := clGray;
    WebPanel29.TabOrder := 2;
    WebPanel30.SetParentComponent(pMaintTypes);
    WebPanel30.Name := 'WebPanel30';
    WebPanel30.Left := 0;
    WebPanel30.Top := 15;
    WebPanel30.Width := 15;
    WebPanel30.Height := 179;
    WebPanel30.Align := alLeft;
    WebPanel30.BorderColor := clGray;
    WebPanel30.BorderStyle := bsNone;
    WebPanel30.ChildOrder := 3;
    WebPanel30.Color := clGray;
    WebPanel30.TabOrder := 3;
    WebPanel3.SetParentComponent(WebPanel4);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 205;
    WebPanel3.Width := 1782;
    WebPanel3.Height := 200;
    WebPanel3.HeightStyle := ssPercent;
    WebPanel3.HeightPercent := 45.000000000000000000;
    WebPanel3.Align := alBottom;
    WebPanel3.BorderColor := clBtnFace;
    WebPanel3.BorderStyle := bsNone;
    WebPanel3.ChildOrder := 2;
    WebPanel3.ShowCaption := False;
    WebPanel3.TabOrder := 1;
    wpSuppliers.SetParentComponent(WebPanel3);
    wpSuppliers.Name := 'wpSuppliers';
    wpSuppliers.Left := 280;
    wpSuppliers.Top := 0;
    wpSuppliers.Width := 280;
    wpSuppliers.Height := 200;
    wpSuppliers.Align := alLeft;
    wpSuppliers.BorderColor := clGray;
    wpSuppliers.BorderStyle := bsNone;
    wpSuppliers.ChildOrder := 6;
    wpSuppliers.Color := clGray;
    wpSuppliers.TabOrder := 0;
    WebLabel18.SetParentComponent(wpSuppliers);
    WebLabel18.Name := 'WebLabel18';
    WebLabel18.Left := 0;
    WebLabel18.Top := 0;
    WebLabel18.Width := 280;
    WebLabel18.Height := 15;
    WebLabel18.Align := alTop;
    WebLabel18.Alignment := taCenter;
    WebLabel18.Caption := 'Suppliers';
    WebLabel18.Color := clGray;
    WebLabel18.Font.Charset := DEFAULT_CHARSET;
    WebLabel18.Font.Color := clWindowText;
    WebLabel18.Font.Height := -12;
    WebLabel18.Font.Name := 'Segoe UI';
    WebLabel18.Font.Style := [fsBold];
    WebLabel18.HeightPercent := 100.000000000000000000;
    WebLabel18.ParentFont := False;
    WebLabel18.Transparent := False;
    WebLabel18.WidthPercent := 100.000000000000000000;
    WebPanel35.SetParentComponent(wpSuppliers);
    WebPanel35.Name := 'WebPanel35';
    WebPanel35.Left := 265;
    WebPanel35.Top := 15;
    WebPanel35.Width := 15;
    WebPanel35.Height := 170;
    WebPanel35.Align := alRight;
    WebPanel35.BorderColor := clGray;
    WebPanel35.BorderStyle := bsNone;
    WebPanel35.ChildOrder := 4;
    WebPanel35.Color := clGray;
    WebPanel35.TabOrder := 0;
    WebPanel36.SetParentComponent(wpSuppliers);
    WebPanel36.Name := 'WebPanel36';
    WebPanel36.Left := 0;
    WebPanel36.Top := 15;
    WebPanel36.Width := 15;
    WebPanel36.Height := 170;
    WebPanel36.Align := alLeft;
    WebPanel36.BorderColor := clGray;
    WebPanel36.BorderStyle := bsNone;
    WebPanel36.ChildOrder := 3;
    WebPanel36.Color := clGray;
    WebPanel36.TabOrder := 1;
    WebPanel37.SetParentComponent(wpSuppliers);
    WebPanel37.Name := 'WebPanel37';
    WebPanel37.Left := 0;
    WebPanel37.Top := 185;
    WebPanel37.Width := 280;
    WebPanel37.Height := 15;
    WebPanel37.Align := alBottom;
    WebPanel37.BorderColor := clGray;
    WebPanel37.BorderStyle := bsNone;
    WebPanel37.ChildOrder := 4;
    WebPanel37.Color := clGray;
    WebPanel37.TabOrder := 2;
    WebPanel38.SetParentComponent(wpSuppliers);
    WebPanel38.Name := 'WebPanel38';
    WebPanel38.Left := 15;
    WebPanel38.Top := 15;
    WebPanel38.Width := 250;
    WebPanel38.Height := 170;
    WebPanel38.Align := alClient;
    WebPanel38.BorderColor := clGray;
    WebPanel38.BorderStyle := bsNone;
    WebPanel38.Caption := 'WebPanel38';
    WebPanel38.ChildOrder := 6;
    WebPanel38.Color := clGray;
    WebPanel38.TabOrder := 3;
    dgSuppliers.SetParentComponent(WebPanel38);
    dgSuppliers.Name := 'dgSuppliers';
    dgSuppliers.Left := 0;
    dgSuppliers.Top := 0;
    dgSuppliers.Width := 250;
    dgSuppliers.Height := 146;
    dgSuppliers.Align := alClient;
    dgSuppliers.ParentDoubleBuffered := False;
    dgSuppliers.DoubleBuffered := True;
    dgSuppliers.TabOrder := 0;
    dgSuppliers.ShowAcceleratorChar := False;
    dgSuppliers.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgSuppliers.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgSuppliers.Header.VisualGrouping.Layout.Font.Height := -12;
    dgSuppliers.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgSuppliers.Header.VisualGrouping.Layout.Font.Style := [];
    dgSuppliers.Adapter := dgdaSuppliers;
    dgSuppliers.BitmapContainer := BitmapContainer1;
    dgSuppliers.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgSuppliers.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgSuppliers.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgSuppliers.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgSuppliers.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgSuppliers.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgSuppliers.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgSuppliers.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgSuppliers.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgSuppliers.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgSuppliers.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgSuppliers.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgSuppliers.CellAppearance.BandLayout.Font.Height := -12;
    dgSuppliers.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgSuppliers.CellAppearance.BandLayout.Font.Style := [];
    dgSuppliers.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSuppliers.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgSuppliers.CellAppearance.FixedLayout.Font.Height := -12;
    dgSuppliers.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgSuppliers.CellAppearance.FixedLayout.Font.Style := [];
    dgSuppliers.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSuppliers.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgSuppliers.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgSuppliers.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgSuppliers.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgSuppliers.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSuppliers.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgSuppliers.CellAppearance.FocusedLayout.Font.Height := -12;
    dgSuppliers.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgSuppliers.CellAppearance.FocusedLayout.Font.Style := [];
    dgSuppliers.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgSuppliers.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgSuppliers.CellAppearance.GroupLayout.Font.Height := -12;
    dgSuppliers.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgSuppliers.CellAppearance.GroupLayout.Font.Style := [];
    dgSuppliers.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgSuppliers.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgSuppliers.CellAppearance.NormalLayout.Font.Height := -12;
    dgSuppliers.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgSuppliers.CellAppearance.NormalLayout.Font.Style := [];
    dgSuppliers.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSuppliers.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgSuppliers.CellAppearance.SelectedLayout.Font.Height := -12;
    dgSuppliers.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgSuppliers.CellAppearance.SelectedLayout.Font.Style := [];
    dgSuppliers.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgSuppliers.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgSuppliers.CellAppearance.SummaryLayout.Font.Height := -12;
    dgSuppliers.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgSuppliers.CellAppearance.SummaryLayout.Font.Style := [];
    dgSuppliers.Columns.Clear;
    with dgSuppliers.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'ID';
      Width := 0.000000000000000000;
    end;
    with dgSuppliers.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Name';
      Width := 150.000000000000000000;
    end;
    with dgSuppliers.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Status';
      Settings := [gcsType];
    end;
    with dgSuppliers.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    dgSuppliers.Designer := False;
    dgSuppliers.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgSuppliers.FilterAppearance.Font.Color := clWindowText;
    dgSuppliers.FilterAppearance.Font.Height := -12;
    dgSuppliers.FilterAppearance.Font.Name := 'Segoe UI';
    dgSuppliers.FilterAppearance.Font.Style := [];
    dgSuppliers.Icons.ExpandIcon.LoadFromFile('dashboard.maintenance.WebPanel38.dgSuppliers.Icons.ExpandIcon.svg');
    dgSuppliers.Icons.CollapseIcon.LoadFromFile('dashboard.maintenance.WebPanel38.dgSuppliers.Icons.CollapseIcon.svg');
    dgSuppliers.Icons.FilterIcon.LoadFromFile('dashboard.maintenance.WebPanel38.dgSuppliers.Icons.FilterIcon.svg');
    dgSuppliers.Icons.FilterActiveIcon.LoadFromFile('dashboard.maintenance.WebPanel38.dgSuppliers.Icons.FilterActiveIcon.svg');
    dgSuppliers.Icons.FilterClearIcon.LoadFromFile('dashboard.maintenance.WebPanel38.dgSuppliers.Icons.FilterClearIcon.svg');
    dgSuppliers.Icons.FilterTypeIcon.LoadFromFile('dashboard.maintenance.WebPanel38.dgSuppliers.Icons.FilterTypeIcon.svg');
    dgSuppliers.Icons.SortAscendingIcon.LoadFromFile('dashboard.maintenance.WebPanel38.dgSuppliers.Icons.SortAscendingIcon.svg');
    dgSuppliers.Icons.SortDescendingIcon.LoadFromFile('dashboard.maintenance.WebPanel38.dgSuppliers.Icons.SortDescendingIcon.svg');
    dgSuppliers.Icons.CloseIcon.LoadFromFile('dashboard.maintenance.WebPanel38.dgSuppliers.Icons.CloseIcon.svg');
    SetEvent(dgSuppliers, Self, 'OnCellClick', 'dgSuppliersCellClick');
    SetEvent(dgSuppliers, Self, 'OnGetCellProperties', 'dgSuppliersGetCellProperties');
    dgSuppliers.RowCount := 1;
    dgdaSuppliers.SetParentComponent(dgSuppliers);
    dgdaSuppliers.Name := 'dgdaSuppliers';
    dgdaSuppliers.Left := 96;
    dgdaSuppliers.Top := 64;
    dgdaSuppliers.Width := 26;
    dgdaSuppliers.Height := 26;
    dgdaSuppliers.Visible := True;
    dgdaSuppliers.AutoCreateColumns := False;
    dgdaSuppliers.AutoRemoveColumns := False;
    dgdaSuppliers.Columns.Clear;
    with dgdaSuppliers.Columns.Add do
    begin
      FieldName := 'CrNumber';
      Header := 'ID';
      AutoCreated := False;
    end;
    with dgdaSuppliers.Columns.Add do
    begin
      FieldName := 'CrName';
      Header := 'Name';
      AutoCreated := False;
    end;
    with dgdaSuppliers.Columns.Add do
    begin
      FieldName := 'Selected';
      AutoCreated := False;
    end;
    with dgdaSuppliers.Columns.Add do
    begin
      AutoCreated := False;
    end;
    dgdaSuppliers.DataSource := dsSuppliers;
    WebSpeedButton3.SetParentComponent(WebPanel38);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 0;
    WebSpeedButton3.Top := 146;
    WebSpeedButton3.Width := 250;
    WebSpeedButton3.Height := 24;
    WebSpeedButton3.Align := alBottom;
    WebSpeedButton3.Caption := 'Clear';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.TabOrder := 1;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton3, Self, 'OnClick', 'WebSpeedButton3Click');
    wpVehGroups.SetParentComponent(WebPanel3);
    wpVehGroups.Name := 'wpVehGroups';
    wpVehGroups.Left := 560;
    wpVehGroups.Top := 0;
    wpVehGroups.Width := 280;
    wpVehGroups.Height := 200;
    wpVehGroups.Align := alLeft;
    wpVehGroups.BorderColor := clGray;
    wpVehGroups.BorderStyle := bsNone;
    wpVehGroups.ChildOrder := 1;
    wpVehGroups.Color := clGray;
    wpVehGroups.TabOrder := 1;
    WebLabel20.SetParentComponent(wpVehGroups);
    WebLabel20.Name := 'WebLabel20';
    WebLabel20.Left := 0;
    WebLabel20.Top := 0;
    WebLabel20.Width := 280;
    WebLabel20.Height := 15;
    WebLabel20.Align := alTop;
    WebLabel20.Alignment := taCenter;
    WebLabel20.Caption := 'Operation Groups';
    WebLabel20.Color := clGray;
    WebLabel20.Font.Charset := DEFAULT_CHARSET;
    WebLabel20.Font.Color := clWindowText;
    WebLabel20.Font.Height := -12;
    WebLabel20.Font.Name := 'Segoe UI';
    WebLabel20.Font.Style := [fsBold];
    WebLabel20.HeightPercent := 100.000000000000000000;
    WebLabel20.ParentFont := False;
    WebLabel20.Transparent := False;
    WebLabel20.WidthPercent := 100.000000000000000000;
    WebPanel45.SetParentComponent(wpVehGroups);
    WebPanel45.Name := 'WebPanel45';
    WebPanel45.Left := 0;
    WebPanel45.Top := 15;
    WebPanel45.Width := 15;
    WebPanel45.Height := 170;
    WebPanel45.Align := alLeft;
    WebPanel45.BorderColor := clGray;
    WebPanel45.BorderStyle := bsNone;
    WebPanel45.ChildOrder := 3;
    WebPanel45.Color := clGray;
    WebPanel45.TabOrder := 0;
    WebPanel46.SetParentComponent(wpVehGroups);
    WebPanel46.Name := 'WebPanel46';
    WebPanel46.Left := 265;
    WebPanel46.Top := 15;
    WebPanel46.Width := 15;
    WebPanel46.Height := 170;
    WebPanel46.Align := alRight;
    WebPanel46.BorderColor := clGray;
    WebPanel46.BorderStyle := bsNone;
    WebPanel46.ChildOrder := 5;
    WebPanel46.Color := clGray;
    WebPanel46.TabOrder := 1;
    WebPanel47.SetParentComponent(wpVehGroups);
    WebPanel47.Name := 'WebPanel47';
    WebPanel47.Left := 0;
    WebPanel47.Top := 185;
    WebPanel47.Width := 280;
    WebPanel47.Height := 15;
    WebPanel47.Align := alBottom;
    WebPanel47.BorderColor := clGray;
    WebPanel47.BorderStyle := bsNone;
    WebPanel47.ChildOrder := 4;
    WebPanel47.Color := clGray;
    WebPanel47.TabOrder := 2;
    WebPanel50.SetParentComponent(wpVehGroups);
    WebPanel50.Name := 'WebPanel50';
    WebPanel50.Left := 15;
    WebPanel50.Top := 15;
    WebPanel50.Width := 250;
    WebPanel50.Height := 170;
    WebPanel50.Align := alClient;
    WebPanel50.BorderColor := clGray;
    WebPanel50.BorderStyle := bsNone;
    WebPanel50.Caption := 'WebPanel48';
    WebPanel50.ChildOrder := 6;
    WebPanel50.Color := clGray;
    WebPanel50.TabOrder := 3;
    dgVehGroup.SetParentComponent(WebPanel50);
    dgVehGroup.Name := 'dgVehGroup';
    dgVehGroup.Left := 0;
    dgVehGroup.Top := 0;
    dgVehGroup.Width := 250;
    dgVehGroup.Height := 146;
    dgVehGroup.Align := alClient;
    dgVehGroup.ParentDoubleBuffered := False;
    dgVehGroup.DoubleBuffered := True;
    dgVehGroup.TabOrder := 0;
    dgVehGroup.ShowAcceleratorChar := False;
    dgVehGroup.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgVehGroup.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgVehGroup.Header.VisualGrouping.Layout.Font.Height := -12;
    dgVehGroup.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgVehGroup.Header.VisualGrouping.Layout.Font.Style := [];
    dgVehGroup.Adapter := dgdaVehGroups;
    dgVehGroup.BitmapContainer := BitmapContainer1;
    dgVehGroup.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgVehGroup.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgVehGroup.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgVehGroup.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgVehGroup.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgVehGroup.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgVehGroup.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgVehGroup.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgVehGroup.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgVehGroup.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgVehGroup.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgVehGroup.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgVehGroup.CellAppearance.BandLayout.Font.Height := -12;
    dgVehGroup.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgVehGroup.CellAppearance.BandLayout.Font.Style := [];
    dgVehGroup.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgVehGroup.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgVehGroup.CellAppearance.FixedLayout.Font.Height := -12;
    dgVehGroup.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgVehGroup.CellAppearance.FixedLayout.Font.Style := [];
    dgVehGroup.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgVehGroup.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgVehGroup.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgVehGroup.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgVehGroup.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgVehGroup.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgVehGroup.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgVehGroup.CellAppearance.FocusedLayout.Font.Height := -12;
    dgVehGroup.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgVehGroup.CellAppearance.FocusedLayout.Font.Style := [];
    dgVehGroup.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgVehGroup.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgVehGroup.CellAppearance.GroupLayout.Font.Height := -12;
    dgVehGroup.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgVehGroup.CellAppearance.GroupLayout.Font.Style := [];
    dgVehGroup.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgVehGroup.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgVehGroup.CellAppearance.NormalLayout.Font.Height := -12;
    dgVehGroup.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgVehGroup.CellAppearance.NormalLayout.Font.Style := [];
    dgVehGroup.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgVehGroup.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgVehGroup.CellAppearance.SelectedLayout.Font.Height := -12;
    dgVehGroup.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgVehGroup.CellAppearance.SelectedLayout.Font.Style := [];
    dgVehGroup.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgVehGroup.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgVehGroup.CellAppearance.SummaryLayout.Font.Height := -12;
    dgVehGroup.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgVehGroup.CellAppearance.SummaryLayout.Font.Style := [];
    dgVehGroup.Columns.Clear;
    with dgVehGroup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'ID';
      Width := 0.000000000000000000;
    end;
    with dgVehGroup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Name';
      Width := 100.000000000000000000;
    end;
    with dgVehGroup.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Status';
      Settings := [gcsType];
    end;
    with dgVehGroup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    dgVehGroup.Designer := False;
    dgVehGroup.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgVehGroup.FilterAppearance.Font.Color := clWindowText;
    dgVehGroup.FilterAppearance.Font.Height := -12;
    dgVehGroup.FilterAppearance.Font.Name := 'Segoe UI';
    dgVehGroup.FilterAppearance.Font.Style := [];
    dgVehGroup.Icons.ExpandIcon.LoadFromFile('dashboard.maintenance.WebPanel50.dgVehGroup.Icons.ExpandIcon.svg');
    dgVehGroup.Icons.CollapseIcon.LoadFromFile('dashboard.maintenance.WebPanel50.dgVehGroup.Icons.CollapseIcon.svg');
    dgVehGroup.Icons.FilterIcon.LoadFromFile('dashboard.maintenance.WebPanel50.dgVehGroup.Icons.FilterIcon.svg');
    dgVehGroup.Icons.FilterActiveIcon.LoadFromFile('dashboard.maintenance.WebPanel50.dgVehGroup.Icons.FilterActiveIcon.svg');
    dgVehGroup.Icons.FilterClearIcon.LoadFromFile('dashboard.maintenance.WebPanel50.dgVehGroup.Icons.FilterClearIcon.svg');
    dgVehGroup.Icons.FilterTypeIcon.LoadFromFile('dashboard.maintenance.WebPanel50.dgVehGroup.Icons.FilterTypeIcon.svg');
    dgVehGroup.Icons.SortAscendingIcon.LoadFromFile('dashboard.maintenance.WebPanel50.dgVehGroup.Icons.SortAscendingIcon.svg');
    dgVehGroup.Icons.SortDescendingIcon.LoadFromFile('dashboard.maintenance.WebPanel50.dgVehGroup.Icons.SortDescendingIcon.svg');
    dgVehGroup.Icons.CloseIcon.LoadFromFile('dashboard.maintenance.WebPanel50.dgVehGroup.Icons.CloseIcon.svg');
    SetEvent(dgVehGroup, Self, 'OnCellClick', 'dgVehGroupCellClick');
    SetEvent(dgVehGroup, Self, 'OnGetCellProperties', 'dgVehGroupGetCellProperties');
    dgVehGroup.RowCount := 1;
    dgdaVehGroups.SetParentComponent(dgVehGroup);
    dgdaVehGroups.Name := 'dgdaVehGroups';
    dgdaVehGroups.Left := 144;
    dgdaVehGroups.Top := 32;
    dgdaVehGroups.Width := 26;
    dgdaVehGroups.Height := 26;
    dgdaVehGroups.Visible := True;
    dgdaVehGroups.AutoCreateColumns := False;
    dgdaVehGroups.AutoRemoveColumns := False;
    dgdaVehGroups.Columns.Clear;
    with dgdaVehGroups.Columns.Add do
    begin
      FieldName := 'SysType';
      Header := 'ID';
      AutoCreated := False;
    end;
    with dgdaVehGroups.Columns.Add do
    begin
      FieldName := 'Description';
      Header := 'Name';
      AutoCreated := False;
    end;
    with dgdaVehGroups.Columns.Add do
    begin
      FieldName := 'Selected';
      Header := 'Status';
      AutoCreated := False;
    end;
    with dgdaVehGroups.Columns.Add do
    begin
      AutoCreated := False;
    end;
    dgdaVehGroups.DataSource := dsVehGroups;
    WebSpeedButton5.SetParentComponent(WebPanel50);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 0;
    WebSpeedButton5.Top := 146;
    WebSpeedButton5.Width := 250;
    WebSpeedButton5.Height := 24;
    WebSpeedButton5.Align := alBottom;
    WebSpeedButton5.Caption := 'Clear';
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.TabOrder := 1;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton5, Self, 'OnClick', 'WebSpeedButton5Click');
    pCostGroups.SetParentComponent(WebPanel3);
    pCostGroups.Name := 'pCostGroups';
    pCostGroups.Left := 0;
    pCostGroups.Top := 0;
    pCostGroups.Width := 280;
    pCostGroups.Height := 200;
    pCostGroups.Align := alLeft;
    pCostGroups.BorderColor := clGray;
    pCostGroups.BorderStyle := bsNone;
    pCostGroups.ChildOrder := 4;
    pCostGroups.Color := clGray;
    pCostGroups.TabOrder := 2;
    WebLabel5.SetParentComponent(pCostGroups);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 0;
    WebLabel5.Top := 0;
    WebLabel5.Width := 280;
    WebLabel5.Height := 15;
    WebLabel5.Align := alTop;
    WebLabel5.Alignment := taCenter;
    WebLabel5.Caption := 'Cost Description';
    WebLabel5.Color := clGray;
    WebLabel5.Font.Charset := DEFAULT_CHARSET;
    WebLabel5.Font.Color := clWindowText;
    WebLabel5.Font.Height := -12;
    WebLabel5.Font.Name := 'Segoe UI';
    WebLabel5.Font.Style := [fsBold];
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.ParentFont := False;
    WebLabel5.Transparent := False;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebPanel31.SetParentComponent(pCostGroups);
    WebPanel31.Name := 'WebPanel31';
    WebPanel31.Left := 15;
    WebPanel31.Top := 15;
    WebPanel31.Width := 250;
    WebPanel31.Height := 170;
    WebPanel31.Align := alClient;
    WebPanel31.BorderColor := clGray;
    WebPanel31.BorderStyle := bsNone;
    WebPanel31.Caption := 'WebPanel31';
    WebPanel31.ChildOrder := 3;
    WebPanel31.Color := clGray;
    WebPanel31.TabOrder := 0;
    dgCostGroups.SetParentComponent(WebPanel31);
    dgCostGroups.Name := 'dgCostGroups';
    dgCostGroups.Left := 0;
    dgCostGroups.Top := 0;
    dgCostGroups.Width := 250;
    dgCostGroups.Height := 146;
    dgCostGroups.Align := alClient;
    dgCostGroups.ParentDoubleBuffered := False;
    dgCostGroups.DoubleBuffered := True;
    dgCostGroups.TabOrder := 0;
    dgCostGroups.ShowAcceleratorChar := False;
    dgCostGroups.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgCostGroups.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgCostGroups.Header.VisualGrouping.Layout.Font.Height := -12;
    dgCostGroups.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgCostGroups.Header.VisualGrouping.Layout.Font.Style := [];
    dgCostGroups.Adapter := dgdaCostGroups;
    dgCostGroups.BitmapContainer := BitmapContainer1;
    dgCostGroups.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgCostGroups.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgCostGroups.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgCostGroups.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgCostGroups.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgCostGroups.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgCostGroups.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgCostGroups.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgCostGroups.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgCostGroups.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgCostGroups.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgCostGroups.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgCostGroups.CellAppearance.BandLayout.Font.Height := -12;
    dgCostGroups.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgCostGroups.CellAppearance.BandLayout.Font.Style := [];
    dgCostGroups.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgCostGroups.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgCostGroups.CellAppearance.FixedLayout.Font.Height := -12;
    dgCostGroups.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgCostGroups.CellAppearance.FixedLayout.Font.Style := [];
    dgCostGroups.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgCostGroups.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgCostGroups.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgCostGroups.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgCostGroups.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgCostGroups.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgCostGroups.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgCostGroups.CellAppearance.FocusedLayout.Font.Height := -12;
    dgCostGroups.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgCostGroups.CellAppearance.FocusedLayout.Font.Style := [];
    dgCostGroups.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgCostGroups.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgCostGroups.CellAppearance.GroupLayout.Font.Height := -12;
    dgCostGroups.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgCostGroups.CellAppearance.GroupLayout.Font.Style := [];
    dgCostGroups.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgCostGroups.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgCostGroups.CellAppearance.NormalLayout.Font.Height := -12;
    dgCostGroups.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgCostGroups.CellAppearance.NormalLayout.Font.Style := [];
    dgCostGroups.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgCostGroups.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgCostGroups.CellAppearance.SelectedLayout.Font.Height := -12;
    dgCostGroups.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgCostGroups.CellAppearance.SelectedLayout.Font.Style := [];
    dgCostGroups.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgCostGroups.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgCostGroups.CellAppearance.SummaryLayout.Font.Height := -12;
    dgCostGroups.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgCostGroups.CellAppearance.SummaryLayout.Font.Style := [];
    dgCostGroups.Columns.Clear;
    with dgCostGroups.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'ID';
      Width := 0.000000000000000000;
    end;
    with dgCostGroups.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Name';
      Width := 140.000000000000000000;
    end;
    with dgCostGroups.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Status';
      Settings := [gcsType];
      Width := 50.000000000000000000;
    end;
    with dgCostGroups.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    dgCostGroups.Designer := False;
    dgCostGroups.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgCostGroups.FilterAppearance.Font.Color := clWindowText;
    dgCostGroups.FilterAppearance.Font.Height := -12;
    dgCostGroups.FilterAppearance.Font.Name := 'Segoe UI';
    dgCostGroups.FilterAppearance.Font.Style := [];
    dgCostGroups.Icons.ExpandIcon.LoadFromFile('dashboard.maintenance.WebPanel31.dgCostGroups.Icons.ExpandIcon.svg');
    dgCostGroups.Icons.CollapseIcon.LoadFromFile('dashboard.maintenance.WebPanel31.dgCostGroups.Icons.CollapseIcon.svg');
    dgCostGroups.Icons.FilterIcon.LoadFromFile('dashboard.maintenance.WebPanel31.dgCostGroups.Icons.FilterIcon.svg');
    dgCostGroups.Icons.FilterActiveIcon.LoadFromFile('dashboard.maintenance.WebPanel31.dgCostGroups.Icons.FilterActiveIcon.svg');
    dgCostGroups.Icons.FilterClearIcon.LoadFromFile('dashboard.maintenance.WebPanel31.dgCostGroups.Icons.FilterClearIcon.svg');
    dgCostGroups.Icons.FilterTypeIcon.LoadFromFile('dashboard.maintenance.WebPanel31.dgCostGroups.Icons.FilterTypeIcon.svg');
    dgCostGroups.Icons.SortAscendingIcon.LoadFromFile('dashboard.maintenance.WebPanel31.dgCostGroups.Icons.SortAscendingIcon.svg');
    dgCostGroups.Icons.SortDescendingIcon.LoadFromFile('dashboard.maintenance.WebPanel31.dgCostGroups.Icons.SortDescendingIcon.svg');
    dgCostGroups.Icons.CloseIcon.LoadFromFile('dashboard.maintenance.WebPanel31.dgCostGroups.Icons.CloseIcon.svg');
    SetEvent(dgCostGroups, Self, 'OnCellClick', 'dgCostGroupsCellClick');
    SetEvent(dgCostGroups, Self, 'OnGetCellProperties', 'dgCostGroupsGetCellProperties');
    dgCostGroups.RowCount := 1;
    dgdaCostGroups.SetParentComponent(dgCostGroups);
    dgdaCostGroups.Name := 'dgdaCostGroups';
    dgdaCostGroups.Left := 104;
    dgdaCostGroups.Top := 64;
    dgdaCostGroups.Width := 26;
    dgdaCostGroups.Height := 26;
    dgdaCostGroups.Visible := True;
    dgdaCostGroups.AutoCreateColumns := False;
    dgdaCostGroups.AutoRemoveColumns := False;
    dgdaCostGroups.Columns.Clear;
    with dgdaCostGroups.Columns.Add do
    begin
      FieldName := 'Cost';
      Header := 'ID';
      AutoCreated := False;
    end;
    with dgdaCostGroups.Columns.Add do
    begin
      FieldName := 'Description';
      Header := 'Name';
      AutoCreated := False;
    end;
    with dgdaCostGroups.Columns.Add do
    begin
      FieldName := 'Selected';
      Header := 'Selected';
      AutoCreated := False;
    end;
    with dgdaCostGroups.Columns.Add do
    begin
      AutoCreated := False;
    end;
    dgdaCostGroups.DataSource := dsCostGroups;
    WebSpeedButton2.SetParentComponent(WebPanel31);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 0;
    WebSpeedButton2.Top := 146;
    WebSpeedButton2.Width := 250;
    WebSpeedButton2.Height := 24;
    WebSpeedButton2.Align := alBottom;
    WebSpeedButton2.Caption := 'Clear';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 1;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    WebPanel32.SetParentComponent(pCostGroups);
    WebPanel32.Name := 'WebPanel32';
    WebPanel32.Left := 0;
    WebPanel32.Top := 15;
    WebPanel32.Width := 15;
    WebPanel32.Height := 170;
    WebPanel32.Align := alLeft;
    WebPanel32.BorderColor := clGray;
    WebPanel32.BorderStyle := bsNone;
    WebPanel32.ChildOrder := 3;
    WebPanel32.Color := clGray;
    WebPanel32.TabOrder := 1;
    WebPanel33.SetParentComponent(pCostGroups);
    WebPanel33.Name := 'WebPanel33';
    WebPanel33.Left := 0;
    WebPanel33.Top := 185;
    WebPanel33.Width := 280;
    WebPanel33.Height := 15;
    WebPanel33.Align := alBottom;
    WebPanel33.BorderColor := clGray;
    WebPanel33.BorderStyle := bsNone;
    WebPanel33.ChildOrder := 4;
    WebPanel33.Color := clGray;
    WebPanel33.TabOrder := 2;
    WebPanel34.SetParentComponent(pCostGroups);
    WebPanel34.Name := 'WebPanel34';
    WebPanel34.Left := 265;
    WebPanel34.Top := 15;
    WebPanel34.Width := 15;
    WebPanel34.Height := 170;
    WebPanel34.Align := alRight;
    WebPanel34.BorderColor := clGray;
    WebPanel34.BorderStyle := bsNone;
    WebPanel34.ChildOrder := 4;
    WebPanel34.Color := clGray;
    WebPanel34.TabOrder := 3;
    WebPanel5.SetParentComponent(WebPanel3);
    WebPanel5.Name := 'WebPanel5';
    WebPanel5.Left := 840;
    WebPanel5.Top := 0;
    WebPanel5.Width := 280;
    WebPanel5.Height := 200;
    WebPanel5.Align := alLeft;
    WebPanel5.BorderColor := clGray;
    WebPanel5.BorderStyle := bsNone;
    WebPanel5.Caption := 'WebPanel5';
    WebPanel5.ChildOrder := 3;
    WebPanel5.Color := clGray;
    WebPanel5.TabOrder := 3;
    WebLabel23.SetParentComponent(WebPanel5);
    WebLabel23.Name := 'WebLabel23';
    WebLabel23.Left := 0;
    WebLabel23.Top := 0;
    WebLabel23.Width := 280;
    WebLabel23.Height := 15;
    WebLabel23.Align := alTop;
    WebLabel23.Alignment := taCenter;
    WebLabel23.Caption := 'Equipment Type';
    WebLabel23.Color := clGray;
    WebLabel23.Font.Charset := DEFAULT_CHARSET;
    WebLabel23.Font.Color := clWindowText;
    WebLabel23.Font.Height := -12;
    WebLabel23.Font.Name := 'Segoe UI';
    WebLabel23.Font.Style := [fsBold];
    WebLabel23.HeightPercent := 100.000000000000000000;
    WebLabel23.ParentFont := False;
    WebLabel23.Transparent := False;
    WebLabel23.WidthPercent := 100.000000000000000000;
    WebPanel42.SetParentComponent(WebPanel5);
    WebPanel42.Name := 'WebPanel42';
    WebPanel42.Left := 0;
    WebPanel42.Top := 15;
    WebPanel42.Width := 15;
    WebPanel42.Height := 170;
    WebPanel42.Align := alLeft;
    WebPanel42.BorderColor := clGray;
    WebPanel42.BorderStyle := bsNone;
    WebPanel42.ChildOrder := 3;
    WebPanel42.Color := clGray;
    WebPanel42.TabOrder := 0;
    WebPanel43.SetParentComponent(WebPanel5);
    WebPanel43.Name := 'WebPanel43';
    WebPanel43.Left := 265;
    WebPanel43.Top := 15;
    WebPanel43.Width := 15;
    WebPanel43.Height := 170;
    WebPanel43.Align := alRight;
    WebPanel43.BorderColor := clGray;
    WebPanel43.BorderStyle := bsNone;
    WebPanel43.ChildOrder := 5;
    WebPanel43.Color := clGray;
    WebPanel43.TabOrder := 1;
    WebPanel44.SetParentComponent(WebPanel5);
    WebPanel44.Name := 'WebPanel44';
    WebPanel44.Left := 0;
    WebPanel44.Top := 185;
    WebPanel44.Width := 280;
    WebPanel44.Height := 15;
    WebPanel44.Align := alBottom;
    WebPanel44.BorderColor := clGray;
    WebPanel44.BorderStyle := bsNone;
    WebPanel44.ChildOrder := 4;
    WebPanel44.Color := clGray;
    WebPanel44.TabOrder := 2;
    WebPanel49.SetParentComponent(WebPanel5);
    WebPanel49.Name := 'WebPanel49';
    WebPanel49.Left := 15;
    WebPanel49.Top := 15;
    WebPanel49.Width := 250;
    WebPanel49.Height := 170;
    WebPanel49.Align := alClient;
    WebPanel49.BorderColor := clGray;
    WebPanel49.BorderStyle := bsNone;
    WebPanel49.Caption := 'WebPanel48';
    WebPanel49.ChildOrder := 6;
    WebPanel49.Color := clGray;
    WebPanel49.TabOrder := 3;
    dgUnitType.SetParentComponent(WebPanel49);
    dgUnitType.Name := 'dgUnitType';
    dgUnitType.Left := 80;
    dgUnitType.Top := 10;
    dgUnitType.Width := 0;
    dgUnitType.Height := 90;
    dgUnitType.ParentDoubleBuffered := False;
    dgUnitType.DoubleBuffered := True;
    dgUnitType.TabOrder := 0;
    dgUnitType.ShowAcceleratorChar := False;
    dgUnitType.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgUnitType.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgUnitType.Header.VisualGrouping.Layout.Font.Height := -12;
    dgUnitType.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgUnitType.Header.VisualGrouping.Layout.Font.Style := [];
    dgUnitType.Adapter := dgdaUnitType;
    dgUnitType.BitmapContainer := BitmapContainer1;
    dgUnitType.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgUnitType.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgUnitType.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgUnitType.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgUnitType.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgUnitType.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgUnitType.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgUnitType.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgUnitType.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgUnitType.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgUnitType.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgUnitType.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgUnitType.CellAppearance.BandLayout.Font.Height := -12;
    dgUnitType.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgUnitType.CellAppearance.BandLayout.Font.Style := [];
    dgUnitType.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgUnitType.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgUnitType.CellAppearance.FixedLayout.Font.Height := -12;
    dgUnitType.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgUnitType.CellAppearance.FixedLayout.Font.Style := [];
    dgUnitType.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgUnitType.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgUnitType.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgUnitType.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgUnitType.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgUnitType.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgUnitType.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgUnitType.CellAppearance.FocusedLayout.Font.Height := -12;
    dgUnitType.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgUnitType.CellAppearance.FocusedLayout.Font.Style := [];
    dgUnitType.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgUnitType.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgUnitType.CellAppearance.GroupLayout.Font.Height := -12;
    dgUnitType.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgUnitType.CellAppearance.GroupLayout.Font.Style := [];
    dgUnitType.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgUnitType.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgUnitType.CellAppearance.NormalLayout.Font.Height := -12;
    dgUnitType.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgUnitType.CellAppearance.NormalLayout.Font.Style := [];
    dgUnitType.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgUnitType.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgUnitType.CellAppearance.SelectedLayout.Font.Height := -12;
    dgUnitType.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgUnitType.CellAppearance.SelectedLayout.Font.Style := [];
    dgUnitType.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgUnitType.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgUnitType.CellAppearance.SummaryLayout.Font.Height := -12;
    dgUnitType.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgUnitType.CellAppearance.SummaryLayout.Font.Style := [];
    dgUnitType.Columns.Clear;
    with dgUnitType.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'ID';
      Width := 0.000000000000000000;
    end;
    with dgUnitType.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Name';
    end;
    with dgUnitType.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Status';
      Settings := [gcsType];
    end;
    with dgUnitType.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    dgUnitType.Designer := False;
    dgUnitType.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgUnitType.FilterAppearance.Font.Color := clWindowText;
    dgUnitType.FilterAppearance.Font.Height := -12;
    dgUnitType.FilterAppearance.Font.Name := 'Segoe UI';
    dgUnitType.FilterAppearance.Font.Style := [];
    dgUnitType.Icons.ExpandIcon.LoadFromFile('dashboard.maintenance.WebPanel49.dgUnitType.Icons.ExpandIcon.svg');
    dgUnitType.Icons.CollapseIcon.LoadFromFile('dashboard.maintenance.WebPanel49.dgUnitType.Icons.CollapseIcon.svg');
    dgUnitType.Icons.FilterIcon.LoadFromFile('dashboard.maintenance.WebPanel49.dgUnitType.Icons.FilterIcon.svg');
    dgUnitType.Icons.FilterActiveIcon.LoadFromFile('dashboard.maintenance.WebPanel49.dgUnitType.Icons.FilterActiveIcon.svg');
    dgUnitType.Icons.FilterClearIcon.LoadFromFile('dashboard.maintenance.WebPanel49.dgUnitType.Icons.FilterClearIcon.svg');
    dgUnitType.Icons.FilterTypeIcon.LoadFromFile('dashboard.maintenance.WebPanel49.dgUnitType.Icons.FilterTypeIcon.svg');
    dgUnitType.Icons.SortAscendingIcon.LoadFromFile('dashboard.maintenance.WebPanel49.dgUnitType.Icons.SortAscendingIcon.svg');
    dgUnitType.Icons.SortDescendingIcon.LoadFromFile('dashboard.maintenance.WebPanel49.dgUnitType.Icons.SortDescendingIcon.svg');
    dgUnitType.Icons.CloseIcon.LoadFromFile('dashboard.maintenance.WebPanel49.dgUnitType.Icons.CloseIcon.svg');
    SetEvent(dgUnitType, Self, 'OnCellClick', 'dgUnitTypeCellClick');
    SetEvent(dgUnitType, Self, 'OnGetCellProperties', 'dgUnitTypeGetCellProperties');
    dgUnitType.RowCount := 1;
    dgdaUnitType.SetParentComponent(dgUnitType);
    dgdaUnitType.Name := 'dgdaUnitType';
    dgdaUnitType.Left := 64;
    dgdaUnitType.Top := 64;
    dgdaUnitType.Width := 26;
    dgdaUnitType.Height := 26;
    dgdaUnitType.Visible := True;
    dgdaUnitType.Columns.Clear;
    with dgdaUnitType.Columns.Add do
    begin
      FieldName := 'SysType';
      Header := 'ID';
      AutoCreated := False;
    end;
    with dgdaUnitType.Columns.Add do
    begin
      FieldName := 'Description';
      Header := 'Name';
      AutoCreated := False;
    end;
    with dgdaUnitType.Columns.Add do
    begin
      FieldName := 'Selected';
      Header := 'Status';
      AutoCreated := False;
    end;
    with dgdaUnitType.Columns.Add do
    begin
      AutoCreated := False;
    end;
    dgdaUnitType.DataSource := dsUnitType;
    TMSFNCDataGrid2.SetParentComponent(WebPanel49);
    TMSFNCDataGrid2.Name := 'TMSFNCDataGrid2';
    TMSFNCDataGrid2.Left := 0;
    TMSFNCDataGrid2.Top := 0;
    TMSFNCDataGrid2.Width := 250;
    TMSFNCDataGrid2.Height := 146;
    TMSFNCDataGrid2.Align := alClient;
    TMSFNCDataGrid2.ParentDoubleBuffered := False;
    TMSFNCDataGrid2.DoubleBuffered := True;
    TMSFNCDataGrid2.TabOrder := 1;
    TMSFNCDataGrid2.ShowAcceleratorChar := False;
    TMSFNCDataGrid2.Header.VisualGrouping.Layout.Fill.Kind := gfkGradient;
    TMSFNCDataGrid2.Header.VisualGrouping.Layout.Fill.Color := 16382457;
    TMSFNCDataGrid2.Header.VisualGrouping.Layout.Fill.ColorTo := 16382457;
    TMSFNCDataGrid2.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.Header.VisualGrouping.Layout.Font.Color := clBlack;
    TMSFNCDataGrid2.Header.VisualGrouping.Layout.Font.Height := -12;
    TMSFNCDataGrid2.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.Header.VisualGrouping.Layout.Font.Style := [];
    TMSFNCDataGrid2.Header.VisualGrouping.Layout.Stroke.Color := 15987699;
    TMSFNCDataGrid2.Header.VisualGrouping.LevelActiveIndicationFill.Color := clWhite;
    TMSFNCDataGrid2.Header.VisualGrouping.LevelIndicationStroke.Color := 15987699;
    TMSFNCDataGrid2.Header.VisualGrouping.LevelActiveIndicationStroke.Color := 15987699;
    TMSFNCDataGrid2.Header.Stroke.Color := 15987699;
    TMSFNCDataGrid2.Header.Bar.Fill.Color := 16382457;
    TMSFNCDataGrid2.Header.Bar.Stroke.Color := 15987699;
    TMSFNCDataGrid2.Adapter := TMSFNCDataGridDatabaseAdapter2;
    TMSFNCDataGrid2.BitmapContainer := BitmapContainer1;
    TMSFNCDataGrid2.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.FilterMatchLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.FilterMatchLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.BandLayout.Font.Color := clBlack;
    TMSFNCDataGrid2.CellAppearance.BandLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.BandLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.BandLayout.Stroke.Color := 15987699;
    TMSFNCDataGrid2.CellAppearance.FixedLayout.Fill.ColorTo := 16382457;
    TMSFNCDataGrid2.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.FixedLayout.Font.Color := clBlack;
    TMSFNCDataGrid2.CellAppearance.FixedLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.FixedLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.FixedLayout.Stroke.Color := 15987699;
    TMSFNCDataGrid2.CellAppearance.FixedSelectedLayout.Fill.ColorTo := 15385233;
    TMSFNCDataGrid2.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.FixedSelectedLayout.Font.Color := clBlack;
    TMSFNCDataGrid2.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.FixedSelectedLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.FixedSelectedLayout.Stroke.Color := 15987699;
    TMSFNCDataGrid2.CellAppearance.FocusedLayout.Fill.ColorTo := 15385233;
    TMSFNCDataGrid2.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.FocusedLayout.Font.Color := clBlack;
    TMSFNCDataGrid2.CellAppearance.FocusedLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.FocusedLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.FocusedLayout.Stroke.Color := 15987699;
    TMSFNCDataGrid2.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.GroupLayout.Font.Color := clBlack;
    TMSFNCDataGrid2.CellAppearance.GroupLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.GroupLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.GroupLayout.Stroke.Color := 15987699;
    TMSFNCDataGrid2.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.NormalLayout.Font.Color := clBlack;
    TMSFNCDataGrid2.CellAppearance.NormalLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.NormalLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.NormalLayout.Stroke.Color := 15987699;
    TMSFNCDataGrid2.CellAppearance.SelectedLayout.Fill.ColorTo := 15385233;
    TMSFNCDataGrid2.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.SelectedLayout.Font.Color := clBlack;
    TMSFNCDataGrid2.CellAppearance.SelectedLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.SelectedLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.SelectedLayout.Stroke.Color := 15987699;
    TMSFNCDataGrid2.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.SummaryLayout.Font.Color := clBlack;
    TMSFNCDataGrid2.CellAppearance.SummaryLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.SummaryLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.SummaryLayout.Stroke.Color := 15987699;
    TMSFNCDataGrid2.Columns.Clear;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'ID';
      Width := 0.000000000000000000;
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Name';
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Status';
      Settings := [gcsType];
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    TMSFNCDataGrid2.Designer := False;
    TMSFNCDataGrid2.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.FilterAppearance.Font.Color := clBlack;
    TMSFNCDataGrid2.FilterAppearance.Font.Height := -12;
    TMSFNCDataGrid2.FilterAppearance.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.FilterAppearance.Font.Style := [];
    TMSFNCDataGrid2.Icons.ExpandIcon.LoadFromFile('dashboard.maintenance.WebPanel49.TMSFNCDataGrid2.Icons.ExpandIcon.svg');
    TMSFNCDataGrid2.Icons.CollapseIcon.LoadFromFile('dashboard.maintenance.WebPanel49.TMSFNCDataGrid2.Icons.CollapseIcon.svg');
    TMSFNCDataGrid2.Icons.FilterIcon.LoadFromFile('dashboard.maintenance.WebPanel49.TMSFNCDataGrid2.Icons.FilterIcon.svg');
    TMSFNCDataGrid2.Icons.FilterActiveIcon.LoadFromFile('dashboard.maintenance.WebPanel49.TMSFNCDataGrid2.Icons.FilterActiveIcon.svg');
    TMSFNCDataGrid2.Icons.FilterClearIcon.LoadFromFile('dashboard.maintenance.WebPanel49.TMSFNCDataGrid2.Icons.FilterClearIcon.svg');
    TMSFNCDataGrid2.Icons.FilterTypeIcon.LoadFromFile('dashboard.maintenance.WebPanel49.TMSFNCDataGrid2.Icons.FilterTypeIcon.svg');
    TMSFNCDataGrid2.Icons.SortAscendingIcon.LoadFromFile('dashboard.maintenance.WebPanel49.TMSFNCDataGrid2.Icons.SortAscendingIcon.svg');
    TMSFNCDataGrid2.Icons.SortDescendingIcon.LoadFromFile('dashboard.maintenance.WebPanel49.TMSFNCDataGrid2.Icons.SortDescendingIcon.svg');
    TMSFNCDataGrid2.Icons.CloseIcon.LoadFromFile('dashboard.maintenance.WebPanel49.TMSFNCDataGrid2.Icons.CloseIcon.svg');
    SetEvent(TMSFNCDataGrid2, Self, 'OnCellClick', 'dgUnitTypeCellClick');
    SetEvent(TMSFNCDataGrid2, Self, 'OnGetCellProperties', 'dgUnitTypeGetCellProperties');
    TMSFNCDataGrid2.RowCount := 1;
    TMSFNCDataGridDatabaseAdapter2.SetParentComponent(TMSFNCDataGrid2);
    TMSFNCDataGridDatabaseAdapter2.Name := 'TMSFNCDataGridDatabaseAdapter2';
    TMSFNCDataGridDatabaseAdapter2.Left := 64;
    TMSFNCDataGridDatabaseAdapter2.Top := 64;
    TMSFNCDataGridDatabaseAdapter2.Width := 26;
    TMSFNCDataGridDatabaseAdapter2.Height := 26;
    TMSFNCDataGridDatabaseAdapter2.Visible := True;
    TMSFNCDataGridDatabaseAdapter2.Columns.Clear;
    with TMSFNCDataGridDatabaseAdapter2.Columns.Add do
    begin
      FieldName := 'SysType';
      Header := 'ID';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter2.Columns.Add do
    begin
      FieldName := 'Description';
      Header := 'Name';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter2.Columns.Add do
    begin
      FieldName := 'Selected';
      Header := 'Status';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter2.Columns.Add do
    begin
      AutoCreated := False;
    end;
    TMSFNCDataGridDatabaseAdapter2.DataSource := dsUnitType;
    WebSpeedButton7.SetParentComponent(WebPanel49);
    WebSpeedButton7.Name := 'WebSpeedButton7';
    WebSpeedButton7.Left := 0;
    WebSpeedButton7.Top := 146;
    WebSpeedButton7.Width := 250;
    WebSpeedButton7.Height := 24;
    WebSpeedButton7.Align := alBottom;
    WebSpeedButton7.Caption := 'Clear';
    WebSpeedButton7.Color := clNone;
    WebSpeedButton7.HeightPercent := 100.000000000000000000;
    WebSpeedButton7.TabOrder := 2;
    WebSpeedButton7.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton7, Self, 'OnClick', 'WebSpeedButton7Click');
    pEquipMake.SetParentComponent(WebPanel3);
    pEquipMake.Name := 'pEquipMake';
    pEquipMake.Left := 1120;
    pEquipMake.Top := 0;
    pEquipMake.Width := 280;
    pEquipMake.Height := 200;
    pEquipMake.Align := alLeft;
    pEquipMake.BorderColor := clGray;
    pEquipMake.BorderStyle := bsNone;
    pEquipMake.Caption := 'pEquipMake';
    pEquipMake.ChildOrder := 4;
    pEquipMake.Color := clGray;
    pEquipMake.TabOrder := 4;
    WebLabel24.SetParentComponent(pEquipMake);
    WebLabel24.Name := 'WebLabel24';
    WebLabel24.Left := 0;
    WebLabel24.Top := 0;
    WebLabel24.Width := 280;
    WebLabel24.Height := 15;
    WebLabel24.Align := alTop;
    WebLabel24.Alignment := taCenter;
    WebLabel24.Caption := 'Equipment Make';
    WebLabel24.Color := clGray;
    WebLabel24.Font.Charset := DEFAULT_CHARSET;
    WebLabel24.Font.Color := clWindowText;
    WebLabel24.Font.Height := -12;
    WebLabel24.Font.Name := 'Segoe UI';
    WebLabel24.Font.Style := [fsBold];
    WebLabel24.HeightPercent := 100.000000000000000000;
    WebLabel24.ParentFont := False;
    WebLabel24.Transparent := False;
    WebLabel24.WidthPercent := 100.000000000000000000;
    WebPanel39.SetParentComponent(pEquipMake);
    WebPanel39.Name := 'WebPanel39';
    WebPanel39.Left := 0;
    WebPanel39.Top := 15;
    WebPanel39.Width := 15;
    WebPanel39.Height := 170;
    WebPanel39.Align := alLeft;
    WebPanel39.BorderColor := clGray;
    WebPanel39.BorderStyle := bsNone;
    WebPanel39.ChildOrder := 3;
    WebPanel39.Color := clGray;
    WebPanel39.TabOrder := 0;
    WebPanel40.SetParentComponent(pEquipMake);
    WebPanel40.Name := 'WebPanel40';
    WebPanel40.Left := 265;
    WebPanel40.Top := 15;
    WebPanel40.Width := 15;
    WebPanel40.Height := 170;
    WebPanel40.Align := alRight;
    WebPanel40.BorderColor := clGray;
    WebPanel40.BorderStyle := bsNone;
    WebPanel40.ChildOrder := 5;
    WebPanel40.Color := clGray;
    WebPanel40.TabOrder := 1;
    WebPanel41.SetParentComponent(pEquipMake);
    WebPanel41.Name := 'WebPanel41';
    WebPanel41.Left := 0;
    WebPanel41.Top := 185;
    WebPanel41.Width := 280;
    WebPanel41.Height := 15;
    WebPanel41.Align := alBottom;
    WebPanel41.BorderColor := clGray;
    WebPanel41.BorderStyle := bsNone;
    WebPanel41.ChildOrder := 4;
    WebPanel41.Color := clGray;
    WebPanel41.TabOrder := 2;
    WebPanel48.SetParentComponent(pEquipMake);
    WebPanel48.Name := 'WebPanel48';
    WebPanel48.Left := 15;
    WebPanel48.Top := 15;
    WebPanel48.Width := 250;
    WebPanel48.Height := 170;
    WebPanel48.Align := alClient;
    WebPanel48.BorderColor := clGray;
    WebPanel48.BorderStyle := bsNone;
    WebPanel48.Caption := 'WebPanel48';
    WebPanel48.ChildOrder := 6;
    WebPanel48.Color := clGray;
    WebPanel48.TabOrder := 3;
    dgMake.SetParentComponent(WebPanel48);
    dgMake.Name := 'dgMake';
    dgMake.Left := 0;
    dgMake.Top := 0;
    dgMake.Width := 250;
    dgMake.Height := 146;
    dgMake.Align := alClient;
    dgMake.ParentDoubleBuffered := False;
    dgMake.DoubleBuffered := True;
    dgMake.TabOrder := 0;
    dgMake.ShowAcceleratorChar := False;
    dgMake.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgMake.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgMake.Header.VisualGrouping.Layout.Font.Height := -12;
    dgMake.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgMake.Header.VisualGrouping.Layout.Font.Style := [];
    dgMake.Adapter := dgdaMake;
    dgMake.BitmapContainer := BitmapContainer1;
    dgMake.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgMake.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgMake.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgMake.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgMake.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgMake.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgMake.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgMake.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgMake.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgMake.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgMake.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgMake.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgMake.CellAppearance.BandLayout.Font.Height := -12;
    dgMake.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgMake.CellAppearance.BandLayout.Font.Style := [];
    dgMake.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgMake.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgMake.CellAppearance.FixedLayout.Font.Height := -12;
    dgMake.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgMake.CellAppearance.FixedLayout.Font.Style := [];
    dgMake.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgMake.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgMake.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgMake.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgMake.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgMake.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgMake.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgMake.CellAppearance.FocusedLayout.Font.Height := -12;
    dgMake.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgMake.CellAppearance.FocusedLayout.Font.Style := [];
    dgMake.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgMake.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgMake.CellAppearance.GroupLayout.Font.Height := -12;
    dgMake.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgMake.CellAppearance.GroupLayout.Font.Style := [];
    dgMake.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgMake.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgMake.CellAppearance.NormalLayout.Font.Height := -12;
    dgMake.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgMake.CellAppearance.NormalLayout.Font.Style := [];
    dgMake.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgMake.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgMake.CellAppearance.SelectedLayout.Font.Height := -12;
    dgMake.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgMake.CellAppearance.SelectedLayout.Font.Style := [];
    dgMake.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgMake.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgMake.CellAppearance.SummaryLayout.Font.Height := -12;
    dgMake.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgMake.CellAppearance.SummaryLayout.Font.Style := [];
    dgMake.ColumnCount := 2;
    dgMake.Columns.Clear;
    with dgMake.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Name';
      Width := 150.000000000000000000;
    end;
    with dgMake.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Selected';
      Settings := [gcsType];
      Width := 50.000000000000000000;
    end;
    dgMake.Designer := False;
    dgMake.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgMake.FilterAppearance.Font.Color := clWindowText;
    dgMake.FilterAppearance.Font.Height := -12;
    dgMake.FilterAppearance.Font.Name := 'Segoe UI';
    dgMake.FilterAppearance.Font.Style := [];
    dgMake.Icons.ExpandIcon.LoadFromFile('dashboard.maintenance.WebPanel48.dgMake.Icons.ExpandIcon.svg');
    dgMake.Icons.CollapseIcon.LoadFromFile('dashboard.maintenance.WebPanel48.dgMake.Icons.CollapseIcon.svg');
    dgMake.Icons.FilterIcon.LoadFromFile('dashboard.maintenance.WebPanel48.dgMake.Icons.FilterIcon.svg');
    dgMake.Icons.FilterActiveIcon.LoadFromFile('dashboard.maintenance.WebPanel48.dgMake.Icons.FilterActiveIcon.svg');
    dgMake.Icons.FilterClearIcon.LoadFromFile('dashboard.maintenance.WebPanel48.dgMake.Icons.FilterClearIcon.svg');
    dgMake.Icons.FilterTypeIcon.LoadFromFile('dashboard.maintenance.WebPanel48.dgMake.Icons.FilterTypeIcon.svg');
    dgMake.Icons.SortAscendingIcon.LoadFromFile('dashboard.maintenance.WebPanel48.dgMake.Icons.SortAscendingIcon.svg');
    dgMake.Icons.SortDescendingIcon.LoadFromFile('dashboard.maintenance.WebPanel48.dgMake.Icons.SortDescendingIcon.svg');
    dgMake.Icons.CloseIcon.LoadFromFile('dashboard.maintenance.WebPanel48.dgMake.Icons.CloseIcon.svg');
    SetEvent(dgMake, Self, 'OnCellClick', 'dgMakeCellClick');
    SetEvent(dgMake, Self, 'OnGetCellProperties', 'dgMakeGetCellProperties');
    dgMake.RowCount := 1;
    dgdaMake.SetParentComponent(dgMake);
    dgdaMake.Name := 'dgdaMake';
    dgdaMake.Left := 72;
    dgdaMake.Top := 72;
    dgdaMake.Width := 26;
    dgdaMake.Height := 26;
    dgdaMake.Visible := True;
    dgdaMake.Columns.Clear;
    with dgdaMake.Columns.Add do
    begin
      FieldName := 'Description';
      Header := 'Description';
      AutoCreated := False;
    end;
    with dgdaMake.Columns.Add do
    begin
      FieldName := 'Selected';
      Header := 'Selected';
      AutoCreated := False;
    end;
    dgdaMake.DataSource := dsMake;
    WebSpeedButton8.SetParentComponent(WebPanel48);
    WebSpeedButton8.Name := 'WebSpeedButton8';
    WebSpeedButton8.Left := 0;
    WebSpeedButton8.Top := 146;
    WebSpeedButton8.Width := 250;
    WebSpeedButton8.Height := 24;
    WebSpeedButton8.Align := alBottom;
    WebSpeedButton8.Caption := 'Clear';
    WebSpeedButton8.Color := clNone;
    WebSpeedButton8.HeightPercent := 100.000000000000000000;
    WebSpeedButton8.TabOrder := 1;
    WebSpeedButton8.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton8, Self, 'OnClick', 'WebSpeedButton8Click');
    WebPageControl1Sheet2.SetParentComponent(WebPageControl1);
    WebPageControl1Sheet2.Name := 'WebPageControl1Sheet2';
    WebPageControl1Sheet2.Left := 0;
    WebPageControl1Sheet2.Top := 20;
    WebPageControl1Sheet2.Width := 1782;
    WebPageControl1Sheet2.Height := 405;
    WebPageControl1Sheet2.Caption := 'Detail';
    WebPageControl1Sheet2.ChildOrder := 1;
    pDashData.SetParentComponent(WebPageControl1Sheet2);
    pDashData.Name := 'pDashData';
    pDashData.Left := 0;
    pDashData.Top := 0;
    pDashData.Width := 1782;
    pDashData.Height := 405;
    pDashData.WidthStyle := ssPercent;
    pDashData.WidthPercent := 99.000000000000000000;
    pDashData.Align := alClient;
    pDashData.Caption := 'pDashData';
    pDashData.ChildOrder := 3;
    pDashData.TabOrder := 0;
    dgDashData.SetParentComponent(pDashData);
    dgDashData.Name := 'dgDashData';
    dgDashData.Left := 0;
    dgDashData.Top := 0;
    dgDashData.Width := 1782;
    dgDashData.Height := 405;
    dgDashData.Align := alClient;
    dgDashData.ParentDoubleBuffered := False;
    dgDashData.DoubleBuffered := True;
    dgDashData.TabOrder := 0;
    dgDashData.ShowAcceleratorChar := False;
    dgDashData.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgDashData.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgDashData.Header.VisualGrouping.Layout.Font.Height := -12;
    dgDashData.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgDashData.Header.VisualGrouping.Layout.Font.Style := [];
    dgDashData.Adapter := dgdaDashData;
    dgDashData.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgDashData.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgDashData.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgDashData.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgDashData.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgDashData.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgDashData.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgDashData.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgDashData.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgDashData.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgDashData.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgDashData.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgDashData.CellAppearance.BandLayout.Font.Height := -12;
    dgDashData.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgDashData.CellAppearance.BandLayout.Font.Style := [];
    dgDashData.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgDashData.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgDashData.CellAppearance.FixedLayout.Font.Height := -12;
    dgDashData.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgDashData.CellAppearance.FixedLayout.Font.Style := [];
    dgDashData.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgDashData.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgDashData.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgDashData.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgDashData.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgDashData.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgDashData.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgDashData.CellAppearance.FocusedLayout.Font.Height := -12;
    dgDashData.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgDashData.CellAppearance.FocusedLayout.Font.Style := [];
    dgDashData.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgDashData.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgDashData.CellAppearance.GroupLayout.Font.Height := -12;
    dgDashData.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgDashData.CellAppearance.GroupLayout.Font.Style := [];
    dgDashData.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgDashData.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgDashData.CellAppearance.NormalLayout.Font.Height := -12;
    dgDashData.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgDashData.CellAppearance.NormalLayout.Font.Style := [];
    dgDashData.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgDashData.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgDashData.CellAppearance.SelectedLayout.Font.Height := -12;
    dgDashData.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgDashData.CellAppearance.SelectedLayout.Font.Style := [];
    dgDashData.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgDashData.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgDashData.CellAppearance.SummaryLayout.Font.Height := -12;
    dgDashData.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgDashData.CellAppearance.SummaryLayout.Font.Style := [];
    dgDashData.ColumnCount := 14;
    dgDashData.Columns.Clear;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Vehichle Type ';
      Settings := [gcsReadOnly,gcsControlWidth];
      Width := 100.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Fleet No';
      Settings := [gcsReadOnly,gcsControlWidth];
      Width := 127.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Jobcard Date';
      Settings := [gcsReadOnly,gcsControlWidth];
      Width := 127.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Job No';
      Settings := [gcsReadOnly,gcsControlWidth];
      Width := 127.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Order No';
      Settings := [gcsReadOnly,gcsControlWidth];
      Width := 127.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Ref No';
      Settings := [gcsControlWidth];
      Width := 127.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Cost Category';
      Settings := [gcsControlWidth];
      Width := 200.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'GL Code';
      Settings := [gcsControlWidth];
      Width := 85.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Cost Description';
      Width := 150.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Stock Description';
      Settings := [gcsControlWidth];
      Width := 400.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Total Excl';
      Settings := [gcsControlWidth];
      Width := 127.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Job Type';
      Settings := [gcsControlWidth];
      Width := 127.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Supplier';
      Settings := [gcsControlWidth];
      Width := 200.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Comment';
      Settings := [gcsControlWidth];
      Width := 131.000000000000000000;
    end;
    dgDashData.ColumnViewMode := gcvmControl;
    dgDashData.DefaultColumnWidth := 250.000000000000000000;
    dgDashData.Designer := False;
    dgDashData.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgDashData.FilterAppearance.Font.Color := clWindowText;
    dgDashData.FilterAppearance.Font.Height := -12;
    dgDashData.FilterAppearance.Font.Name := 'Segoe UI';
    dgDashData.FilterAppearance.Font.Style := [];
    dgDashData.Icons.ExpandIcon.LoadFromFile('dashboard.maintenance.pDashData.dgDashData.Icons.ExpandIcon.svg');
    dgDashData.Icons.CollapseIcon.LoadFromFile('dashboard.maintenance.pDashData.dgDashData.Icons.CollapseIcon.svg');
    dgDashData.Icons.FilterIcon.LoadFromFile('dashboard.maintenance.pDashData.dgDashData.Icons.FilterIcon.svg');
    dgDashData.Icons.FilterActiveIcon.LoadFromFile('dashboard.maintenance.pDashData.dgDashData.Icons.FilterActiveIcon.svg');
    dgDashData.Icons.FilterClearIcon.LoadFromFile('dashboard.maintenance.pDashData.dgDashData.Icons.FilterClearIcon.svg');
    dgDashData.Icons.FilterTypeIcon.LoadFromFile('dashboard.maintenance.pDashData.dgDashData.Icons.FilterTypeIcon.svg');
    dgDashData.Icons.SortAscendingIcon.LoadFromFile('dashboard.maintenance.pDashData.dgDashData.Icons.SortAscendingIcon.svg');
    dgDashData.Icons.SortDescendingIcon.LoadFromFile('dashboard.maintenance.pDashData.dgDashData.Icons.SortDescendingIcon.svg');
    dgDashData.Icons.CloseIcon.LoadFromFile('dashboard.maintenance.pDashData.dgDashData.Icons.CloseIcon.svg');
    dgDashData.Options.Sorting.Enabled := True;
    dgDashData.Options.Column.Stretching.Range := gstrAll;
    dgDashData.Options.Column.FixedAutoCheckAll := False;
    dgDashData.Options.Editing.Enabled := False;
    dgDashData.RowCount := 1;
    dgDashData.StretchScrollBars := True;
    dgdaDashData.SetParentComponent(dgDashData);
    dgdaDashData.Name := 'dgdaDashData';
    dgdaDashData.Left := 331;
    dgdaDashData.Top := 104;
    dgdaDashData.Width := 26;
    dgdaDashData.Height := 26;
    dgdaDashData.Visible := True;
    dgdaDashData.AutoCreateColumns := False;
    dgdaDashData.AutoRemoveColumns := False;
    dgdaDashData.Columns.Clear;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'Vehtype';
      Header := 'Vehichle Type ';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'TFleetNo';
      Header := 'Fleet No';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'JobDate';
      Header := 'Jobcard Date';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'JobcardNo';
      Header := 'Job No';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'OrderNo';
      Header := 'Order No';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'ReferenceNo';
      Header := 'Ref No';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'Category';
      Header := 'Cost Category';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'GlCode';
      Header := 'GL Code';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'CostDescription';
      Header := 'Cost Description';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'StockDescription';
      Header := 'Stock Description';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'TotalExcl';
      Header := 'Total Excl';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'JobType';
      Header := 'Job Type';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'Supplier';
      Header := 'Supplier';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'Reason';
      Header := 'Comment';
      AutoCreated := False;
    end;
    dgdaDashData.DataSource := dsDashData;
    dgdaDashData.LoadMode := almAllRecords;
    BitmapContainer1.SetParentComponent(dgDashData);
    BitmapContainer1.Name := 'BitmapContainer1';
    BitmapContainer1.Left := 407;
    BitmapContainer1.Top := 56;
    BitmapContainer1.Width := 26;
    BitmapContainer1.Height := 26;
    BitmapContainer1.Visible := True;
    BitmapContainer1.Items.Clear;
    with BitmapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('dashboard.maintenance.BitmapContainer1.Items.Bitmap.png');
      Name := 'green-switch.png';
      Tag := 0;
    end;
    with BitmapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('dashboard.maintenance.BitmapContainer1.Items.Bitmap_1.png');
      Name := 'red-switch.png';
      Tag := 0;
    end;
    with BitmapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('dashboard.maintenance.BitmapContainer1.Items.Bitmap.svg');
      Name := 'green-switch.svg';
      Tag := 0;
    end;
    with BitmapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('dashboard.maintenance.BitmapContainer1.Items.Bitmap_1.svg');
      Name := 'red-switch.svg';
      Tag := 0;
    end;
    WebPageControl1Sheet1.SetParentComponent(WebPageControl1);
    WebPageControl1Sheet1.Name := 'WebPageControl1Sheet1';
    WebPageControl1Sheet1.Left := 0;
    WebPageControl1Sheet1.Top := 20;
    WebPageControl1Sheet1.Width := 1782;
    WebPageControl1Sheet1.Height := 405;
    WebPageControl1Sheet1.Caption := 'Trends';
    WebPanel2.SetParentComponent(WebPageControl1Sheet1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 1782;
    WebPanel2.Height := 405;
    WebPanel2.Align := alClient;
    WebPanel2.Caption := 'WebPanel2';
    WebPanel2.TabOrder := 0;
    wcYears.SetParentComponent(Self);
    wcYears.Name := 'wcYears';
    wcYears.Connection := dmData.dbConnect;
    wcYears.Left := 1288;
    wcYears.Top := 352;
    wdsYears.SetParentComponent(Self);
    wdsYears.Name := 'wdsYears';
    wdsYears.AfterPost := wdsYearsAfterPost;
    wdsYears.Connection := dmData.dbConnect;
    wdsYears.Left := 1208;
    wdsYears.Top := 264;
    wdsYearsSelected.SetParentComponent(wdsYears);
    wdsYearsSelected.Name := 'wdsYearsSelected';
    wdsYearsSelected.FieldName := 'Selected';
    wdsYearsYear.SetParentComponent(wdsYears);
    wdsYearsYear.Name := 'wdsYearsYear';
    wdsYearsYear.FieldName := 'Year';
    dsYears.SetParentComponent(Self);
    dsYears.Name := 'dsYears';
    dsYears.AutoEdit := False;
    dsYears.DataSet := wdsYears;
    dsYears.Left := 1208;
    dsYears.Top := 328;
    wcMonths.SetParentComponent(Self);
    wcMonths.Name := 'wcMonths';
    wcMonths.Connection := dmData.dbConnect;
    wcMonths.Left := 1209;
    wcMonths.Top := 392;
    wdsMonths.SetParentComponent(Self);
    wdsMonths.Name := 'wdsMonths';
    wdsMonths.AfterPost := wdsMonthsAfterPost;
    wdsMonths.Connection := dmData.dbConnect;
    wdsMonths.Left := 1281;
    wdsMonths.Top := 280;
    wdsMonthsMonth.SetParentComponent(wdsMonths);
    wdsMonthsMonth.Name := 'wdsMonthsMonth';
    wdsMonthsMonth.FieldName := 'Month';
    wdsMonthsMonthName.SetParentComponent(wdsMonths);
    wdsMonthsMonthName.Name := 'wdsMonthsMonthName';
    wdsMonthsMonthName.FieldName := 'MonthName';
    wdsMonthsSelected.SetParentComponent(wdsMonths);
    wdsMonthsSelected.Name := 'wdsMonthsSelected';
    wdsMonthsSelected.FieldName := 'Selected';
    dsMonths.SetParentComponent(Self);
    dsMonths.Name := 'dsMonths';
    dsMonths.AutoEdit := False;
    dsMonths.DataSet := wdsMonths;
    dsMonths.Left := 1297;
    dsMonths.Top := 416;
    wcReg.SetParentComponent(Self);
    wcReg.Name := 'wcReg';
    wcReg.Connection := dmData.dbConnect;
    wcReg.Left := 1130;
    wcReg.Top := 272;
    wdsReg.SetParentComponent(Self);
    wdsReg.Name := 'wdsReg';
    wdsReg.Connection := dmData.dbConnect;
    wdsReg.Left := 1058;
    wdsReg.Top := 328;
    wdsRegReg.SetParentComponent(wdsReg);
    wdsRegReg.Name := 'wdsRegReg';
    wdsRegReg.FieldName := 'Reg';
    wdsRegFleetNo.SetParentComponent(wdsReg);
    wdsRegFleetNo.Name := 'wdsRegFleetNo';
    wdsRegFleetNo.FieldName := 'FleetNo';
    wdsRegFleetType.SetParentComponent(wdsReg);
    wdsRegFleetType.Name := 'wdsRegFleetType';
    wdsRegFleetType.FieldName := 'FleetType';
    wdsRegSelected.SetParentComponent(wdsReg);
    wdsRegSelected.Name := 'wdsRegSelected';
    wdsRegSelected.FieldName := 'Selected';
    wdsRegPriKey.SetParentComponent(wdsReg);
    wdsRegPriKey.Name := 'wdsRegPriKey';
    wdsRegPriKey.FieldName := 'PriKey';
    dsReg.SetParentComponent(Self);
    dsReg.Name := 'dsReg';
    dsReg.AutoEdit := False;
    dsReg.DataSet := wdsReg;
    dsReg.Left := 1058;
    dsReg.Top := 376;
    WebTimer1.SetParentComponent(Self);
    WebTimer1.Name := 'WebTimer1';
    WebTimer1.Enabled := False;
    SetEvent(WebTimer1, Self, 'OnTimer', 'WebTimer1Timer');
    WebTimer1.Left := 584;
    WebTimer1.Top := 313;
    wdsTempReg.SetParentComponent(Self);
    wdsTempReg.Name := 'wdsTempReg';
    wdsTempReg.Connection := dmData.dbConnect;
    wdsTempReg.Left := 1058;
    wdsTempReg.Top := 272;
    StringField1.SetParentComponent(wdsTempReg);
    StringField1.Name := 'StringField1';
    StringField1.FieldName := 'Reg';
    StringField2.SetParentComponent(wdsTempReg);
    StringField2.Name := 'StringField2';
    StringField2.FieldName := 'FleetNo';
    StringField3.SetParentComponent(wdsTempReg);
    StringField3.Name := 'StringField3';
    StringField3.FieldName := 'FleetType';
    BooleanField1.SetParentComponent(wdsTempReg);
    BooleanField1.Name := 'BooleanField1';
    BooleanField1.FieldName := 'Selected';
    IntegerField1.SetParentComponent(wdsTempReg);
    IntegerField1.Name := 'IntegerField1';
    IntegerField1.FieldName := 'PriKey';
    dsSysTypes.SetParentComponent(Self);
    dsSysTypes.Name := 'dsSysTypes';
    dsSysTypes.AutoEdit := False;
    dsSysTypes.DataSet := wdsSysTypes;
    dsSysTypes.Left := 1561;
    dsSysTypes.Top := 145;
    wcSysTypes.SetParentComponent(Self);
    wcSysTypes.Name := 'wcSysTypes';
    wcSysTypes.Connection := dmData.dbConnect;
    wcSysTypes.Left := 1553;
    wcSysTypes.Top := 89;
    wdsSysTypes.SetParentComponent(Self);
    wdsSysTypes.Name := 'wdsSysTypes';
    wdsSysTypes.AfterPost := wdsSysTypesAfterPost;
    wdsSysTypes.Connection := dmData.dbConnect;
    wdsSysTypes.Left := 1553;
    wdsSysTypes.Top := 201;
    wdsSysTypesSelected.SetParentComponent(wdsSysTypes);
    wdsSysTypesSelected.Name := 'wdsSysTypesSelected';
    wdsSysTypesSelected.FieldName := 'Selected';
    wdsSysTypesSysType.SetParentComponent(wdsSysTypes);
    wdsSysTypesSysType.Name := 'wdsSysTypesSysType';
    wdsSysTypesSysType.FieldName := 'SysType';
    wdsSysTypesDescription.SetParentComponent(wdsSysTypes);
    wdsSysTypesDescription.Name := 'wdsSysTypesDescription';
    wdsSysTypesDescription.FieldName := 'Description';
    wdsCostGroups.SetParentComponent(Self);
    wdsCostGroups.Name := 'wdsCostGroups';
    wdsCostGroups.AfterPost := wdsCostGroupsAfterPost;
    wdsCostGroups.Connection := dmData.dbConnect;
    wdsCostGroups.Left := 1209;
    wdsCostGroups.Top := 208;
    wdsCostGroupsselected.SetParentComponent(wdsCostGroups);
    wdsCostGroupsselected.Name := 'wdsCostGroupsselected';
    wdsCostGroupsselected.FieldName := 'Selected';
    wdsCostGroupsCost.SetParentComponent(wdsCostGroups);
    wdsCostGroupsCost.Name := 'wdsCostGroupsCost';
    wdsCostGroupsCost.FieldName := 'Cost';
    wdsCostGroupsDescription.SetParentComponent(wdsCostGroups);
    wdsCostGroupsDescription.Name := 'wdsCostGroupsDescription';
    wdsCostGroupsDescription.FieldName := 'Description';
    dsCostGroups.SetParentComponent(Self);
    dsCostGroups.Name := 'dsCostGroups';
    dsCostGroups.DataSet := wdsCostGroups;
    dsCostGroups.Left := 1225;
    dsCostGroups.Top := 144;
    wcCostGroups.SetParentComponent(Self);
    wcCostGroups.Name := 'wcCostGroups';
    wcCostGroups.Connection := dmData.dbConnect;
    wcCostGroups.Left := 1217;
    wcCostGroups.Top := 80;
    wdsDashData.SetParentComponent(Self);
    wdsDashData.Name := 'wdsDashData';
    wdsDashData.AfterOpen := wdsDashDataAfterOpen;
    wdsDashData.Connection := dmData.dbConnect;
    wdsDashData.Left := 1376;
    wdsDashData.Top := 376;
    wdsDashDataJobcardNo.SetParentComponent(wdsDashData);
    wdsDashDataJobcardNo.Name := 'wdsDashDataJobcardNo';
    wdsDashDataJobcardNo.FieldName := 'JobcardNo';
    wdsDashDataStockDescription.SetParentComponent(wdsDashData);
    wdsDashDataStockDescription.Name := 'wdsDashDataStockDescription';
    wdsDashDataStockDescription.FieldName := 'StockDescription';
    wdsDashDataTotalExcl.SetParentComponent(wdsDashData);
    wdsDashDataTotalExcl.Name := 'wdsDashDataTotalExcl';
    wdsDashDataTotalExcl.FieldName := 'TotalExcl';
    wdsDashDataGlCode.SetParentComponent(wdsDashData);
    wdsDashDataGlCode.Name := 'wdsDashDataGlCode';
    wdsDashDataGlCode.FieldName := 'GlCode';
    wdsDashDataReason.SetParentComponent(wdsDashData);
    wdsDashDataReason.Name := 'wdsDashDataReason';
    wdsDashDataReason.FieldName := 'Reason';
    wdsDashDataCategory.SetParentComponent(wdsDashData);
    wdsDashDataCategory.Name := 'wdsDashDataCategory';
    wdsDashDataCategory.FieldName := 'Category';
    wdsDashDataRepMain.SetParentComponent(wdsDashData);
    wdsDashDataRepMain.Name := 'wdsDashDataRepMain';
    wdsDashDataRepMain.FieldName := 'RepMain';
    wdsDashDataCostDescription.SetParentComponent(wdsDashData);
    wdsDashDataCostDescription.Name := 'wdsDashDataCostDescription';
    wdsDashDataCostDescription.FieldName := 'CostDescription';
    wdsDashDataTRegNo.SetParentComponent(wdsDashData);
    wdsDashDataTRegNo.Name := 'wdsDashDataTRegNo';
    wdsDashDataTRegNo.FieldName := 'TRegNo';
    wdsDashDataTFleetNo.SetParentComponent(wdsDashData);
    wdsDashDataTFleetNo.Name := 'wdsDashDataTFleetNo';
    wdsDashDataTFleetNo.FieldName := 'TFleetNo';
    wdsDashDataOrderNo.SetParentComponent(wdsDashData);
    wdsDashDataOrderNo.Name := 'wdsDashDataOrderNo';
    wdsDashDataOrderNo.FieldName := 'OrderNo';
    wdsDashDataJobDate.SetParentComponent(wdsDashData);
    wdsDashDataJobDate.Name := 'wdsDashDataJobDate';
    wdsDashDataJobDate.FieldName := 'JobDate';
    wdsDashDataReferenceNo.SetParentComponent(wdsDashData);
    wdsDashDataReferenceNo.Name := 'wdsDashDataReferenceNo';
    wdsDashDataReferenceNo.FieldName := 'ReferenceNo';
    wdsDashDataVehType.SetParentComponent(wdsDashData);
    wdsDashDataVehType.Name := 'wdsDashDataVehType';
    wdsDashDataVehType.FieldName := 'Vehtype';
    wdsDashDataJobType.SetParentComponent(wdsDashData);
    wdsDashDataJobType.Name := 'wdsDashDataJobType';
    wdsDashDataJobType.FieldName := 'JobType';
    wdsDashDataSupplier.SetParentComponent(wdsDashData);
    wdsDashDataSupplier.Name := 'wdsDashDataSupplier';
    wdsDashDataSupplier.FieldName := 'Supplier';
    wcDashboardSums.SetParentComponent(Self);
    wcDashboardSums.Name := 'wcDashboardSums';
    wcDashboardSums.Connection := dmData.dbConnect;
    wcDashboardSums.Left := 1488;
    wcDashboardSums.Top := 281;
    dsDashBoardSums.SetParentComponent(Self);
    dsDashBoardSums.Name := 'dsDashBoardSums';
    dsDashBoardSums.AutoEdit := False;
    dsDashBoardSums.DataSet := wdsDashboardSums;
    dsDashBoardSums.Left := 1488;
    dsDashBoardSums.Top := 337;
    wcDashData.SetParentComponent(Self);
    wcDashData.Name := 'wcDashData';
    wcDashData.Connection := dmData.dbConnect;
    wcDashData.Left := 1384;
    wcDashData.Top := 264;
    dsDashData.SetParentComponent(Self);
    dsDashData.Name := 'dsDashData';
    dsDashData.DataSet := wdsDashData;
    dsDashData.Left := 1376;
    dsDashData.Top := 320;
    wdsSuppliers.SetParentComponent(Self);
    wdsSuppliers.Name := 'wdsSuppliers';
    wdsSuppliers.AfterPost := wdsSuppliersAfterPost;
    wdsSuppliers.Connection := dmData.dbConnect;
    wdsSuppliers.Left := 1300;
    wdsSuppliers.Top := 192;
    wdsSuppliersCrName.SetParentComponent(wdsSuppliers);
    wdsSuppliersCrName.Name := 'wdsSuppliersCrName';
    wdsSuppliersCrName.FieldName := 'CrName';
    wdsSuppliersCrNumber.SetParentComponent(wdsSuppliers);
    wdsSuppliersCrNumber.Name := 'wdsSuppliersCrNumber';
    wdsSuppliersCrNumber.FieldName := 'CrNumber';
    wdsSuppliersSelected.SetParentComponent(wdsSuppliers);
    wdsSuppliersSelected.Name := 'wdsSuppliersSelected';
    wdsSuppliersSelected.FieldName := 'Selected';
    wcSuppliers.SetParentComponent(Self);
    wcSuppliers.Name := 'wcSuppliers';
    wcSuppliers.Connection := dmData.dbConnect;
    wcSuppliers.Left := 1308;
    wcSuppliers.Top := 80;
    dsSuppliers.SetParentComponent(Self);
    dsSuppliers.Name := 'dsSuppliers';
    dsSuppliers.DataSet := wdsSuppliers;
    dsSuppliers.Left := 1308;
    dsSuppliers.Top := 136;
    wdsVehGroups.SetParentComponent(Self);
    wdsVehGroups.Name := 'wdsVehGroups';
    wdsVehGroups.Connection := dmData.dbConnect;
    wdsVehGroups.Left := 1484;
    wdsVehGroups.Top := 208;
    wdsVehGroupsDescription.SetParentComponent(wdsVehGroups);
    wdsVehGroupsDescription.Name := 'wdsVehGroupsDescription';
    wdsVehGroupsDescription.FieldName := 'Description';
    wdsVehGroupsSelected.SetParentComponent(wdsVehGroups);
    wdsVehGroupsSelected.Name := 'wdsVehGroupsSelected';
    wdsVehGroupsSelected.FieldName := 'Selected';
    wdsVehGroupsSysType.SetParentComponent(wdsVehGroups);
    wdsVehGroupsSysType.Name := 'wdsVehGroupsSysType';
    wdsVehGroupsSysType.FieldName := 'SysType';
    wcVehGroups.SetParentComponent(Self);
    wcVehGroups.Name := 'wcVehGroups';
    wcVehGroups.Connection := dmData.dbConnect;
    wcVehGroups.Left := 1476;
    wcVehGroups.Top := 88;
    dsVehGroups.SetParentComponent(Self);
    dsVehGroups.Name := 'dsVehGroups';
    dsVehGroups.DataSet := wdsVehGroups;
    dsVehGroups.Left := 1484;
    dsVehGroups.Top := 144;
    wcUnitType.SetParentComponent(Self);
    wcUnitType.Name := 'wcUnitType';
    wcUnitType.Connection := dmData.dbConnect;
    wcUnitType.Left := 1389;
    wcUnitType.Top := 71;
    dsUnitType.SetParentComponent(Self);
    dsUnitType.Name := 'dsUnitType';
    dsUnitType.DataSet := wdsUnitType;
    dsUnitType.Left := 1389;
    dsUnitType.Top := 127;
    wdsUnitType.SetParentComponent(Self);
    wdsUnitType.Name := 'wdsUnitType';
    wdsUnitType.Connection := dmData.dbConnect;
    wdsUnitType.Left := 1389;
    wdsUnitType.Top := 183;
    wdsUnitTypeSysType.SetParentComponent(wdsUnitType);
    wdsUnitTypeSysType.Name := 'wdsUnitTypeSysType';
    wdsUnitTypeSysType.FieldName := 'SysType';
    wdsUnitTypeDescription.SetParentComponent(wdsUnitType);
    wdsUnitTypeDescription.Name := 'wdsUnitTypeDescription';
    wdsUnitTypeDescription.FieldName := 'Description';
    wdsUnitTypeSelected.SetParentComponent(wdsUnitType);
    wdsUnitTypeSelected.Name := 'wdsUnitTypeSelected';
    wdsUnitTypeSelected.FieldName := 'Selected';
    dsMake.SetParentComponent(Self);
    dsMake.Name := 'dsMake';
    dsMake.DataSet := wdsMake;
    dsMake.Left := 1616;
    dsMake.Top := 287;
    wdsMake.SetParentComponent(Self);
    wdsMake.Name := 'wdsMake';
    wdsMake.Connection := dmData.dbConnect;
    wdsMake.Left := 1616;
    wdsMake.Top := 343;
    wdsMakeDescription.SetParentComponent(wdsMake);
    wdsMakeDescription.Name := 'wdsMakeDescription';
    wdsMakeDescription.FieldName := 'Description';
    wdsMakeSelected.SetParentComponent(wdsMake);
    wdsMakeSelected.Name := 'wdsMakeSelected';
    wdsMakeSelected.FieldName := 'Selected';
    wcMake.SetParentComponent(Self);
    wcMake.Name := 'wcMake';
    wcMake.Connection := dmData.dbConnect;
    wcMake.Left := 1608;
    wcMake.Top := 407;
    dsMaintGroup.SetParentComponent(Self);
    dsMaintGroup.Name := 'dsMaintGroup';
    dsMaintGroup.DataSet := wdsMaintGroup;
    dsMaintGroup.Left := 1648;
    dsMaintGroup.Top := 71;
    wdsMaintGroup.SetParentComponent(Self);
    wdsMaintGroup.Name := 'wdsMaintGroup';
    wdsMaintGroup.Connection := dmData.dbConnect;
    wdsMaintGroup.Left := 1648;
    wdsMaintGroup.Top := 127;
    wdsMaintGroupSelected.SetParentComponent(wdsMaintGroup);
    wdsMaintGroupSelected.Name := 'wdsMaintGroupSelected';
    wdsMaintGroupSelected.FieldName := 'Selected';
    wdsMaintGroupSysType.SetParentComponent(wdsMaintGroup);
    wdsMaintGroupSysType.Name := 'wdsMaintGroupSysType';
    wdsMaintGroupSysType.FieldName := 'SysType';
    wdsMaintGroupDescription.SetParentComponent(wdsMaintGroup);
    wdsMaintGroupDescription.Name := 'wdsMaintGroupDescription';
    wdsMaintGroupDescription.FieldName := 'Description';
    wcMaintGroup.SetParentComponent(Self);
    wcMaintGroup.Name := 'wcMaintGroup';
    wcMaintGroup.Connection := dmData.dbConnect;
    wcMaintGroup.Left := 1640;
    wcMaintGroup.Top := 191;
    wdsFinYears.SetParentComponent(Self);
    wdsFinYears.Name := 'wdsFinYears';
    wdsFinYears.Connection := dmData.dbConnect;
    wdsFinYears.Left := 1128;
    wdsFinYears.Top := 399;
    wdsFinYearsSelected.SetParentComponent(wdsFinYears);
    wdsFinYearsSelected.Name := 'wdsFinYearsSelected';
    wdsFinYearsSelected.FieldName := 'Selected';
    wdsFinYearsYear.SetParentComponent(wdsFinYears);
    wdsFinYearsYear.Name := 'wdsFinYearsYear';
    wdsFinYearsYear.FieldName := 'Year';
    wcFinYears.SetParentComponent(Self);
    wcFinYears.Name := 'wcFinYears';
    wcFinYears.Left := 1120;
    wcFinYears.Top := 463;
    dsFinYears.SetParentComponent(Self);
    dsFinYears.Name := 'dsFinYears';
    dsFinYears.DataSet := wdsFinYears;
    dsFinYears.Left := 1128;
    dsFinYears.Top := 343;
    dsServiceTypes.SetParentComponent(Self);
    dsServiceTypes.Name := 'dsServiceTypes';
    dsServiceTypes.DataSet := wdsServiceTypes;
    dsServiceTypes.Left := 1680;
    dsServiceTypes.Top := 298;
    wdsServiceTypes.SetParentComponent(Self);
    wdsServiceTypes.Name := 'wdsServiceTypes';
    wdsServiceTypes.Connection := dmData.dbConnect;
    wdsServiceTypes.Left := 1688;
    wdsServiceTypes.Top := 362;
    wdsServiceTypesSelected.SetParentComponent(wdsServiceTypes);
    wdsServiceTypesSelected.Name := 'wdsServiceTypesSelected';
    wdsServiceTypesSelected.FieldName := 'Selected';
    wdsServiceTypesSystype.SetParentComponent(wdsServiceTypes);
    wdsServiceTypesSystype.Name := 'wdsServiceTypesSystype';
    wdsServiceTypesSystype.FieldName := 'Systype';
    wdsServiceTypesDescription.SetParentComponent(wdsServiceTypes);
    wdsServiceTypesDescription.Name := 'wdsServiceTypesDescription';
    wdsServiceTypesDescription.FieldName := 'Description';
    wcServiceTypes.SetParentComponent(Self);
    wcServiceTypes.Name := 'wcServiceTypes';
    wcServiceTypes.Connection := dmData.dbConnect;
    wcServiceTypes.Left := 1688;
    wcServiceTypes.Top := 426;
    wdsDashboardSums.SetParentComponent(Self);
    wdsDashboardSums.Name := 'wdsDashboardSums';
    wdsDashboardSums.AfterOpen := wdsDashboardSumsAfterOpen;
    wdsDashboardSums.Connection := dmData.dbConnect;
    wdsDashboardSums.Left := 1488;
    wdsDashboardSums.Top := 394;
    wdsDashboardSumsMaintenanceCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsMaintenanceCost.Name := 'wdsDashboardSumsMaintenanceCost';
    wdsDashboardSumsMaintenanceCost.FieldName := 'MaintenanceCost';
    wdsDashboardSumsMaintenanceCost.DisplayFormat := '#,#0.00';
    wdsDashboardSumsTyreCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsTyreCost.Name := 'wdsDashboardSumsTyreCost';
    wdsDashboardSumsTyreCost.FieldName := 'TyreCost';
    wdsDashboardSumsTyreCost.DisplayFormat := '#,#0.00';
    wdsDashboardSumsWashCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsWashCost.Name := 'wdsDashboardSumsWashCost';
    wdsDashboardSumsWashCost.FieldName := 'WashCost';
    wdsDashboardSumsWashCost.DisplayFormat := '#,#0.00';
    wdsDashboardSumsInsuranceCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsInsuranceCost.Name := 'wdsDashboardSumsInsuranceCost';
    wdsDashboardSumsInsuranceCost.FieldName := 'InsuranceCost';
    wdsDashboardSumsInsuranceCost.DisplayFormat := '#,#0.00';
    wdsDashboardSumsOtherCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsOtherCost.Name := 'wdsDashboardSumsOtherCost';
    wdsDashboardSumsOtherCost.FieldName := 'OtherCost';
    wdsDashboardSumsOtherCost.DisplayFormat := '#,#0.00';
    wdsDashboardSumsTotalCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsTotalCost.Name := 'wdsDashboardSumsTotalCost';
    wdsDashboardSumsTotalCost.FieldName := 'TotalCost';
    wdsDashboardSumsTotalCost.DisplayFormat := '#,#0.00';
    wdsDashboardSumsCapexCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsCapexCost.Name := 'wdsDashboardSumsCapexCost';
    wdsDashboardSumsCapexCost.FieldName := 'CapexCost';
    wdsDashboardSumsCapexCost.DisplayFormat := '#,#0.00';
    wdsDashboardSumsUnallCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsUnallCost.Name := 'wdsDashboardSumsUnallCost';
    wdsDashboardSumsUnallCost.FieldName := 'UnallCost';
    wdsDashboardSumsUnallCost.DisplayFormat := '#,#0.00';
    wdsDashboardSumsNotLinkedCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsNotLinkedCost.Name := 'wdsDashboardSumsNotLinkedCost';
    wdsDashboardSumsNotLinkedCost.FieldName := 'NotLinkedCost';
    wdsDashboardSumsNotLinkedCost.DisplayFormat := '#,#0.00';
    wdsDashboardSumsMaintenanceCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsMaintenanceCPK.Name := 'wdsDashboardSumsMaintenanceCPK';
    wdsDashboardSumsMaintenanceCPK.FieldName := 'MaintenanceCPK';
    wdsDashboardSumsMaintenanceCPK.DisplayFormat := '#,#0.00';
    wdsDashboardSumsTyreCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsTyreCPK.Name := 'wdsDashboardSumsTyreCPK';
    wdsDashboardSumsTyreCPK.FieldName := 'TyreCPK';
    wdsDashboardSumsTyreCPK.DisplayFormat := '#,#0.00';
    wdsDashboardSumsWashCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsWashCPK.Name := 'wdsDashboardSumsWashCPK';
    wdsDashboardSumsWashCPK.FieldName := 'WashCPK';
    wdsDashboardSumsWashCPK.DisplayFormat := '#,#0.00';
    wdsDashboardSumsInsuranceCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsInsuranceCPK.Name := 'wdsDashboardSumsInsuranceCPK';
    wdsDashboardSumsInsuranceCPK.FieldName := 'InsuranceCPK';
    wdsDashboardSumsInsuranceCPK.DisplayFormat := '#,#0.00';
    wdsDashboardSumsOtherCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsOtherCPK.Name := 'wdsDashboardSumsOtherCPK';
    wdsDashboardSumsOtherCPK.FieldName := 'OtherCPK';
    wdsDashboardSumsOtherCPK.DisplayFormat := '#,#0.00';
    wdsDashboardSumsTotalCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsTotalCPK.Name := 'wdsDashboardSumsTotalCPK';
    wdsDashboardSumsTotalCPK.FieldName := 'TotalCPK';
    wdsDashboardSumsTotalCPK.DisplayFormat := '#,#0.00';
    wdsDashboardSumsCapexCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsCapexCPK.Name := 'wdsDashboardSumsCapexCPK';
    wdsDashboardSumsCapexCPK.FieldName := 'CapexCPK';
    wdsDashboardSumsCapexCPK.DisplayFormat := '#,#0.00';
    wdsDashboardSumsUnallCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsUnallCPK.Name := 'wdsDashboardSumsUnallCPK';
    wdsDashboardSumsUnallCPK.FieldName := 'UnallCPK';
    wdsDashboardSumsUnallCPK.DisplayFormat := '#,#0.00';
    wdsDashboardSumsNotLinkedCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsNotLinkedCPK.Name := 'wdsDashboardSumsNotLinkedCPK';
    wdsDashboardSumsNotLinkedCPK.FieldName := 'NotLinkedCPK';
    wdsDashboardSumsNotLinkedCPK.DisplayFormat := '#,#0.00';
    wdsDashboardSumsTotalkilo.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsTotalkilo.Name := 'wdsDashboardSumsTotalkilo';
    wdsDashboardSumsTotalkilo.FieldName := 'Totalkilo';
    wdsDashboardSumsTotalkilo.DisplayFormat := '#,#0.00';
  finally
    pTop.AfterLoadDFMValues;
    pBottom.AfterLoadDFMValues;
    pMain.AfterLoadDFMValues;
    wpDashSums.AfterLoadDFMValues;
    wpTotalCost.AfterLoadDFMValues;
    WebDBLabel1.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebDBLabel10.AfterLoadDFMValues;
    wpMaintenance.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebDBLabel2.AfterLoadDFMValues;
    WebDBLabel11.AfterLoadDFMValues;
    wpTyres.AfterLoadDFMValues;
    WebDBLabel5.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebDBLabel12.AfterLoadDFMValues;
    wpCost.AfterLoadDFMValues;
    WebDBLabel3.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebDBLabel9.AfterLoadDFMValues;
    wpInsurance.AfterLoadDFMValues;
    WebDBLabel4.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebDBLabel13.AfterLoadDFMValues;
    wpOperational.AfterLoadDFMValues;
    WebDBLabel6.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebDBLabel14.AfterLoadDFMValues;
    wbSearch.AfterLoadDFMValues;
    wpCapex.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebDBLabel7.AfterLoadDFMValues;
    WebDBLabel15.AfterLoadDFMValues;
    wpUnAll.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebDBLabel8.AfterLoadDFMValues;
    WebDBLabel16.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    wbExcel.AfterLoadDFMValues;
    wpNoLink.AfterLoadDFMValues;
    WebLabel17.AfterLoadDFMValues;
    WebDBLabel17.AfterLoadDFMValues;
    WebDBLabel18.AfterLoadDFMValues;
    WebPanel6.AfterLoadDFMValues;
    WebLabel22.AfterLoadDFMValues;
    WebDBLabel19.AfterLoadDFMValues;
    WebPageControl1.AfterLoadDFMValues;
    WebPageControl1Sheet3.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    pMainTop.AfterLoadDFMValues;
    pMainMonths.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebPanel19.AfterLoadDFMValues;
    dgMonths.AfterLoadDFMValues;
    dgdaMonths.AfterLoadDFMValues;
    btnMonthsClear.AfterLoadDFMValues;
    WebPanel21.AfterLoadDFMValues;
    WebPanel22.AfterLoadDFMValues;
    WebPanel23.AfterLoadDFMValues;
    pRegNo.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebPanel20.AfterLoadDFMValues;
    dgReg.AfterLoadDFMValues;
    dgdaReg.AfterLoadDFMValues;
    btnRegClear.AfterLoadDFMValues;
    WebPanel24.AfterLoadDFMValues;
    WebPanel25.AfterLoadDFMValues;
    WebPanel26.AfterLoadDFMValues;
    pFinYears.AfterLoadDFMValues;
    WebLabel19.AfterLoadDFMValues;
    WebPanel11.AfterLoadDFMValues;
    WebPanel12.AfterLoadDFMValues;
    WebPanel13.AfterLoadDFMValues;
    dgFinYears.AfterLoadDFMValues;
    dgdaFinYears.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    WebPanel14.AfterLoadDFMValues;
    pMainYears.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    dgYears.AfterLoadDFMValues;
    dgdaYears.AfterLoadDFMValues;
    WebPanel15.AfterLoadDFMValues;
    WebPanel16.AfterLoadDFMValues;
    WebPanel17.AfterLoadDFMValues;
    TMSFNCDataGrid1.AfterLoadDFMValues;
    TMSFNCDataGridDatabaseAdapter1.AfterLoadDFMValues;
    btnYearsClear.AfterLoadDFMValues;
    WebPanel18.AfterLoadDFMValues;
    pMaintGroups.AfterLoadDFMValues;
    WebLabel21.AfterLoadDFMValues;
    WebPanel7.AfterLoadDFMValues;
    WebPanel8.AfterLoadDFMValues;
    WebPanel9.AfterLoadDFMValues;
    WebPanel10.AfterLoadDFMValues;
    WebSpeedButton6.AfterLoadDFMValues;
    dgMaintGroups.AfterLoadDFMValues;
    dgdaMaintGroups.AfterLoadDFMValues;
    pMaintTypes.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebPanel27.AfterLoadDFMValues;
    dgSysTypes.AfterLoadDFMValues;
    dgdaSysTypes.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebPanel28.AfterLoadDFMValues;
    WebPanel29.AfterLoadDFMValues;
    WebPanel30.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    wpSuppliers.AfterLoadDFMValues;
    WebLabel18.AfterLoadDFMValues;
    WebPanel35.AfterLoadDFMValues;
    WebPanel36.AfterLoadDFMValues;
    WebPanel37.AfterLoadDFMValues;
    WebPanel38.AfterLoadDFMValues;
    dgSuppliers.AfterLoadDFMValues;
    dgdaSuppliers.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    wpVehGroups.AfterLoadDFMValues;
    WebLabel20.AfterLoadDFMValues;
    WebPanel45.AfterLoadDFMValues;
    WebPanel46.AfterLoadDFMValues;
    WebPanel47.AfterLoadDFMValues;
    WebPanel50.AfterLoadDFMValues;
    dgVehGroup.AfterLoadDFMValues;
    dgdaVehGroups.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    pCostGroups.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebPanel31.AfterLoadDFMValues;
    dgCostGroups.AfterLoadDFMValues;
    dgdaCostGroups.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebPanel32.AfterLoadDFMValues;
    WebPanel33.AfterLoadDFMValues;
    WebPanel34.AfterLoadDFMValues;
    WebPanel5.AfterLoadDFMValues;
    WebLabel23.AfterLoadDFMValues;
    WebPanel42.AfterLoadDFMValues;
    WebPanel43.AfterLoadDFMValues;
    WebPanel44.AfterLoadDFMValues;
    WebPanel49.AfterLoadDFMValues;
    dgUnitType.AfterLoadDFMValues;
    dgdaUnitType.AfterLoadDFMValues;
    TMSFNCDataGrid2.AfterLoadDFMValues;
    TMSFNCDataGridDatabaseAdapter2.AfterLoadDFMValues;
    WebSpeedButton7.AfterLoadDFMValues;
    pEquipMake.AfterLoadDFMValues;
    WebLabel24.AfterLoadDFMValues;
    WebPanel39.AfterLoadDFMValues;
    WebPanel40.AfterLoadDFMValues;
    WebPanel41.AfterLoadDFMValues;
    WebPanel48.AfterLoadDFMValues;
    dgMake.AfterLoadDFMValues;
    dgdaMake.AfterLoadDFMValues;
    WebSpeedButton8.AfterLoadDFMValues;
    WebPageControl1Sheet2.AfterLoadDFMValues;
    pDashData.AfterLoadDFMValues;
    dgDashData.AfterLoadDFMValues;
    dgdaDashData.AfterLoadDFMValues;
    BitmapContainer1.AfterLoadDFMValues;
    WebPageControl1Sheet1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    wcYears.AfterLoadDFMValues;
    wdsYears.AfterLoadDFMValues;
    wdsYearsSelected.AfterLoadDFMValues;
    wdsYearsYear.AfterLoadDFMValues;
    dsYears.AfterLoadDFMValues;
    wcMonths.AfterLoadDFMValues;
    wdsMonths.AfterLoadDFMValues;
    wdsMonthsMonth.AfterLoadDFMValues;
    wdsMonthsMonthName.AfterLoadDFMValues;
    wdsMonthsSelected.AfterLoadDFMValues;
    dsMonths.AfterLoadDFMValues;
    wcReg.AfterLoadDFMValues;
    wdsReg.AfterLoadDFMValues;
    wdsRegReg.AfterLoadDFMValues;
    wdsRegFleetNo.AfterLoadDFMValues;
    wdsRegFleetType.AfterLoadDFMValues;
    wdsRegSelected.AfterLoadDFMValues;
    wdsRegPriKey.AfterLoadDFMValues;
    dsReg.AfterLoadDFMValues;
    WebTimer1.AfterLoadDFMValues;
    wdsTempReg.AfterLoadDFMValues;
    StringField1.AfterLoadDFMValues;
    StringField2.AfterLoadDFMValues;
    StringField3.AfterLoadDFMValues;
    BooleanField1.AfterLoadDFMValues;
    IntegerField1.AfterLoadDFMValues;
    dsSysTypes.AfterLoadDFMValues;
    wcSysTypes.AfterLoadDFMValues;
    wdsSysTypes.AfterLoadDFMValues;
    wdsSysTypesSelected.AfterLoadDFMValues;
    wdsSysTypesSysType.AfterLoadDFMValues;
    wdsSysTypesDescription.AfterLoadDFMValues;
    wdsCostGroups.AfterLoadDFMValues;
    wdsCostGroupsselected.AfterLoadDFMValues;
    wdsCostGroupsCost.AfterLoadDFMValues;
    wdsCostGroupsDescription.AfterLoadDFMValues;
    dsCostGroups.AfterLoadDFMValues;
    wcCostGroups.AfterLoadDFMValues;
    wdsDashData.AfterLoadDFMValues;
    wdsDashDataJobcardNo.AfterLoadDFMValues;
    wdsDashDataStockDescription.AfterLoadDFMValues;
    wdsDashDataTotalExcl.AfterLoadDFMValues;
    wdsDashDataGlCode.AfterLoadDFMValues;
    wdsDashDataReason.AfterLoadDFMValues;
    wdsDashDataCategory.AfterLoadDFMValues;
    wdsDashDataRepMain.AfterLoadDFMValues;
    wdsDashDataCostDescription.AfterLoadDFMValues;
    wdsDashDataTRegNo.AfterLoadDFMValues;
    wdsDashDataTFleetNo.AfterLoadDFMValues;
    wdsDashDataOrderNo.AfterLoadDFMValues;
    wdsDashDataJobDate.AfterLoadDFMValues;
    wdsDashDataReferenceNo.AfterLoadDFMValues;
    wdsDashDataVehType.AfterLoadDFMValues;
    wdsDashDataJobType.AfterLoadDFMValues;
    wdsDashDataSupplier.AfterLoadDFMValues;
    wcDashboardSums.AfterLoadDFMValues;
    dsDashBoardSums.AfterLoadDFMValues;
    wcDashData.AfterLoadDFMValues;
    dsDashData.AfterLoadDFMValues;
    wdsSuppliers.AfterLoadDFMValues;
    wdsSuppliersCrName.AfterLoadDFMValues;
    wdsSuppliersCrNumber.AfterLoadDFMValues;
    wdsSuppliersSelected.AfterLoadDFMValues;
    wcSuppliers.AfterLoadDFMValues;
    dsSuppliers.AfterLoadDFMValues;
    wdsVehGroups.AfterLoadDFMValues;
    wdsVehGroupsDescription.AfterLoadDFMValues;
    wdsVehGroupsSelected.AfterLoadDFMValues;
    wdsVehGroupsSysType.AfterLoadDFMValues;
    wcVehGroups.AfterLoadDFMValues;
    dsVehGroups.AfterLoadDFMValues;
    wcUnitType.AfterLoadDFMValues;
    dsUnitType.AfterLoadDFMValues;
    wdsUnitType.AfterLoadDFMValues;
    wdsUnitTypeSysType.AfterLoadDFMValues;
    wdsUnitTypeDescription.AfterLoadDFMValues;
    wdsUnitTypeSelected.AfterLoadDFMValues;
    dsMake.AfterLoadDFMValues;
    wdsMake.AfterLoadDFMValues;
    wdsMakeDescription.AfterLoadDFMValues;
    wdsMakeSelected.AfterLoadDFMValues;
    wcMake.AfterLoadDFMValues;
    dsMaintGroup.AfterLoadDFMValues;
    wdsMaintGroup.AfterLoadDFMValues;
    wdsMaintGroupSelected.AfterLoadDFMValues;
    wdsMaintGroupSysType.AfterLoadDFMValues;
    wdsMaintGroupDescription.AfterLoadDFMValues;
    wcMaintGroup.AfterLoadDFMValues;
    wdsFinYears.AfterLoadDFMValues;
    wdsFinYearsSelected.AfterLoadDFMValues;
    wdsFinYearsYear.AfterLoadDFMValues;
    wcFinYears.AfterLoadDFMValues;
    dsFinYears.AfterLoadDFMValues;
    dsServiceTypes.AfterLoadDFMValues;
    wdsServiceTypes.AfterLoadDFMValues;
    wdsServiceTypesSelected.AfterLoadDFMValues;
    wdsServiceTypesSystype.AfterLoadDFMValues;
    wdsServiceTypesDescription.AfterLoadDFMValues;
    wcServiceTypes.AfterLoadDFMValues;
    wdsDashboardSums.AfterLoadDFMValues;
    wdsDashboardSumsMaintenanceCost.AfterLoadDFMValues;
    wdsDashboardSumsTyreCost.AfterLoadDFMValues;
    wdsDashboardSumsWashCost.AfterLoadDFMValues;
    wdsDashboardSumsInsuranceCost.AfterLoadDFMValues;
    wdsDashboardSumsOtherCost.AfterLoadDFMValues;
    wdsDashboardSumsTotalCost.AfterLoadDFMValues;
    wdsDashboardSumsCapexCost.AfterLoadDFMValues;
    wdsDashboardSumsUnallCost.AfterLoadDFMValues;
    wdsDashboardSumsNotLinkedCost.AfterLoadDFMValues;
    wdsDashboardSumsMaintenanceCPK.AfterLoadDFMValues;
    wdsDashboardSumsTyreCPK.AfterLoadDFMValues;
    wdsDashboardSumsWashCPK.AfterLoadDFMValues;
    wdsDashboardSumsInsuranceCPK.AfterLoadDFMValues;
    wdsDashboardSumsOtherCPK.AfterLoadDFMValues;
    wdsDashboardSumsTotalCPK.AfterLoadDFMValues;
    wdsDashboardSumsCapexCPK.AfterLoadDFMValues;
    wdsDashboardSumsUnallCPK.AfterLoadDFMValues;
    wdsDashboardSumsNotLinkedCPK.AfterLoadDFMValues;
    wdsDashboardSumsTotalkilo.AfterLoadDFMValues;
  end;
end;

end.
